export const movieData = [
  {
    "id": 23,
    "title": "Amatöörid",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/23/0fab268a897391f3626ed8f094e04a4619e8f628.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Draama",
    "producer": "Riho Västrik",
    "director": "Marianne Kõrver",
    "peaosa": [
      {
        "actor": "Jass Seljamaa",
        "playing": "Roop"
      },
      {
        "actor": "Merli Berg",
        "playing": "Milla"
      },
      {
        "actor": "Taavi Eelmaa",
        "playing": "Jaak"
      }
    ]
  },
  {
    "id": 58,
    "title": "Kuritegu maksab kätte",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/58/b62f0cf967a73c1e1d7e6ae25d3e3a7b18001c13.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Marija Butjajeva",
    "director": "Jekaterina Hitruhhina",
    "peaosa": [
      {
        "actor": "Viktorija Sinjagina",
        "playing": "She"
      },
      {
        "actor": "Aleksandr Rachynskyi",
        "playing": "He"
      }
    ]
  },
  {
    "id": 64,
    "title": "Jumalik tragöödia",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/64/86832c2cc4c623116d1aa7261a30d8ad90ca8fc0.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Draama",
    "producer": "Alissa Kutšok",
    "director": "Sergey Kachan",
    "peaosa": [
      {
        "actor": "Jevgeni Dubei",
        "playing": "Noormees"
      }
    ]
  },
  {
    "id": 88,
    "title": "Fiktsioon",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/88/36d88d2586eaa3ad82ddb0c45ccd95647df9bb8d.PNG",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Lizete Murovska",
    "director": "Lizete Murovska",
    "peaosa": [
      {
        "actor": "Anna Markevica",
        "playing": "Tüdruk"
      },
      {
        "actor": "Mikus Vanags",
        "playing": "Kurat"
      }
    ]
  },
  {
    "id": 103,
    "title": "Helmut",
    "year": "2001",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/103/7b49807d8dfefceaa235d52d40e0b0e948b4c378.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Peeter Urbla",
    "director": "Anri Rulkov",
    "peaosa": [
      {
        "actor": "Helmut Malm",
        "playing": "Helmut"
      },
      {
        "actor": "Silvia Meister",
        "playing": "Silvi"
      },
      {
        "actor": "Veltan Otsman",
        "playing": "Velton"
      },
      {
        "actor": "Aarne Soro",
        "playing": "Autojuht"
      }
    ]
  },
  {
    "id": 156,
    "title": "Kingapuu",
    "year": "2003",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/156/27986a0426163ef8da60dc1aaf72ef6d7e891979.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Pille Rünk, Patrick Collerton",
    "director": "Ian Cottage",
    "peaosa": [
      {
        "actor": "Peeter Jakobi",
        "playing": "Vanaisa"
      },
      {
        "actor": "Jaanus Sildam",
        "playing": "Jaanus"
      },
      {
        "actor": "Toomas Hussar",
        "playing": "Isa"
      }
    ]
  },
  {
    "id": 159,
    "title": "Kiri Giuliale",
    "year": "1978",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/159/88642e4268355717c149e69d8046c255d948f6d2.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "",
    "director": "Raul Tammet",
    "peaosa": [
      {
        "actor": "Lembit Ulfsak",
        "playing": "Noormees"
      }
    ]
  },
  {
    "id": 167,
    "title": "Kodutee",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/167/5fc2182d2847b57bb302000a2d6548ea01c2a981.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Mona Mi Mikkin",
    "director": "Tõnis Pill",
    "peaosa": [
      {
        "actor": "Elle Kull",
        "playing": "Naine"
      },
      {
        "actor": "Kalev Martson",
        "playing": "Mees"
      },
      {
        "actor": "Marius  Peterson",
        "playing": "Majakavaht"
      }
    ]
  },
  {
    "id": 169,
    "title": "Koera surm",
    "year": "1998",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/169/64de1c85aff3bfbf3a88920e67da22186360f721.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Melodraama",
    "producer": "Ago Ruus",
    "director": "Urmas Eero Liiv",
    "peaosa": [
      {
        "actor": "Hannes Kaljujärv",
        "playing": "Mees"
      },
      {
        "actor": "Ülle Kaljuste",
        "playing": "Diana"
      }
    ]
  },
  {
    "id": 182,
    "title": "Krantsid",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/182/9d1fcfa55cfeca239a59d98b7af3f94c5729b1e8.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Marianne Ostrat",
    "director": "Sutharsan Bala",
    "peaosa": [
      {
        "actor": "Jekaterina Novosjolova",
        "playing": "Nazeeya"
      },
      {
        "actor": "Paulo Kulešov",
        "playing": "Emir"
      },
      {
        "actor": "Ago Soots",
        "playing": "Mihkel"
      },
      {
        "actor": "Jevgeni Gaitšuk",
        "playing": "Jassim"
      },
      {
        "actor": "Jürgen Gansen",
        "playing": "Tõnn"
      },
      {
        "actor": "Oskar Kala",
        "playing": "Jaan"
      },
      {
        "actor": "Vallo Kirs",
        "playing": "Paul"
      }
    ]
  },
  {
    "id": 197,
    "title": "Külla tuli",
    "year": "1997",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/197/073e39145516aba5faf914c66bd764a566bb4a3a.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Reet Sokmann, Jaak Kilmi",
    "director": "Jaak Kilmi",
    "peaosa": [
      {
        "actor": "René Reinumägi",
        "playing": "Leopold"
      },
      {
        "actor": "Pille Lukin",
        "playing": "Lee"
      },
      {
        "actor": "Robert Gutman",
        "playing": "Onu Kalju"
      },
      {
        "actor": "Liina Tennosaar",
        "playing": "Irma"
      }
    ]
  },
  {
    "id": 222,
    "title": "Löö vastu",
    "year": "1975",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/222/743aeb5e5e2637b74044156cf7d5f085e292518c.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "",
    "director": "Valentin  Kuik",
    "peaosa": [
      {
        "actor": "Jüri Aarma",
        "playing": "Avo Eller"
      },
      {
        "actor": "Mikk Mikiver",
        "playing": "Treener Kaaver"
      },
      {
        "actor": "Johannes Möldre",
        "playing": "Spordisaali valvur"
      },
      {
        "actor": "Ada Lundver",
        "playing": "Hotellikorruse administraator"
      },
      {
        "actor": "Martin Veinmann",
        "playing": "Poksija"
      },
      {
        "actor": "Paul Laasik",
        "playing": "Sõber"
      }
    ]
  },
  {
    "id": 227,
    "title": "Magada tahaks",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/227/4381c81cfd2e8af8141b66975a5209f2bb7c21a6.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kristi Rimm",
    "director": "Martti Helde",
    "peaosa": [
      {
        "actor": "Kaili Viidas",
        "playing": "Kerli"
      },
      {
        "actor": "Raiko Maal",
        "playing": "Laos"
      },
      {
        "actor": "Ülle Lichtfeldt",
        "playing": "Tädi Mare"
      },
      {
        "actor": "Riho Kütsar",
        "playing": "Onu Jüri"
      }
    ]
  },
  {
    "id": 228,
    "title": "Magusad unelmad",
    "year": "2001",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/228/ab25c8f5caf294f6e29086bb739fc90051ca623b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Melodraama",
    "producer": "Arbo Tammiksaar",
    "director": "Arbo Tammiksaar",
    "peaosa": [
      {
        "actor": "Urmas Eero Liiv",
        "playing": "Diktor"
      }
    ]
  },
  {
    "id": 239,
    "title": "Mehed jäävad koju",
    "year": "1956",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/239/eccd1cca24c75db8ef56e3f0ec0b76fd5bb4144d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "",
    "director": "Igor Jeltsov",
    "peaosa": [
      {
        "actor": "Ants Eskola",
        "playing": "Isa"
      },
      {
        "actor": "Linda Rummo",
        "playing": "Ema"
      },
      {
        "actor": "Arvo Tahk",
        "playing": "Arvo"
      }
    ]
  },
  {
    "id": 268,
    "title": "Mäed kui valged elevandid",
    "year": "1963",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/268/35faa9c498159098dcfeacb77d45e99147dd2ec7.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Suhtedraama",
    "producer": "",
    "director": "Leida  Laius",
    "peaosa": [
      {
        "actor": "Viiu Härm",
        "playing": "Naine"
      },
      {
        "actor": "Heino Mandri",
        "playing": "Mees"
      }
    ]
  },
  {
    "id": 297,
    "title": "Hilinemisega",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/297/b2c3b509427e64e159a7268ee5fb2a70f1787a7c.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (dokumentaalne)",
    "genre": "",
    "producer": "",
    "director": "Elena Kuznetsova",
    "peaosa": [
      {
        "actor": "Johan-Mattias Iho",
        "playing": "Mees 2"
      }
    ]
  },
  {
    "id": 314,
    "title": "Pieces of Me(at)",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/314/16b4b43fe20ef99e1b41722dd934e50bd893cedb.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Draama",
    "producer": "",
    "director": "Triin Ruumet",
    "peaosa": [
      {
        "actor": "Johannes Naan",
        "playing": "Noormees"
      },
      {
        "actor": "Helene Vetik",
        "playing": "Neiu"
      }
    ]
  },
  {
    "id": 315,
    "title": "Pihv",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/315/5fc4c48b702a97aa383c47c7f981085ad5e52ebb.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Piret Tibbo-Hudgins",
    "director": "Mihkel Ulk",
    "peaosa": [
      {
        "actor": "Mari Abel",
        "playing": "Karin"
      },
      {
        "actor": "Andres Mähar",
        "playing": "Riho"
      },
      {
        "actor": "Gert Raudsep",
        "playing": "Rein"
      },
      {
        "actor": "Ove Leišovnieks",
        "playing": "Mathias"
      },
      {
        "actor": "Tõnu Tanel",
        "playing": "Kalev"
      }
    ]
  },
  {
    "id": 336,
    "title": "Päev, mil ma kasvasin",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/336/91e70c101941bf5008b409787a063608134ff868.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Koguperefilm",
    "producer": "Riin Urbanik",
    "director": "Martti Helde",
    "peaosa": [
      {
        "actor": "Erik Toomet-Björck",
        "playing": "Priidik"
      },
      {
        "actor": "Rain Simmul",
        "playing": "Isa"
      },
      {
        "actor": "Aarne Üksküla",
        "playing": "Vanaisa"
      }
    ]
  },
  {
    "id": 347,
    "title": "Naasmine",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/347/576d1d1f2a95e6c6921baf68a6d48b06934608cb.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Draama",
    "producer": "",
    "director": "Eva Ligi",
    "peaosa": [
      {
        "actor": "Triin Ruumet",
        "playing": "Tüdruk"
      }
    ]
  },
  {
    "id": 348,
    "title": "Ringhoov",
    "year": "1987",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/348/1e0afc6c38ac3b59f09842ddd7978fb2ab13768d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "",
    "director": "Tõnu Virve",
    "peaosa": [
      {
        "actor": "Kaie Mihkelson",
        "playing": "Naine"
      },
      {
        "actor": "Evald Hermaküla",
        "playing": "Mees"
      }
    ]
  },
  {
    "id": 358,
    "title": "Roosa kübar",
    "year": "1963",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/358/6cb9886d2268eda3abff86308561badff9796996.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Sõjafilm",
    "producer": "",
    "director": "Veljo  Käsper",
    "peaosa": [
      {
        "actor": "Herta Elviste",
        "playing": "Naine"
      },
      {
        "actor": "Eneken Aksel",
        "playing": "Maria"
      }
    ]
  },
  {
    "id": 362,
    "title": "Röövpüüdjajaht",
    "year": "1975",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/362/5e8842d2b64211fe314d7b2e06693d8218319103.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Noortefilm",
    "producer": "",
    "director": "Marika Villa",
    "peaosa": [
      {
        "actor": "Boris Vald",
        "playing": "Juhan"
      },
      {
        "actor": "Marika Roopalu",
        "playing": "Liisa"
      },
      {
        "actor": "Arvo Kruusement",
        "playing": "Raamatupidaja"
      }
    ]
  },
  {
    "id": 374,
    "title": "Semm",
    "year": "1990",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/374/0e9d038165743e22b78505be9b5241e5be96c03d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "",
    "producer": "",
    "director": "Aare Tilk",
    "peaosa": [
      {
        "actor": "Imre Avaste",
        "playing": "Jaanus"
      },
      {
        "actor": "Heidi Klamp",
        "playing": "Eva"
      },
      {
        "actor": "Anu Lamp",
        "playing": "Ema"
      },
      {
        "actor": "Ants Ander",
        "playing": "Isa"
      },
      {
        "actor": "Zaza Tšavlešvili",
        "playing": "Sõdur"
      }
    ]
  },
  {
    "id": 383,
    "title": "Soolo",
    "year": "1979",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/383/ace6a6ebc0215a7307450382a99dbf9a91908a70.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Ulmefilm",
    "producer": "",
    "director": "Raul Tammet",
    "peaosa": [
      {
        "actor": "Viiu Kõrvits",
        "playing": "Minna"
      },
      {
        "actor": "Andrus Rüütlane",
        "playing": "Parvevaht"
      },
      {
        "actor": "Mikk Mikiver",
        "playing": "Aat"
      }
    ]
  },
  {
    "id": 415,
    "title": "Ta-ram, ta-ram",
    "year": "1995",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/415/10cc7207fc1a7cea5b77a8f8e1ba7b1344a5afa3.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Arvo Iho, Reet Sokmann",
    "director": "Jaak Kilmi",
    "peaosa": [
      {
        "actor": "Tarvo Sõmer",
        "playing": "Noormees"
      },
      {
        "actor": "Tarmo Männard",
        "playing": "Mees"
      }
    ]
  },
  {
    "id": 426,
    "title": "Küpsis",
    "year": "2007",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/426/2f2f8b42a9c9f3486884f10a8c6455526e8b71c7.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "",
    "director": "Elina Litvinova",
    "peaosa": [
      {
        "actor": "Thijs  Jaspaert",
        "playing": "Mees"
      },
      {
        "actor": "Helen Vinogradov",
        "playing": "Naine"
      },
      {
        "actor": "Eva Ligi",
        "playing": "Tänavaprostituut"
      },
      {
        "actor": "Oskar Lehemaa",
        "playing": "Klient"
      }
    ]
  },
  {
    "id": 429,
    "title": "Oponent",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/429/a4934309f4cece51b4a370797c373ed7607264c1.PNG",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Eira Virekoski",
    "director": "Sami Taavetti Hyvönen",
    "peaosa": [
      {
        "actor": "Sami Hyvönen",
        "playing": "Poiss"
      },
      {
        "actor": "Jouna Keränen",
        "playing": "Vastane"
      }
    ]
  },
  {
    "id": 433,
    "title": "Thibaut",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/433/56f183264b0a6bf2db326b59790cc39e59352c18.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kristi Rimm",
    "director": "Martti Helde",
    "peaosa": [
      {
        "actor": "Rain Simmul",
        "playing": "Thibaut"
      }
    ]
  },
  {
    "id": 435,
    "title": "Tingimustega Tallinnas",
    "year": "1996",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/435/f4144154e415b284dca8936f04a0d01ed817cc65.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Reet Sokmann, Graeme Dallas, Mati Sepping",
    "director": "Edith Sepp",
    "peaosa": [
      {
        "actor": "Emma Roche",
        "playing": "Alicia"
      },
      {
        "actor": "Martin Thom",
        "playing": "Gregg"
      },
      {
        "actor": "Toomas Saarepera",
        "playing": "Uku"
      }
    ]
  },
  {
    "id": 478,
    "title": "Hingelt ära",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/478/3d0530480d5b6d3beabb3f5ae2232d656bfbe7dc.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Tiiu-Ann Pello",
    "director": "Raimo Kaubi",
    "peaosa": [
      {
        "actor": "Sandra  Üksküla-Uusberg",
        "playing": "Kadri"
      },
      {
        "actor": "Meelis Rämmeld",
        "playing": "Toomas"
      },
      {
        "actor": "Janek Joost",
        "playing": "Jüri"
      },
      {
        "actor": "Maria Taimre-Varres",
        "playing": "Naine"
      }
    ]
  },
  {
    "id": 497,
    "title": "Viimane öö",
    "year": "2003",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/497/5d01c11040177172d0d1aec20dbb589ce802cdfb.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Põnevusfilm",
    "producer": "Manfred Vainokivi, Kristjan-Jaak Nuudi, Mart Arjukese, Marju Lepp",
    "director": "Mart Arjukese",
    "peaosa": [
      {
        "actor": "Lauri-Kare Laos",
        "playing": "Theodore"
      },
      {
        "actor": "Ivo Uukkivi",
        "playing": "Jean-Paul"
      },
      {
        "actor": "Evelin Pang",
        "playing": "Clair"
      },
      {
        "actor": "Raivo E. Tamm",
        "playing": "Autopoemees"
      },
      {
        "actor": "Raoul Joao",
        "playing": "Mustanahaline mees"
      },
      {
        "actor": "Arvo Kukumägi",
        "playing": "Sutenöör"
      }
    ]
  },
  {
    "id": 503,
    "title": "Võsakurat",
    "year": "1976",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/503/200679c27c8f52dd1977c8fbc5805badb6950ccc.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Sõjafilm",
    "producer": "",
    "director": "Peeter Simm",
    "peaosa": [
      {
        "actor": "Vaino Vahing",
        "playing": "Metsavaht"
      },
      {
        "actor": "Kubanbek Žussupov",
        "playing": "Sõdur"
      }
    ]
  },
  {
    "id": 512,
    "title": "Väike puust linn",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/512/d5c86d52cbe46b62f563a551d9f5c2f00b7bd9a3.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "NoortefilmŽanr: Draama",
    "producer": "Margus Karu, Kristjan Pütsep",
    "director": "Ragne Mandri",
    "peaosa": [
      {
        "actor": "Vallo Toomla",
        "playing": "Kristjan"
      },
      {
        "actor": "Loore Martma",
        "playing": "Kirke"
      },
      {
        "actor": "Marko Leht",
        "playing": "Lauri"
      },
      {
        "actor": "Lauri Kaldoja",
        "playing": "Kloun"
      },
      {
        "actor": "Andres Maimik",
        "playing": "Kontrolör"
      }
    ]
  },
  {
    "id": 517,
    "title": "Värav nr. 2",
    "year": "1955",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/517/109487aa9e30dd3615009b3b4544f13ae2f59380.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "",
    "director": "Oleg Lentsius",
    "peaosa": [
      {
        "actor": "Ruut Tarmo",
        "playing": "Jaan Koppel"
      },
      {
        "actor": "Endel Padrik",
        "playing": "Kalju"
      },
      {
        "actor": "Elle Timmer",
        "playing": "Salme"
      },
      {
        "actor": "Linda Sellistemägi-Moor",
        "playing": "Tädi Liisa"
      },
      {
        "actor": "Jüri Järvet",
        "playing": "Mees hanega"
      },
      {
        "actor": "Linda Tubin",
        "playing": "Kassiir"
      },
      {
        "actor": "Aleksander Mägi",
        "playing": "Vanamees"
      },
      {
        "actor": "Mari Möldre-Tarmo",
        "playing": "Vanaeit"
      }
    ]
  },
  {
    "id": 519,
    "title": "Õhtust hommikuni",
    "year": "1962",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/519/5606874bdcc1aaab43c14fbd5be920030e708497.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "PõnevusfilmŽanr: DraamaŽanr: Sõjafilm",
    "producer": "",
    "director": "Leida  Laius",
    "peaosa": [
      {
        "actor": "Viiu Härm",
        "playing": "Salme"
      },
      {
        "actor": "Kirill Lavrov",
        "playing": "Griša"
      },
      {
        "actor": "Ülle Ulla",
        "playing": "Karin"
      },
      {
        "actor": "Aksel Orav",
        "playing": "Rudolf"
      }
    ]
  },
  {
    "id": 526,
    "title": "Öine navigatsioon",
    "year": "1998",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/526/05beca058259aafdf17f5034cc62186019984a18.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "NoortefilmŽanr: Teekonnafilm",
    "producer": "Reet Sokmann, Erik Norkroos",
    "director": "Marko Raat",
    "peaosa": [
      {
        "actor": "Pille Vassar",
        "playing": "Paula"
      },
      {
        "actor": "Kaido Veermäe",
        "playing": "Mark"
      },
      {
        "actor": "Signe Lomp",
        "playing": "Kim"
      },
      {
        "actor": "Kristel Sarnet",
        "playing": "Milla"
      },
      {
        "actor": "Jan Uuspõld",
        "playing": "Joosep"
      },
      {
        "actor": "Taavi Teplenkov",
        "playing": "Teet"
      }
    ]
  },
  {
    "id": 527,
    "title": "Öö",
    "year": "2007",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/527/9b76dfd81abb08484d03b19c24db906a4f08b8a8.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Erik Norkroos",
    "director": "Jaanis Valk",
    "peaosa": [
      {
        "actor": "Liina-Riin Olmaru",
        "playing": "Veera"
      },
      {
        "actor": "Raimo  Pass",
        "playing": "Poliit Kaju"
      },
      {
        "actor": "Margus Prangel",
        "playing": "Paavo Korhonen"
      }
    ]
  },
  {
    "id": 532,
    "title": "Üks moment, oodake!",
    "year": "1956",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/532/c64324fe12bbe2b1d67693604e74cd0f811c9742.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "",
    "director": "Virve Reiman",
    "peaosa": [
      {
        "actor": "Endel Simmermann",
        "playing": "Ehitustrusti juhataja Kukk"
      },
      {
        "actor": "Ilmar Tammur",
        "playing": "Minister"
      }
    ]
  },
  {
    "id": 781,
    "title": "Tulnukas ehk Valdise pääsemine 11 osas",
    "year": "2006",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/781/75eef529f021bb9d6ccdd77dfc8eb96816a7fa4c.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Noortefilm",
    "producer": "Manfred Vainokivi, Marju Lepp",
    "director": "Rasmus Merivoo",
    "peaosa": [
      {
        "actor": "Märt Avandi",
        "playing": "Valdis"
      },
      {
        "actor": "Ott Sepp",
        "playing": "Märt"
      },
      {
        "actor": "Vallo Kirs",
        "playing": "Ott"
      },
      {
        "actor": "Uku Uusberg",
        "playing": "Rait"
      },
      {
        "actor": "Ago Anderson",
        "playing": "Päts"
      },
      {
        "actor": "Indrek Taalmaa",
        "playing": "Marko"
      },
      {
        "actor": "Indrek Ojari",
        "playing": "Jarmo"
      },
      {
        "actor": "Merle Jääger",
        "playing": "Eve"
      },
      {
        "actor": "Kristjan Sarv",
        "playing": "Purjus rullnokk"
      },
      {
        "actor": "Kaupo Kiilaspää",
        "playing": "Juss"
      },
      {
        "actor": "Kuldar Kivimäe",
        "playing": "Jussi sõber"
      },
      {
        "actor": "Priit Parro",
        "playing": "Kõige pisem karvane"
      },
      {
        "actor": "Tarmo Põiklik",
        "playing": "Prill"
      },
      {
        "actor": "Mart Ratassepp",
        "playing": "Mart"
      },
      {
        "actor": "Jüri Rebane",
        "playing": "Karvaste isa"
      },
      {
        "actor": "Ants Martin Vahur",
        "playing": "Kollanokk"
      },
      {
        "actor": "Meelis Veeremets",
        "playing": "Margus"
      }
    ]
  },
  {
    "id": 834,
    "title": "Näkilugu",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/834/7bb210d9e3ee7bd74b870cce0b8cd06b6a4022c3.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Muinasjuttfilm",
    "producer": "Esko Rips, Evar Anvelt",
    "director": "Heleri Saarik",
    "peaosa": [
      {
        "actor": "Kaisa Mallene",
        "playing": "Kaisa"
      },
      {
        "actor": "Anne Türnpu",
        "playing": "Ida"
      }
    ]
  },
  {
    "id": 836,
    "title": "Klaverihäälestaja tuleb kolmapäeval",
    "year": "1973",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/836/086bed00a48bd45bd68b153e25c8b1357b1d0ea5.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Melodraama",
    "producer": "",
    "director": "Valentin  Kuik",
    "peaosa": [
      {
        "actor": "Evald Aavik",
        "playing": "Klaverihäälestaja"
      },
      {
        "actor": "Eneken Priks",
        "playing": "Liilia Tamm"
      }
    ]
  },
  {
    "id": 849,
    "title": "Haaratus",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/849/f8c1a7c278a53dfdabb295df1e566d81e3d3914e.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "NoortefilmŽanr: Ulmefilm",
    "producer": "Maario Masing, Andrew Bond",
    "director": "Andrew Bond",
    "peaosa": [
      {
        "actor": "Riina Maidre",
        "playing": "Tüdruk"
      },
      {
        "actor": "Kristo Viiding",
        "playing": "Poiss"
      }
    ]
  },
  {
    "id": 918,
    "title": "Õnnelik lapsepõlv",
    "year": "1988",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/918/57c6d45ead7fd3e0a57e37e64868bf257406a05a.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Koguperefilm",
    "producer": "",
    "director": "Jaan Kolberg",
    "peaosa": [
      {
        "actor": "Raimo Nõu",
        "playing": "Ants"
      },
      {
        "actor": "Immanuel Volkonski",
        "playing": "Heiki"
      },
      {
        "actor": "Terje Pennie",
        "playing": "Ema"
      },
      {
        "actor": "Ada Lundver",
        "playing": "Direktor"
      },
      {
        "actor": "Ants Ander",
        "playing": "Onu Püss"
      },
      {
        "actor": "Margus Tabor",
        "playing": "Evald"
      }
    ]
  },
  {
    "id": 927,
    "title": "Külaline",
    "year": "1979",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/927/4d71859b6a2f2d1da4bf06a84ae74d0c9c89978b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Muinasjuttfilm",
    "producer": "",
    "director": "Elo Tust",
    "peaosa": [
      {
        "actor": "Juhan Viiding",
        "playing": "Surm"
      },
      {
        "actor": "Ilmar Tammur",
        "playing": "Kõrtsmik"
      },
      {
        "actor": "Ita Ever",
        "playing": "Võõrasema"
      },
      {
        "actor": "Jüri Järvet",
        "playing": "Metsavana"
      }
    ]
  },
  {
    "id": 930,
    "title": "Põrgu ekspress",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/930/6a4367897172269a34ee27bfac00dcbda4116a44.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Tiiu-Ann Pello",
    "director": "Kaur Kokk",
    "peaosa": [
      {
        "actor": "Ago Roo",
        "playing": "Anton Tamm"
      },
      {
        "actor": "Tõnu Mikiver",
        "playing": "Jüri"
      },
      {
        "actor": "Erlend Kollom",
        "playing": "Politseinik"
      },
      {
        "actor": "Ester Pajusoo",
        "playing": "Proua"
      },
      {
        "actor": "Kristjan Sarv",
        "playing": "Noor Anton"
      },
      {
        "actor": "Sten Karpov",
        "playing": "Noor Jüri"
      },
      {
        "actor": "Liis Laigna",
        "playing": "Noor naine"
      }
    ]
  },
  {
    "id": 936,
    "title": "Koguja",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/936/8a2449caada012412041cf5f6f3dad9a13daca9e.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "René Pihlak",
    "director": "Eva Kübar",
    "peaosa": [
      {
        "actor": "Tanel Saar",
        "playing": "Mees"
      },
      {
        "actor": "Liina Tennosaar",
        "playing": "Naine maamajas"
      },
      {
        "actor": "Inga Allik",
        "playing": "Mehe tüdruksõber"
      }
    ]
  },
  {
    "id": 938,
    "title": "She",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/938/cbe54ae14a4e8a0486cc8e7141b6e1a829c967db.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Erootikafim",
    "producer": "Simona Klavina",
    "director": "Gadi Lübek",
    "peaosa": [
      {
        "actor": "Paolo Girol",
        "playing": "S/he"
      },
      {
        "actor": "Elf (pseudonüüm)",
        "playing": "She"
      },
      {
        "actor": "Inga Soom",
        "playing": "Blonde"
      },
      {
        "actor": "Lenochka",
        "playing": "Girl"
      },
      {
        "actor": "Marika Pärn",
        "playing": "Girl"
      },
      {
        "actor": "Lulu (pseudonüüm)",
        "playing": "Girl"
      }
    ]
  },
  {
    "id": 939,
    "title": "Tulepistmine",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/939/12e3e8734e7e2d2686b6632f64d093d5902f8aa9.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kristjan Pütsep",
    "director": "Janno Jürgens",
    "peaosa": [
      {
        "actor": "Raimo  Pass",
        "playing": "Võõras"
      },
      {
        "actor": "Kalju Orro",
        "playing": "Konstaabel"
      },
      {
        "actor": "Raivo Adlas",
        "playing": "Peremees"
      },
      {
        "actor": "Toomas Kreen",
        "playing": "Veiko"
      }
    ]
  },
  {
    "id": 945,
    "title": "Valikud",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/945/1fb0746ea50562e0e386d1d3af78a60661ee35f6.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Simona Klavina, Agnese Laizane",
    "director": "Agnese Laizane",
    "peaosa": [
      {
        "actor": "Sergei Furmanjuk",
        "playing": "Alexander"
      },
      {
        "actor": "Eduard Toman",
        "playing": "Father"
      },
      {
        "actor": "Julia Nozhkina",
        "playing": "Daughter"
      },
      {
        "actor": "Oxana Agarkova",
        "playing": "Wife"
      },
      {
        "actor": "Jelena Kuznetsova",
        "playing": "Secretary"
      },
      {
        "actor": "Jekaterina Novosjolova",
        "playing": "Woman by door"
      },
      {
        "actor": "Sergei Tšerkassov",
        "playing": "Commissioner"
      },
      {
        "actor": "Allan Kress",
        "playing": "Commissioner"
      }
    ]
  },
  {
    "id": 946,
    "title": "Pimekohting",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/946/3470b97693cb32ef6f858723954d43b4a75d96d6.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Noortefilm",
    "producer": "Viktorija Soboleva, Maris Salumets",
    "director": "Zane Dirina",
    "peaosa": [
      {
        "actor": "Sigrid Saag",
        "playing": "Temake"
      },
      {
        "actor": "Marko Leht",
        "playing": "Tema"
      },
      {
        "actor": "Mikk Jürjens",
        "playing": "Kelner"
      }
    ]
  },
  {
    "id": 1630,
    "title": "2 pic",
    "year": "2005",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/1630/8082724b9567a29011092a88645ddffbaa2b61d4.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Noortefilm",
    "producer": "",
    "director": "Kristjan Sarv",
    "peaosa": [
      {
        "actor": "Kristjan Sarv",
        "playing": "Noormees"
      }
    ]
  },
  {
    "id": 1632,
    "title": "2.68",
    "year": "2004",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/1632/67d1f7de70d167904e0e7f291ef931f736c0627b.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "",
    "producer": "",
    "director": "Tanel Toom",
    "peaosa": [
      {
        "actor": "Mait Malmsten",
        "playing": "Leonard"
      },
      {
        "actor": "Tõnu Aru",
        "playing": "Kojamees"
      },
      {
        "actor": "Inga Proode",
        "playing": "Noor ema"
      }
    ]
  },
  {
    "id": 1676,
    "title": "AA ravi",
    "year": "1999",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/1676/929f971db743f6238b8f7dd89c297f23b4480feb.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "DraamaŽanr: Teekonnafilm",
    "producer": "",
    "director": "Raimo Jõerand",
    "peaosa": [
      {
        "actor": "Aldo Maksimov",
        "playing": "Raoul"
      },
      {
        "actor": "Avo Verner",
        "playing": "Autojuht"
      }
    ]
  },
  {
    "id": 1799,
    "title": "Algolis",
    "year": "2007",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/1799/ffc523737275747245937bf9ce844b7ffc031cb8.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Muusika/tantsu",
    "producer": "Kristjan Pütsep",
    "director": "Janno Jürgens",
    "peaosa": [
      {
        "actor": "Gert Preegel",
        "playing": "Musklites noormees"
      },
      {
        "actor": "Mall Järvela",
        "playing": "Noor naine"
      },
      {
        "actor": "Jegor Zadoya",
        "playing": "Teine noormees"
      }
    ]
  },
  {
    "id": 1820,
    "title": "Amontillado",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/1820/9a856553c5fbb80ae423a7fbde85bc3d14c05d3d.jpeg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Yuliya Sokolova",
    "director": "Kristo Viiding",
    "peaosa": [
      {
        "actor": "Arvo Kukumägi",
        "playing": "Asso"
      },
      {
        "actor": "Indrek Taalmaa",
        "playing": "Koit"
      }
    ]
  },
  {
    "id": 1827,
    "title": "Anna ja Krukoljev",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/1827/5ba8956a00214da0dbf437fd03cefceee770105c.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Maie Rosmann",
    "director": "Ingrid Roose",
    "peaosa": [
      {
        "actor": "Marika Korolev",
        "playing": "Anna"
      },
      {
        "actor": "Gert Raudsep",
        "playing": "Krukoljev"
      }
    ]
  },
  {
    "id": 1909,
    "title": "Sügise palett",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/1909/d6e4621d56bcf5413ad3829644e2a62dbb701a49.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Semjon Levin",
    "director": "Tatjana Borissova",
    "peaosa": [
      {
        "actor": "Anne-Reet Margiste",
        "playing": "Anne"
      },
      {
        "actor": "Marje Metsur",
        "playing": "Margarita"
      }
    ]
  },
  {
    "id": 1921,
    "title": "Ballada",
    "year": "2001",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/1921/abaede17ebd4de2524e35652c3ab496ce568a36f.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "",
    "producer": "Märt Sildvee, Erik Norkroos",
    "director": "Märt Sildvee",
    "peaosa": [
      {
        "actor": "Erik Ruus",
        "playing": "Põlluharija"
      }
    ]
  },
  {
    "id": 1922,
    "title": "Ballast",
    "year": "2007",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/1922/5769413832a565dd82f5265df6de4be0bb697af0.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Helena  Sikk",
    "director": "Yuliya Sokolova",
    "peaosa": [
      {
        "actor": "Evgenij Gajchuk",
        "playing": "Kapten"
      },
      {
        "actor": "Nadezhda Klishova",
        "playing": "Asya"
      }
    ]
  },
  {
    "id": 1951,
    "title": "Veri",
    "year": "2007",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/1951/5cb10989fa552469b643ad9f03cc2a0dc527479d.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "PõnevusfilmŽanr: Draama",
    "producer": "Taimi  Margus",
    "director": "Jüri Muttika",
    "peaosa": [
      {
        "actor": "Taaniel Uleksin",
        "playing": "Reamees Veri"
      }
    ]
  },
  {
    "id": 1954,
    "title": "Bluus ja hing",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/1954/b45944cefcde1604f3e9d5c5a2be3d67213999cb.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Kristo Jürmann",
    "director": "Jaan Penjam",
    "peaosa": [
      {
        "actor": "Raivo Trass",
        "playing": "Vanapagan"
      },
      {
        "actor": "Jene Walker",
        "playing": "Robert Johnson"
      }
    ]
  },
  {
    "id": 1965,
    "title": "Katkised suhted",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/1965/6fa31c661e4e76a98823f20fe0f606daaa891286.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Draama",
    "producer": "Taimi  Margus",
    "director": "Asko Kase",
    "peaosa": [
      {
        "actor": "Armo Sepandi",
        "playing": "mees"
      },
      {
        "actor": "Piret Sammel",
        "playing": "naine"
      }
    ]
  },
  {
    "id": 1985,
    "title": "Juhus",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/1985/f945a29c50cbf0ab50a22812135f1b0c991ec842.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Simona Klavina",
    "director": "Tatjana Borissova",
    "peaosa": [
      {
        "actor": "Eva Ligi",
        "playing": "Tüdruk"
      },
      {
        "actor": "Juan Pru Ruiz Loritte",
        "playing": "Noormees"
      }
    ]
  },
  {
    "id": 2012,
    "title": "Deus ex Machina",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/2012/73ab93467e03caff87ce3c353f9cfa605b4d5acf.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Ulmefilm",
    "producer": "Helen Tammemäe",
    "director": "Eik Tammemäe",
    "peaosa": [
      {
        "actor": "Mart Koldits",
        "playing": "Jumal"
      },
      {
        "actor": "Jaan-Siim Vikerpuu",
        "playing": "Vanapagan"
      },
      {
        "actor": "Jane Ilm",
        "playing": "Eeva"
      }
    ]
  },
  {
    "id": 2013,
    "title": "Deus ex Machina",
    "year": "2005",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/2013/078045b41441f94899f6ccf3aeffc7c5fe2d4dce.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Piret Tibbo-Hudgins",
    "director": "Moonika Siimets",
    "peaosa": [
      {
        "actor": "Lembit Ulfsak",
        "playing": "Wilhelm"
      },
      {
        "actor": "Indrek Taalmaa",
        "playing": "Männapuu"
      },
      {
        "actor": "Pille Pürg",
        "playing": "Annabella"
      }
    ]
  },
  {
    "id": 2026,
    "title": "Ära nuta mu pärast",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/2026/cd04a4db9637f6ae8da5ba65bb648fda0df16e2c.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "NoortefilmŽanr: Draama",
    "producer": "Maris Salumets",
    "director": "Thijs  Jaspaert",
    "peaosa": [
      {
        "actor": "Kristof Alas",
        "playing": "Eddy"
      },
      {
        "actor": "Mikk Visnap",
        "playing": "John"
      }
    ]
  },
  {
    "id": 2027,
    "title": "Ära raiska oma energiat",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/2027/9f4df56cf177734fcd27ee51e9b1febbc9b34ebc.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Üleloomulik film",
    "producer": "Tomas Miniotas",
    "director": "Ieva Norvele",
    "peaosa": [
      {
        "actor": "Jašek Milzöör",
        "playing": "Doktor R"
      },
      {
        "actor": "Liina-Liis Pihu",
        "playing": "Elektron"
      },
      {
        "actor": "Leo Nõmm",
        "playing": "Silmaarst"
      }
    ]
  },
  {
    "id": 2261,
    "title": "Ei oska filmi teha",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/2261/0badf765033be4ca40d03681511c437608aaec41.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Noortefilm",
    "producer": "Andero Tõnissoo",
    "director": "Hardi Keerutaja",
    "peaosa": [
      {
        "actor": "Pääru Oja",
        "playing": "Kristjan"
      },
      {
        "actor": "Mikk Jürjens",
        "playing": "Stsenarist"
      },
      {
        "actor": "Jarmo Murumaa",
        "playing": "Produtsent"
      },
      {
        "actor": "Jarmo Murumaa",
        "playing": "Sarvedega mees"
      }
    ]
  },
  {
    "id": 2373,
    "title": "Eriti just hommikuti",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/2373/153771b5067ad90d084c77993419695ac155eba2.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Madis Tüür",
    "director": "Heleri Saarik",
    "peaosa": [
      {
        "actor": "Laura Peterson",
        "playing": "Hanna"
      },
      {
        "actor": "Lauri Lagle",
        "playing": "Kaur"
      }
    ]
  },
  {
    "id": 2397,
    "title": "Eesti rulett",
    "year": "2006",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/2397/fab3e8e00ddeda7d23013792c819fa5960924039.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Kriminaalfilm",
    "producer": "Taimi  Margus",
    "director": "Asko Kase",
    "peaosa": [
      {
        "actor": "Armo Sepandi",
        "playing": "Anton"
      }
    ]
  },
  {
    "id": 2422,
    "title": "Süütõend",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/2422/34e0ca2ad6191f4dfb6f71f2711083aa33df8c17.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kristjan Suits",
    "director": "Krisjanis Leitis",
    "peaosa": [
      {
        "actor": "Karlis Matisons",
        "playing": "Vanem Girts"
      },
      {
        "actor": "Aigars Vilims",
        "playing": "Sergejs Gruščikovs"
      },
      {
        "actor": "Erik Metsoja",
        "playing": "Noor Girts"
      },
      {
        "actor": "Rasma Garinga-Garne",
        "playing": "Vanaema"
      }
    ]
  },
  {
    "id": 2477,
    "title": "Float",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/2477/9b5c736023744ecd020e07501ecfa77955367a57.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Agnese Laizane",
    "director": "Jiri Stejskal",
    "peaosa": [
      {
        "actor": "Jekaterina Novosjolova",
        "playing": "Nina"
      },
      {
        "actor": "Jevgeni Moissejenko",
        "playing": "Alex"
      }
    ]
  },
  {
    "id": 2500,
    "title": "Sagedased kohtumised",
    "year": "2007",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/2500/89c755af957f036b30050f9df526839357ac75c5.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "",
    "director": "Darja  Kornijenko",
    "peaosa": [
      {
        "actor": "Tatjana Kosmyinina",
        "playing": "Naine"
      },
      {
        "actor": "Maksim Saber",
        "playing": "Noor mees"
      }
    ]
  },
  {
    "id": 2543,
    "title": "Graatsiast",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/2543/646f6ba90f562bd6a8532db33b09047465c3a334.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Elari Lend",
    "director": "Margit Korbe",
    "peaosa": [
      {
        "actor": "Elina Pähklimägi",
        "playing": "Emma"
      },
      {
        "actor": "Natali Lohk",
        "playing": "Miina"
      },
      {
        "actor": "Ardo Ran Varres",
        "playing": "Theodor"
      },
      {
        "actor": "Liina Tennosaar",
        "playing": "Ema"
      }
    ]
  },
  {
    "id": 2650,
    "title": "Hirm",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/2650/de689b7923caa271fd001176e11d4cd51dbd583b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Maie Rosmann",
    "director": "Triin Ruumet",
    "peaosa": [
      {
        "actor": "Kalju-Karl Kivi",
        "playing": "Leevi"
      },
      {
        "actor": "Anne Margiste",
        "playing": "Elviira"
      },
      {
        "actor": "Peeter Rästas",
        "playing": "Uurija"
      },
      {
        "actor": "Riho Laufer",
        "playing": "Sergei"
      }
    ]
  },
  {
    "id": 2677,
    "title": "Huvitav Matemaatika",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/2677/cfe3edb31c2d1473670a3d6797b8fc60f58ce866.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Noortefilm",
    "producer": "Elari Lend",
    "director": "Hardi Keerutaja",
    "peaosa": [
      {
        "actor": "Lauri Kaldoja",
        "playing": "Õpetaja"
      },
      {
        "actor": "Meelis Põdersoo",
        "playing": "Naabrikutt"
      },
      {
        "actor": "Marta Pulk",
        "playing": "Carmen"
      },
      {
        "actor": "Liisa Pulk",
        "playing": "Maarjan"
      }
    ]
  },
  {
    "id": 2693,
    "title": "Hüvasti igaveseks, värdjad!",
    "year": "2003",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/2693/e302321fd1b88d71643d9d48e96e4643f56f3576.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Piret Tibbo-Hudgins",
    "director": "Liina Paakspuu, Kadriann Kibus",
    "peaosa": [
      {
        "actor": "Kadi Nõmmela",
        "playing": "Andra"
      },
      {
        "actor": "Iiris Toome",
        "playing": "Isabel"
      },
      {
        "actor": "Kristjan Paju",
        "playing": "Daimon"
      },
      {
        "actor": "Raul Liivoja",
        "playing": "Sergo"
      }
    ]
  },
  {
    "id": 2695,
    "title": "Mul oli sõber",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/2695/c1f573546566534a9a04c49d0649e1f6ee226842.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "",
    "director": "Hanna Samoson",
    "peaosa": [
      {
        "actor": "Andrus Edala",
        "playing": "Poiss"
      },
      {
        "actor": "Inna Samoson",
        "playing": "Ema"
      }
    ]
  },
  {
    "id": 2771,
    "title": "Inimestest",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/2771/c549743f9e0923dfb9ad3530d0e2b44b8e10ee3e.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kristjan Pütsep",
    "director": "Janno Jürgens",
    "peaosa": [
      {
        "actor": "Indrek Pangsepp",
        "playing": "Agu"
      },
      {
        "actor": "Taago Tubin",
        "playing": "Võõras"
      }
    ]
  },
  {
    "id": 2773,
    "title": "Inner sight of outside",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/2773/d174180720217ba6fbbebd3462544e5a9e82799b.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Draama",
    "producer": "Kadri Sammel",
    "director": "Ieva Norvele",
    "peaosa": [
      {
        "actor": "Daija Lidaka",
        "playing": "Modell"
      },
      {
        "actor": "Kristo Kukemelk",
        "playing": "Fotograaf"
      },
      {
        "actor": "Siim Jõgeva",
        "playing": "Fotograaf"
      }
    ]
  },
  {
    "id": 2866,
    "title": "Jope",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/2866/d546cb938c9d49cae60770a922b3061f8717a510.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Elari Lend",
    "director": "Jaan Penjam",
    "peaosa": [
      {
        "actor": "Pääru Oja",
        "playing": "Jaan Penjam"
      }
    ]
  },
  {
    "id": 2878,
    "title": "Juliet",
    "year": "1999",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/2878/b2a516cddce783f3b20dfae8c6944718a1390710.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Peeter Urbla",
    "director": "Anri Rulkov",
    "peaosa": [
      {
        "actor": "Kaia Skoblov",
        "playing": "Juliet"
      }
    ]
  },
  {
    "id": 2930,
    "title": "Järjekordne nädalavahetus",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/2930/5af9b0bd173b2bcdf889824537ae7c3ddc8ab496.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Noortefilm",
    "producer": "Gretlyn Palberg",
    "director": "Inga Eelmäe",
    "peaosa": [
      {
        "actor": "Marilyn Jurman",
        "playing": "Pepi"
      },
      {
        "actor": "Hannes Mets",
        "playing": "Karl"
      }
    ]
  },
  {
    "id": 2970,
    "title": "Kaerajaan",
    "year": "1999",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/2970/5a8cd69291492791e2f0640773069d4a59e95310.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Animafilm",
    "genre": "",
    "producer": "Mikk Rand",
    "director": "Mikk Rand",
    "peaosa": [
      {
        "actor": "Triin Sarapik",
        "playing": "Naine"
      },
      {
        "actor": "Ahto Meri",
        "playing": "Mees"
      }
    ]
  },
  {
    "id": 3018,
    "title": "Kalevipoeg",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/3018/6892bb4bbf6923af1f28655c9ca5f4f70c01b293.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Eepiline/ajalooline filmŽanr: Trikkfilm",
    "producer": "Piret Tibbo-Hudgins, Niko Mihailishin",
    "director": "Ekke Vasli",
    "peaosa": [
      {
        "actor": "Tiit Ojasoo",
        "playing": "Kalevipoeg"
      },
      {
        "actor": "Margus Prangel",
        "playing": "Vanem vend"
      },
      {
        "actor": "Peeter Rästas",
        "playing": "Keskmine vend"
      },
      {
        "actor": "Tiina Rebane",
        "playing": "Linda"
      },
      {
        "actor": "Maarja Merivoo-Parro",
        "playing": "Saarepiiga"
      }
    ]
  },
  {
    "id": 3113,
    "title": "Keegi teine",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/3113/a7b5aa74560af3f78ad8a1a8d4fc661b2481439b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Armastusfilm",
    "producer": "Helen Vinogradov",
    "director": "Helen Takkin",
    "peaosa": [
      {
        "actor": "Maria Reinup",
        "playing": "Anne"
      },
      {
        "actor": "Jarmo Lobjakas",
        "playing": "Karl"
      }
    ]
  },
  {
    "id": 3160,
    "title": "Kes siis teab",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/3160/1798b81587c721fe51cfe7778c0b687799134b9f.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Noortefilm",
    "producer": "Martina Tramberg",
    "director": "Hardi Keerutaja",
    "peaosa": [
      {
        "actor": "Liis Lass",
        "playing": "Laura"
      },
      {
        "actor": "Pääru Oja",
        "playing": "Poiss"
      },
      {
        "actor": "Mikk Jürjens",
        "playing": "Poiss"
      }
    ]
  },
  {
    "id": 3241,
    "title": "Kloun",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/3241/2524a80ac2b63db3e63ff5d1ab055302a033c4cb.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Trikkfilm",
    "producer": "Kristo Jürmann",
    "director": "Andre Kais",
    "peaosa": [
      {
        "actor": "Urmas Kollom",
        "playing": "Kloun"
      }
    ]
  },
  {
    "id": 3274,
    "title": "Kirjanik",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/3274/a5d1a8986e2010d149cd043fe44a6ab44435f520.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Põnevusfilm",
    "producer": "Maario Masing, Evelin Soosaar",
    "director": "Maario Masing",
    "peaosa": [
      {
        "actor": "Sergo Vares",
        "playing": "Paul"
      },
      {
        "actor": "Riina Maidre",
        "playing": "Linda"
      },
      {
        "actor": "Jaak Prints",
        "playing": "Jaak"
      }
    ]
  },
  {
    "id": 3293,
    "title": "Kollane Partmees",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/3293/81fd82c60a92e72864a9485159bcec342d197800.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Muusika/tantsu",
    "producer": "Edina Csüllög, Kristo Viiding, Yuliya Sokolova",
    "director": "Kristo Viiding",
    "peaosa": [
      {
        "actor": "Taavi Väinola",
        "playing": "Kollane Partmees"
      },
      {
        "actor": "Margaret Sarv",
        "playing": "Tüdruk"
      },
      {
        "actor": "Indrek Ojari",
        "playing": "Tsirkusemees"
      },
      {
        "actor": "Pavel Shnjagin",
        "playing": "Marionett"
      },
      {
        "actor": "Tõnu Tepandi",
        "playing": "Sinihabe"
      },
      {
        "actor": "Britta Vahur",
        "playing": "Lumivalgeke"
      }
    ]
  },
  {
    "id": 3347,
    "title": "Koolja",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/3347/e797bbb775ed1ee841e2747912027497bbec4d8a.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Tiiu-Ann Pello",
    "director": "Vallo Toomla",
    "peaosa": [
      {
        "actor": "Ants Ander",
        "playing": "Vanaisa Kolja"
      },
      {
        "actor": "Leho Holm",
        "playing": "Poiss"
      },
      {
        "actor": "Martin Kõiv",
        "playing": "Juhan"
      },
      {
        "actor": "Peeter Piiri",
        "playing": "Peeter"
      },
      {
        "actor": "Donald Tomberg",
        "playing": "Raivo"
      },
      {
        "actor": "Tiiu Uibo",
        "playing": "Adeele"
      },
      {
        "actor": "Kalev Kudu",
        "playing": "Kalev"
      },
      {
        "actor": "Kaia Skoblov",
        "playing": "Ema"
      }
    ]
  },
  {
    "id": 3361,
    "title": "Kord aastas",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/3361/f3ff30e285f2e65eb8fd4542f246172c32e71261.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Põnevusfilm",
    "producer": "Tiiu-Ann Pello",
    "director": "Raimo Kaubi",
    "peaosa": [
      {
        "actor": "Janek Joost",
        "playing": "Telekaparandaja"
      },
      {
        "actor": "Eva Püssa",
        "playing": "Naine"
      },
      {
        "actor": "Anti Kobin",
        "playing": "Mees"
      }
    ]
  },
  {
    "id": 3444,
    "title": "Kuni surm meid lahutab",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/3444/8d90d65131fa7724af32b47670156ec2825fd095.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Nikolai Mihailišin",
    "director": "Heleri Saarik",
    "peaosa": [
      {
        "actor": "Risto Kübar",
        "playing": "Mirko"
      },
      {
        "actor": "Lauri Lagle",
        "playing": "Marko"
      },
      {
        "actor": "Marika Vaarik",
        "playing": "Õde"
      },
      {
        "actor": "Maarja Miramii Vaher",
        "playing": "Lisette"
      }
    ]
  },
  {
    "id": 3468,
    "title": "Kuraditõestus",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/3468/a24994c65111927677898f30f99348bbbf954c14.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Draama",
    "producer": "Kristjan Pütsep",
    "director": "Janno Jürgens",
    "peaosa": [
      {
        "actor": "Tõnu Kark",
        "playing": "Jürka"
      },
      {
        "actor": "Rain Tolk",
        "playing": "Pastor"
      },
      {
        "actor": "Liina Tennosaar",
        "playing": "Lisette"
      },
      {
        "actor": "Kaie Mihkelson",
        "playing": "Juula"
      },
      {
        "actor": "Karol Kuntsel",
        "playing": "Kaval"
      }
    ]
  },
  {
    "id": 3513,
    "title": "Kõik omad poisid",
    "year": "1974",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/3513/5d98cdab6acf06676526e0ff801ef36a2d1ae8ff.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "",
    "producer": "",
    "director": "Peeter Simm",
    "peaosa": [
      {
        "actor": "Lembit Anton",
        "playing": "Külamees"
      },
      {
        "actor": "Peeter Tooma",
        "playing": "Pastor"
      },
      {
        "actor": "Lauri Nebel",
        "playing": "Heiki"
      },
      {
        "actor": "Urmas Kibuspuu",
        "playing": "Jaan"
      }
    ]
  },
  {
    "id": 3526,
    "title": "Kärbseudu",
    "year": "2007",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/3526/fa8ae2c36c149c1bd67bfbf1957824c140b1450e.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Janek Karakatš",
    "director": "Janek Karakatš",
    "peaosa": [
      {
        "actor": "Juhan Lindmaa",
        "playing": "Külavanem"
      },
      {
        "actor": "Igor Maasik",
        "playing": "Metsamees"
      },
      {
        "actor": "Hardi Kalder",
        "playing": "Poisike"
      },
      {
        "actor": "Raine Loo",
        "playing": "Vanaema"
      },
      {
        "actor": "Hindrek Eiskop",
        "playing": "Kosmonaut"
      },
      {
        "actor": "Aapo Ilves",
        "playing": "Külaveidrik"
      }
    ]
  },
  {
    "id": 3726,
    "title": "Libarebased ja kooljad",
    "year": "1998",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/3726/d80abe2d5d59e44cfa5ce984496d554176bc4398.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Üleloomulik film",
    "producer": "Reet Sokmann, Jaak Kilmi",
    "director": "Rainer Sarnet",
    "peaosa": [
      {
        "actor": "Taavi Eelmaa",
        "playing": "Sang"
      },
      {
        "actor": "Hilje Murel",
        "playing": "Li"
      },
      {
        "actor": "Kristel Sarnet",
        "playing": "Lian"
      }
    ]
  },
  {
    "id": 3738,
    "title": "Lihtsalt üks surm",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/3738/393357032cc9373c0e5a153d0819e7fa3eac5d41.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Trikkfilm",
    "producer": "Maie Rosmann",
    "director": "Jaan  Tätte jr",
    "peaosa": [
      {
        "actor": "Vallo Toomla",
        "playing": "Režissöör Juss"
      },
      {
        "actor": "Andres Ots",
        "playing": "Vanapagan"
      },
      {
        "actor": "Mait Joorits",
        "playing": "Peaingel Miikael"
      }
    ]
  },
  {
    "id": 3755,
    "title": "Nagu filmis",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/3755/76350ad7fe5968360b6b029d3f25a5742d64f94b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Jekaterina Minkova",
    "director": "Jekaterina Minkova",
    "peaosa": [
      {
        "actor": "Maria Ignatenko",
        "playing": "Maria"
      },
      {
        "actor": "Vladimir  Vassiljev",
        "playing": "Fotograaf"
      },
      {
        "actor": "Sergei Kamenski",
        "playing": "Valeri"
      }
    ]
  },
  {
    "id": 3974,
    "title": "Pühapäev Matildaga",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/3974/6461b20d4a1668ed3c8f0b8084a4a39fa8a2a415.tif",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "",
    "producer": "Ove Musting",
    "director": "Gadi Lübek",
    "peaosa": [
      {
        "actor": "Antti Reini",
        "playing": "Jan"
      },
      {
        "actor": "Veera Marjamaa",
        "playing": "Matilda"
      },
      {
        "actor": "Peeter Rästas",
        "playing": "Kalastaja"
      },
      {
        "actor": "Priit Pramann",
        "playing": "Kalastaja"
      }
    ]
  },
  {
    "id": 4013,
    "title": "Mehele parim",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/4013/f776534df6b181eb05c02b485238fb7e61c31f34.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Nikolai Mihailišin",
    "director": "Mart Raun",
    "peaosa": [
      {
        "actor": "Margus Grosnõi",
        "playing": "Margus"
      },
      {
        "actor": "Lee Trei",
        "playing": "Lee"
      },
      {
        "actor": "Hendrik Toompere jr jr",
        "playing": "Hendrik \"Heins\""
      },
      {
        "actor": "Mikk Jürjens",
        "playing": "Mikk"
      }
    ]
  },
  {
    "id": 4049,
    "title": "Meister",
    "year": "2005",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/4049/5af110f5fba1dbc9ce04d62428036743d1dfbcbf.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Peeter Urbla",
    "director": "Kaupo Kruusiauk",
    "peaosa": [
      {
        "actor": "Raivo Adlas",
        "playing": "Rein"
      },
      {
        "actor": "Kais Adlas",
        "playing": "Ormi"
      },
      {
        "actor": "Kalju Orro",
        "playing": "Ivo"
      },
      {
        "actor": "Hele Kõrve",
        "playing": "Sporditüdruk"
      }
    ]
  },
  {
    "id": 4144,
    "title": "Minu Laialdased Teadmised Liblikapüüdmisest",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/4144/97eff7fac22582b5ad60581035f3e015a6544e60.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Tiiu-Ann Pello",
    "director": "Kaur Kokk",
    "peaosa": [
      {
        "actor": "Paul Laasik",
        "playing": "Leszek"
      },
      {
        "actor": "Andres Ots",
        "playing": "Liblikapüüdja"
      }
    ]
  },
  {
    "id": 4160,
    "title": "Mis värvi on armastus?",
    "year": "2005",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/4160/f0e6a6afdd7edcd956e13a1f81d83f147469603e.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "",
    "director": "Rasmus Merivoo",
    "peaosa": [
      {
        "actor": "Uku Uusberg",
        "playing": "Georg"
      },
      {
        "actor": "Erik Kunila",
        "playing": "Lillemüüja"
      },
      {
        "actor": "Kristel Elling",
        "playing": "Marje"
      },
      {
        "actor": "Garmen Tabor",
        "playing": "Sirje"
      },
      {
        "actor": "Jim Ashilevi",
        "playing": "Peatoimetaja"
      }
    ]
  },
  {
    "id": 4261,
    "title": "Mälestuste maja",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/4261/0505eb84929db4a05f527436942c922ecf398f89.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kristjan Pütsep",
    "director": "Tanno Mee",
    "peaosa": [
      {
        "actor": "Carmen Mikiver",
        "playing": "Naine"
      },
      {
        "actor": "Taavi Eelmaa",
        "playing": "Mees"
      }
    ]
  },
  {
    "id": 4302,
    "title": "Nagu ikka",
    "year": "2005",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/4302/ae5d64f0924e35c28e93d29a348ef20e0409e5ab.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Draama",
    "producer": "Toomas Sääs",
    "director": "Ekke Vasli",
    "peaosa": [
      {
        "actor": "Lee Trei",
        "playing": "Bo"
      },
      {
        "actor": "Taavi Tõnisson",
        "playing": "Naan"
      },
      {
        "actor": "Allan Paiste",
        "playing": "Kaelkirjak-Tuuli"
      }
    ]
  },
  {
    "id": 4323,
    "title": "Napoleon",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/4323/fa382c00f599be527484ca09ef4e580845a28485.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Yuliya Sokolova",
    "director": "Edina Csüllög",
    "peaosa": [
      {
        "actor": "Dmitri Lomovski",
        "playing": "Sasha"
      },
      {
        "actor": "Riina Maidre",
        "playing": "Iris"
      },
      {
        "actor": "Hillar Ellam",
        "playing": "Irise isa"
      }
    ]
  },
  {
    "id": 4370,
    "title": "Ninanokkija apelsin",
    "year": "2005",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/4370/9ea2dd64381dd4b4fda659e917cf3df996741e8d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Animafilm",
    "genre": "Komöödiafilm",
    "producer": "Mikk Rand",
    "director": "Birgit Demidova",
    "peaosa": [
      {
        "actor": "Kristo Rohtla",
        "playing": "Ninanokkija"
      }
    ]
  },
  {
    "id": 4371,
    "title": "Ninja",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/4371/1b7fd3ccf0bdcbd7d3520632d5a3e8cfbf7b4212.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: NoortefilmŽanr: Armastusfilm",
    "producer": "Elari Lend",
    "director": "Jaan  Tätte jr",
    "peaosa": [
      {
        "actor": "Indrek Jõe",
        "playing": "Johannes"
      },
      {
        "actor": "Gerda-Katrina Samm",
        "playing": "Ivonne"
      }
    ]
  },
  {
    "id": 5222,
    "title": "Näitleja",
    "year": "2004",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/5222/846e71f12ecc2de59d0e744cd8e2e5e7aeca5840.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Armastusfilm",
    "producer": "",
    "director": "Maiju Ingman",
    "peaosa": [
      {
        "actor": "Üllar Saaremäe",
        "playing": "Vestluse juht"
      },
      {
        "actor": "Tiina Mälberg",
        "playing": "Vanem daam"
      },
      {
        "actor": "Margus Stalte",
        "playing": "Noor armunu"
      }
    ]
  },
  {
    "id": 5291,
    "title": "Teel koju",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/5291/c9d089e1e412530ae745758a7caa6417047c76cd.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Armastusfilm",
    "producer": "",
    "director": "Darja  Murlykina",
    "peaosa": [
      {
        "actor": "Tatiana Kosmynina",
        "playing": "Vera"
      },
      {
        "actor": "Dimitri Kosjakov",
        "playing": "Egor"
      },
      {
        "actor": "Jevgeni Gaitšuk",
        "playing": "Vera isa"
      }
    ]
  },
  {
    "id": 5341,
    "title": "Pagu",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/5341/39c101b48b3d5b87b3c583e980c320a22ff7fc16.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Martin Himbek",
    "director": "Martin Himbek",
    "peaosa": [
      {
        "actor": "Dora Laurimaa",
        "playing": "Tütar"
      },
      {
        "actor": "Silvia Soro",
        "playing": "Ema"
      }
    ]
  },
  {
    "id": 5345,
    "title": "Painaja",
    "year": "2004",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/5345/1c7093259480278d482e0b3c6bb9ae0cd61d561b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Põnevusfilm",
    "producer": "Marju Lepp, Manfred Vainokivi",
    "director": "Mart Arjukese",
    "peaosa": [
      {
        "actor": "Taavi Teplenkov",
        "playing": "Toomas Sersern (maakler)"
      },
      {
        "actor": "Tiit Sukk",
        "playing": "Psühhiaater Joel"
      }
    ]
  },
  {
    "id": 5392,
    "title": "Pealpool pilvi",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/5392/cc699ba480ebb06fd19cd66565233ea6ae809a3f.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Priit Pääsuke",
    "director": "Age Viks",
    "peaosa": [
      {
        "actor": "Ireen Kennik",
        "playing": "Mann"
      },
      {
        "actor": "Ivo Uukkivi",
        "playing": "Hugo"
      },
      {
        "actor": "Janek Joost",
        "playing": "Kusti"
      },
      {
        "actor": "Randel Uibo",
        "playing": "Poiss"
      }
    ]
  },
  {
    "id": 5463,
    "title": "Perekondlik sündmus",
    "year": "1997",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/5463/6b3e376c856568f4f115fb4077172de095726df2.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Mati Sepping, Vilja Palm",
    "director": "René Vilbre",
    "peaosa": [
      {
        "actor": "Evald Aavik",
        "playing": "Vanaisa Benno"
      },
      {
        "actor": "Jaan Rekkor",
        "playing": "Kanter Telefojanski"
      },
      {
        "actor": "Anne Paluver",
        "playing": "Medõest tädi"
      },
      {
        "actor": "Tarmo Männard",
        "playing": "Isa"
      },
      {
        "actor": "Mattias Ben Peedruk",
        "playing": "Imik"
      },
      {
        "actor": "Anne Velt",
        "playing": "Ema"
      }
    ]
  },
  {
    "id": 5492,
    "title": "Pihtimus",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/5492/23835cd754b32d6c3a320bd9da4ae85264d417c9.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Tehtud välisülikoolis",
    "genre": "Draama",
    "producer": "Emily Williams",
    "director": "Tanel Toom",
    "peaosa": [
      {
        "actor": "Lewis Howlett",
        "playing": "Sam"
      },
      {
        "actor": "Joe Eales",
        "playing": "Jacob"
      },
      {
        "actor": "James Simmons",
        "playing": "Preester"
      },
      {
        "actor": "Gemma Atkins",
        "playing": "Õpetaja"
      }
    ]
  },
  {
    "id": 5530,
    "title": "Pime Dsin-Lu",
    "year": "2007",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/5530/0e7799bd9199411d92ed45d8ca911382254a71b1.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kristjan Pütsep",
    "director": "Tanno Mee",
    "peaosa": [
      {
        "actor": "Birgit Demidova",
        "playing": "Tütar/Dsin-Lu"
      },
      {
        "actor": "Mart Kampus",
        "playing": "Isa/Fu-Tai-Tsang"
      },
      {
        "actor": "Heino Seljamaa",
        "playing": "Li-Kai"
      },
      {
        "actor": "Pärtel-Peeter Pere",
        "playing": "Vu-Hou"
      }
    ]
  },
  {
    "id": 5560,
    "title": "Pole Hullu",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/5560/de398f717c1f502bc9e8f010285a0194267eff00.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Maie Rosmann",
    "director": "Eik Tammemäe",
    "peaosa": [
      {
        "actor": "Veikko Täär",
        "playing": "Pole Hull"
      },
      {
        "actor": "Jekaterina Novosjolova",
        "playing": "Hooldaja"
      }
    ]
  },
  {
    "id": 5608,
    "title": "Protsess",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/5608/323d9b384d8e10bb9cc91dc10c1adc62ae315fd2.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Üleloomulik film",
    "producer": "Tiiu-Ann Pello",
    "director": "Vallo Toomla",
    "peaosa": [
      {
        "actor": "Mart Aas",
        "playing": "Josef K"
      }
    ]
  },
  {
    "id": 5611,
    "title": "Puhata ja mängida",
    "year": "2007",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/5611/764583dfc5c831f6abbab8fcf6e496285c378762.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Noortefilm",
    "producer": "Nikolai Mihailišin",
    "director": "Heleri Saarik",
    "peaosa": [
      {
        "actor": "Ingrid Isotamm",
        "playing": "Tütarlaps"
      },
      {
        "actor": "Kristo Viiding",
        "playing": "Poiss"
      },
      {
        "actor": "Ago Soots",
        "playing": "II poiss"
      }
    ]
  },
  {
    "id": 5670,
    "title": "Põrgupõhjas",
    "year": "2006",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/5670/90c5115ffc5a2f1e6001f0f508787283af80fa0a.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "",
    "director": "Age Viks",
    "peaosa": [
      {
        "actor": "Peeter Kaljumäe",
        "playing": "Jürka"
      },
      {
        "actor": "Lauri Nebel",
        "playing": "Pastor"
      }
    ]
  },
  {
    "id": 5916,
    "title": "Rohelise seljakotiga mees",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/5916/1314410dfaad912100f571faa56d17e0be3608ab.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Martina Tramberg",
    "director": "Raigo Saariste",
    "peaosa": [
      {
        "actor": "Vallo Toomla",
        "playing": "Rohelise Seljakotiga Mees"
      },
      {
        "actor": "Mairi Jõgi",
        "playing": "Neiu"
      },
      {
        "actor": "Ardo Ran Varres",
        "playing": "Korravalvur"
      }
    ]
  },
  {
    "id": 5937,
    "title": "Juur",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/5937/9cfb29dc98414c1004458a71c4fe6f567c9d7686.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Ulmefilm",
    "producer": "Sten-Erik Toos",
    "director": "Helen Takkin",
    "peaosa": [
      {
        "actor": "Rebecca Bunting",
        "playing": "The Woman"
      }
    ]
  },
  {
    "id": 5965,
    "title": "Rändaja",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/5965/58128ca94239bb6ae9367d8bedca189c2d1cb12b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "PõnevusfilmŽanr: Üleloomulik film",
    "producer": "Berit Piho, Helen Vinogradov, Maria Kivirand",
    "director": "Robi Uppin",
    "peaosa": [
      {
        "actor": "Carita Vaikjärv",
        "playing": "Sandra"
      },
      {
        "actor": "Lauri Nebel",
        "playing": "Albert"
      }
    ]
  },
  {
    "id": 6009,
    "title": "Saatana Vodevill",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/6009/0694e429899b3f4bd58a42c8fc4919810e8c6903.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Elari Lend",
    "director": "Vallo Toomla",
    "peaosa": [
      {
        "actor": "Roman Baskin",
        "playing": "Pastor"
      },
      {
        "actor": "Guido Kangur",
        "playing": "Võõras"
      }
    ]
  },
  {
    "id": 6019,
    "title": "Sagedused",
    "year": "2005",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/6019/55a705d273822684525efeb16ae9d160fa4791d1.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Manfred Vainokivi",
    "director": "Priit Pääsuke",
    "peaosa": [
      {
        "actor": "Rasmus Kaljujärv",
        "playing": "Oliver"
      },
      {
        "actor": "Aarne Üksküla",
        "playing": "Vanamees"
      },
      {
        "actor": "Riina Maidre",
        "playing": "Liina"
      }
    ]
  },
  {
    "id": 6045,
    "title": "Sammul läbi iseenda",
    "year": "2007",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/6045/311af7e518b52559d4cec96fb8e500f1d99d8728.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Ermo Säks",
    "director": "Martin Himbek",
    "peaosa": [
      {
        "actor": "Sten Karpov",
        "playing": "Iian"
      },
      {
        "actor": "Eva-Karoli Remmel",
        "playing": "Mia"
      }
    ]
  },
  {
    "id": 6051,
    "title": "Sattusid hoogu, Hugo",
    "year": "2005",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/6051/25a5fc9b74cba046d5f5396aafae65ca75ee414c.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Teekonnafilm",
    "producer": "Madis Mihkelsoo",
    "director": "Kristin Kalamees",
    "peaosa": [
      {
        "actor": "Mihkel Tamm",
        "playing": "Vend 1"
      },
      {
        "actor": "Martin Tamm",
        "playing": "Vend 2"
      },
      {
        "actor": "Arvo Kukumägi",
        "playing": "Isa"
      }
    ]
  },
  {
    "id": 6096,
    "title": "Laskur",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/6096/99359aba4d6d6f00d769b7fbdff08fa30a833e70.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Yuliya Sokolova",
    "director": "Helena  Sikk",
    "peaosa": [
      {
        "actor": "Kristiine Truu",
        "playing": "Woman"
      },
      {
        "actor": "Erik Rüütel",
        "playing": "Man"
      }
    ]
  },
  {
    "id": 6097,
    "title": "Näita mulle häält",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/6097/06e65e15a7d64b710cf907223d94292f8ee1edd8.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Petra Apers",
    "director": "Agnese Laizane",
    "peaosa": [
      {
        "actor": "Ilze Pukinska",
        "playing": "Dagne"
      },
      {
        "actor": "Kristīne  Šomase",
        "playing": "Kate"
      },
      {
        "actor": "Tālivaldis  Lasmanis",
        "playing": "Artūrs"
      }
    ]
  },
  {
    "id": 6118,
    "title": "Silla alla",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/6118/5d66526a982aaa17e9ab9558c4a5a4f9e09a6849.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Ermo Säks",
    "director": "Lasse Uustalu",
    "peaosa": [
      {
        "actor": "Ardo Ran Varres",
        "playing": "Peeter"
      },
      {
        "actor": "Katariina Lauk",
        "playing": "Aili"
      },
      {
        "actor": "Anne Reemann",
        "playing": "Mara"
      }
    ]
  },
  {
    "id": 6131,
    "title": "Sinine on sügavlilla",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/6131/da7c86ab08bcdd70775a33358bd2ff4396e24fef.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Elari Lend",
    "director": "Triin Ruumet",
    "peaosa": [
      {
        "actor": "Bert Raudsep",
        "playing": "Klaus"
      },
      {
        "actor": "Tiina Tauraite",
        "playing": "Asja"
      }
    ]
  },
  {
    "id": 6228,
    "title": "Suhtumise küsimus",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/6228/b9fcea800f6f80db1b36908bdb8afb24f1092e30.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Ermo Säks",
    "director": "Ergo Kuld",
    "peaosa": [
      {
        "actor": "Priit  Matiisen",
        "playing": "Tõnis"
      },
      {
        "actor": "Eva Vellesaar",
        "playing": "Tõnise naine"
      },
      {
        "actor": "Margus Kruusvall",
        "playing": "Sõber Mart"
      }
    ]
  },
  {
    "id": 6260,
    "title": "Suurde avarusse",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/6260/30dd4e5d460a7d6bca120a7c4203b8e03393c16a.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Teekonnafilm",
    "producer": "Maie Rosmann",
    "director": "Kaur Kokk",
    "peaosa": [
      {
        "actor": "Indrek Taalmaa",
        "playing": "Elmo"
      }
    ]
  },
  {
    "id": 6345,
    "title": "Südameasjad",
    "year": "2007",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/6345/bc97d5fd6e63a6f0f258740e31ba5bc4c37eaf1c.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Üleloomulik film",
    "producer": "Kätlin Jensen",
    "director": "Mihkel Ulk",
    "peaosa": [
      {
        "actor": "Eva Klemets",
        "playing": "Naine"
      },
      {
        "actor": "Tambet Tuisk",
        "playing": "Mees"
      },
      {
        "actor": "Gert Raudsep",
        "playing": "Korrespondent"
      }
    ]
  },
  {
    "id": 6376,
    "title": "Zombie-Võlur",
    "year": "2006",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/6376/4c2b429e49f4d0ae373e08aff691fc50d396362d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Noortefilm",
    "producer": "Helen Tootsi",
    "director": "Birgit Demidova",
    "peaosa": [
      {
        "actor": "Bert Pringi",
        "playing": "Võlur Volmer"
      },
      {
        "actor": "Beatrice Fenice",
        "playing": "Võluv Marianna"
      }
    ]
  },
  {
    "id": 6667,
    "title": "The Bastards",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/6667/c4d197ac96d24465bed903ed181712d436490ee1.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Triinu Uring",
    "director": "Andres Kõpper",
    "peaosa": [
      {
        "actor": "Arun Tamm",
        "playing": "The Main Bastard"
      },
      {
        "actor": "Arun Tamm",
        "playing": "The Lucky Bastard"
      },
      {
        "actor": "Arun Tamm",
        "playing": "The Ugly Bastard"
      },
      {
        "actor": "Arun Tamm",
        "playing": "The Crazy Bastard"
      }
    ]
  },
  {
    "id": 6668,
    "title": "Argpüks",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/6668/dadab2e347d1e64cc451d533ff49ea30b4d5045d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Guntars Gulbis",
    "director": "Harijs Arájs",
    "peaosa": [
      {
        "actor": "Priit Pobbul",
        "playing": "Argpüks"
      }
    ]
  },
  {
    "id": 6675,
    "title": "Maskid",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/6675/e02306ca8f99abee3dfe2cb567714e7e431d904d.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "",
    "director": "Indra Kerste",
    "peaosa": [
      {
        "actor": "Kristaps Liepinlauskis",
        "playing": "Man"
      }
    ]
  },
  {
    "id": 6676,
    "title": "Hommik pärast eilset",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/6676/9853bb6ec712fd0a0c410075e4f354ef24454c70.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Noortefilm",
    "producer": "Peteris Rozitis",
    "director": "Kristo Viiding",
    "peaosa": [
      {
        "actor": "Maris Takk",
        "playing": "Catherine"
      },
      {
        "actor": "Vallo Toomla",
        "playing": "Vincent"
      },
      {
        "actor": "Karl Eelmaa",
        "playing": "Magician"
      },
      {
        "actor": "Madis Enson",
        "playing": "Theo"
      }
    ]
  },
  {
    "id": 6680,
    "title": "Peegeldus",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/6680/36e297905dd86a81379bafb9504ce1683a070719.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "",
    "director": "Annamari Kenk, Tiina  Haak",
    "peaosa": [
      {
        "actor": "Ott Kartau",
        "playing": "Simmo"
      }
    ]
  },
  {
    "id": 6685,
    "title": "Heli Mäeorg",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/6685/8382a6d9a841e7f524011cffbbbb868b47db9210.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Martina Tramberg, Jaan Laugamõts",
    "director": "Martin Ruus",
    "peaosa": [
      {
        "actor": "Rednar Annus",
        "playing": "Margus"
      },
      {
        "actor": "Ülle Kaljuste",
        "playing": "Ema"
      },
      {
        "actor": "Raivo Rüütel",
        "playing": "Isa"
      },
      {
        "actor": "Elina Pähklimägi",
        "playing": "Noor naine"
      },
      {
        "actor": "Martin Mill",
        "playing": "Noormees"
      },
      {
        "actor": "Robert Annus",
        "playing": "Noormees"
      }
    ]
  },
  {
    "id": 6686,
    "title": "Kolm Kartulit",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/6686/d3943f9ef8ddb7b8f3f98159f7be6a49ef04d9c9.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Peteris Rozitis",
    "director": "Giampietro Balia",
    "peaosa": [
      {
        "actor": "Christopher Merila",
        "playing": "Poiss"
      },
      {
        "actor": "Raivo Adlas",
        "playing": "Isa"
      },
      {
        "actor": "Kais Adlas",
        "playing": "Lesk"
      },
      {
        "actor": "Martin Mill",
        "playing": "Vend"
      },
      {
        "actor": "Elve Üksik",
        "playing": "Õde"
      }
    ]
  },
  {
    "id": 6727,
    "title": "Tort",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/6727/5bbe6245412375585264f62e187fe6a4737a432e.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Yuliya Sokolova",
    "director": "Tõnn Sikk",
    "peaosa": [
      {
        "actor": "Martin Liira",
        "playing": "Poiss"
      },
      {
        "actor": "Hella Jansons",
        "playing": "Tüdruk"
      },
      {
        "actor": "Eero Spriit",
        "playing": "Poemüüja"
      }
    ]
  },
  {
    "id": 6756,
    "title": "Ausad värvid",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/6756/61b2d15382062306cd3abab996016124c155f2c1.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Esko Rips",
    "director": "Margus Paju",
    "peaosa": [
      {
        "actor": "Jan Uuspõld",
        "playing": "Joosep"
      },
      {
        "actor": "Margus Grosnõi",
        "playing": "Gabriel"
      },
      {
        "actor": "Maarja Mitt",
        "playing": "Marianne"
      }
    ]
  },
  {
    "id": 6827,
    "title": "Tunnel",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/6827/52858c729c9c838e59381e56db156c834fc7d7f0.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Ulmefilm",
    "producer": "Ermo Säks",
    "director": "Margit Korbe",
    "peaosa": [
      {
        "actor": "Hilje Murel",
        "playing": "Tüdruk"
      },
      {
        "actor": "Vallo Toomla",
        "playing": "Poiss"
      }
    ]
  },
  {
    "id": 6841,
    "title": "Tuul",
    "year": "2005",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/6841/f664f0478df2d5759326e4a36cc23b39f50914e8.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Põnevusfilm",
    "producer": "",
    "director": "Tanel Toom",
    "peaosa": [
      {
        "actor": "Aleksander Eelmaa",
        "playing": "Harry"
      },
      {
        "actor": "Rein Oja",
        "playing": "Fred"
      }
    ]
  },
  {
    "id": 7054,
    "title": "Vana Saab",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/7054/3ab77e06e2af762ca959d21ca8847e01759f1b4b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Andero Tõnissoo",
    "director": "Andre Kais",
    "peaosa": [
      {
        "actor": "Janek Vadi",
        "playing": "Mart"
      }
    ]
  },
  {
    "id": 7127,
    "title": "Vene suurus",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/7127/34bb164a082c7726423a6114829982d6a1610566.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Maie Rosmann",
    "director": "Andrew Bond",
    "peaosa": [
      {
        "actor": "Andres Ots",
        "playing": "Peremees"
      },
      {
        "actor": "Carmen Mikiver",
        "playing": "Perenaine"
      },
      {
        "actor": "Oleg Štšigorets",
        "playing": "Peeter Suur"
      }
    ]
  },
  {
    "id": 7150,
    "title": "When Curtains Fall",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/7150/00e0cda438c13ce150d30b8ff69115c5ee4d0da8.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Põnevusfilm",
    "producer": "Roberts Ekis",
    "director": "Pauls Kesteris",
    "peaosa": [
      {
        "actor": "Arturs Dicis",
        "playing": "Toms"
      },
      {
        "actor": "Kristaps Rasims",
        "playing": "Martins"
      }
    ]
  },
  {
    "id": 7151,
    "title": "Talve tulles",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/7151/5f292655db6169a720b1209e8b454ec497c0de8d.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Simona Klavina",
    "director": "Gadi Lübek",
    "peaosa": [
      {
        "actor": "Raivo Trass",
        "playing": "Vana Martin"
      },
      {
        "actor": "Kristjan Üksküla",
        "playing": "Noor Martin"
      },
      {
        "actor": "Markus Ebruk",
        "playing": "Väike Martin"
      },
      {
        "actor": "Jane Kruus",
        "playing": "Noor Ellen"
      },
      {
        "actor": "Elise Metsanurk",
        "playing": "Väike Ellen"
      },
      {
        "actor": "Elina Pähklimägi",
        "playing": "Anna"
      }
    ]
  },
  {
    "id": 7152,
    "title": "Öösiti läbi elu",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/7152/5a12f3b7d183d616d69a8a859b7da312e5edb262.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Jouna Keränen",
    "director": "Jouna Keränen",
    "peaosa": [
      {
        "actor": "Heino Seljamaa",
        "playing": "Mees"
      }
    ]
  },
  {
    "id": 7168,
    "title": "Viimane vale",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/7168/881ce8e39a9f9aee613765e49d05e30b986c0795.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Maie Rosmann",
    "director": "Triin Ruumet",
    "peaosa": [
      {
        "actor": "Pire Sova",
        "playing": "Laila"
      },
      {
        "actor": "Märt Pius",
        "playing": "Märt"
      },
      {
        "actor": "Priit Pius",
        "playing": "Priit"
      },
      {
        "actor": "Maria Aua",
        "playing": "Maria"
      }
    ]
  },
  {
    "id": 7259,
    "title": "Võlur on armunud",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/7259/a0d2e01c9f20d120cff0e1fc6435403bf985408f.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Noortefilm",
    "producer": "Andero Tõnissoo",
    "director": "Jaan  Tätte jr",
    "peaosa": [
      {
        "actor": "Roland Laos",
        "playing": "Võlur"
      },
      {
        "actor": "Liis Proode",
        "playing": "Neiu"
      },
      {
        "actor": "Maario Masing",
        "playing": "Ohvitser"
      }
    ]
  },
  {
    "id": 7284,
    "title": "Võti õunasüdames",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/7284/68e81d22be803413ce903aa57d23834f5e5dc189.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Aet Laigu, Birgit Rosenberg",
    "director": "Martin Himbek",
    "peaosa": [
      {
        "actor": "Markus Luik",
        "playing": "Noormees"
      }
    ]
  },
  {
    "id": 7325,
    "title": "Väljasõit",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/7325/3bc6176e1ce8a2b00d3d6adc6b186e4108382a57.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Eero Talvistu",
    "director": "Johannes Arro",
    "peaosa": [
      {
        "actor": "Ivo Uukkivi",
        "playing": "Kristjan"
      },
      {
        "actor": "Maria Peterson",
        "playing": "Helen"
      },
      {
        "actor": "Rein Oja",
        "playing": "Markus"
      }
    ]
  },
  {
    "id": 7353,
    "title": "Õndsus",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/7353/5cf80e53191ac9b7c4f57e8870f080ec2b41422a.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Elari Lend",
    "director": "Inga Eelmäe",
    "peaosa": [
      {
        "actor": "Katre Kaseleht",
        "playing": "Marju"
      },
      {
        "actor": "Andres Mähar",
        "playing": "Kristjan"
      }
    ]
  },
  {
    "id": 7431,
    "title": "Ülevaade psühhoanalüütilisest teraapiast",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/7431/a71e682fb9c0352eafbc4f38cad7ce719d3f311a.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Maie Rosmann",
    "director": "Triin Ruumet",
    "peaosa": [
      {
        "actor": "Juhan Ulfsak",
        "playing": "Voldemar"
      },
      {
        "actor": "Volli Käro",
        "playing": "Arst"
      }
    ]
  },
  {
    "id": 11439,
    "title": "Suletud aknad",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11445/4e983b8c990d36b73b22c1dea40cf998fa697c33.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "",
    "director": "Max Golomidov",
    "peaosa": [
      {
        "actor": "Vadim Stepanov",
        "playing": "Mees"
      }
    ]
  },
  {
    "id": 11440,
    "title": "Tolmutu",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11446/486a3c495c293ebc6b573985179a0a8f4fa98911.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Maria Reinup, Jekaterina Hitruhhina",
    "director": "Ivan Pavljutškov",
    "peaosa": [
      {
        "actor": "Dmitri Lomovski",
        "playing": "Alex"
      },
      {
        "actor": "Vadim Stepanov",
        "playing": "Alexi vanaisa"
      }
    ]
  },
  {
    "id": 11441,
    "title": "Iseloomupood",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11447/03c4cb3b3497e6e5ea4628425d1ac6d9df671020.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Armastusfilm",
    "producer": "",
    "director": "Pauls Kesteris",
    "peaosa": [
      {
        "actor": "Marysia Kay",
        "playing": "Ida"
      },
      {
        "actor": "Chris Butler",
        "playing": "Tom"
      },
      {
        "actor": "Nick Evans",
        "playing": "Poe omanik"
      }
    ]
  },
  {
    "id": 11442,
    "title": "Puhastus",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11448/1c552c212fff0a5eef6a9e2319c2dac2e1e63ab2.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Koguperefilm",
    "producer": "Maie Rosmann",
    "director": "Gerli Nõmm",
    "peaosa": [
      {
        "actor": "Marta Laan",
        "playing": "Inga"
      },
      {
        "actor": "Siim Maaten",
        "playing": "Priit"
      }
    ]
  },
  {
    "id": 11444,
    "title": "Suurte meeste mängud",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11450/9bce6b5eef99feced2e5503d65fc0335aad8cde3.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Eluloofilm",
    "producer": "Gretlyn Palberg",
    "director": "Peep Plakso, Gretlyn Palberg",
    "peaosa": [
      {
        "actor": "Hellar Bergmann",
        "playing": "Sass"
      },
      {
        "actor": "Andri Suga",
        "playing": "Joosep"
      }
    ]
  },
  {
    "id": 11446,
    "title": "Kui päike loojub",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11452/a155d27c39dc826d2ec57e8dd18306250ba43ac6.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Aivo Frosch",
    "director": "Aleksandr Rachynskyi",
    "peaosa": [
      {
        "actor": "Vadim Stepanov",
        "playing": "Old man"
      },
      {
        "actor": "Galina Rostovceva",
        "playing": "Old woman"
      }
    ]
  },
  {
    "id": 11449,
    "title": "Tumm",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11455/6e22a4920235b571f40c36a79ada04a4d2a4c460.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Kriminaalfilm",
    "producer": "Reeli Tee",
    "director": "Julia Kalvalid",
    "peaosa": [
      {
        "actor": "Reeli Tee",
        "playing": "Tumm"
      }
    ]
  },
  {
    "id": 11450,
    "title": "Märka mind",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11456/2a68d417226607400b312194e635cbbf78f7859d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Draama",
    "producer": "Mari Tamm",
    "director": "Freddy Alder Saunanen",
    "peaosa": [
      {
        "actor": "Maris Uusna",
        "playing": "Naine"
      }
    ]
  },
  {
    "id": 11451,
    "title": "Mõistlikud inimesed",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11457/5b18a03b92a50990e4af1fa7e0b77bf07e705749.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "MelodraamaŽanr: Draama",
    "producer": "Reinis Kalvinš",
    "director": "Darta Putnina",
    "peaosa": [
      {
        "actor": "Vladimir Zabin",
        "playing": "Mikk"
      },
      {
        "actor": "Maria Mokretsova",
        "playing": "Katriin"
      }
    ]
  },
  {
    "id": 11453,
    "title": "Unenägu",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11459/93c6fba45ede9a633447692402fde0c37dd4220f.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Melodraama",
    "producer": "",
    "director": "Helen Takkin",
    "peaosa": [
      {
        "actor": "Mikk Visnap",
        "playing": "Mees"
      },
      {
        "actor": "Merilin Anni",
        "playing": "Naine"
      }
    ]
  },
  {
    "id": 11455,
    "title": "Lühiromaan",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11461/c5bd3e49440dcaad3cf9f735baf8aa0f23d8145f.PNG",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "",
    "director": "Johannes Arro",
    "peaosa": [
      {
        "actor": "Serob Asatrjan",
        "playing": "Lugeja"
      },
      {
        "actor": "Johan-Mattias Iho",
        "playing": "Raamatu tegelane"
      },
      {
        "actor": "Jelena Kuznetsova",
        "playing": "Tüdruk"
      }
    ]
  },
  {
    "id": 11456,
    "title": "Ache",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11462/a6beb98b2567484e27fdf22b8d60b67534e7a631.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Sigrid Saag",
    "director": "Pauls Kesteris",
    "peaosa": [
      {
        "actor": "Andres Mähar",
        "playing": "Mees"
      },
      {
        "actor": "Mari Vapper",
        "playing": "Naine"
      }
    ]
  },
  {
    "id": 11457,
    "title": "Aastapäev",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11463/2620dfe076ed81c5eeb142a610d84eeaf4447d15.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Gretlyn Palberg",
    "director": "Julia K. Jacobsen",
    "peaosa": [
      {
        "actor": "Eve Kõrda",
        "playing": "Jane"
      },
      {
        "actor": "Riho Laufer",
        "playing": "John"
      }
    ]
  },
  {
    "id": 11460,
    "title": "Kõik on võrdsed",
    "year": "2007",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11466/df1993ae163e3d935a32c9fe915bcb10c10e7a9d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Reinis Kalnaellis",
    "director": "Albina Griniute",
    "peaosa": [
      {
        "actor": "Kunti Berzinska",
        "playing": "Naine"
      },
      {
        "actor": "Bertil Tüvi",
        "playing": "Mees"
      }
    ]
  },
  {
    "id": 11461,
    "title": "Executioner",
    "year": "2007",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11467/7c9686f97c00913a1b17599446bc325f6ced3398.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "",
    "director": "Aleksandr Radžynskyi",
    "peaosa": [
      {
        "actor": "Sergei Andrejev",
        "playing": "Timukas"
      }
    ]
  },
  {
    "id": 11462,
    "title": "Farewell Turku",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11468/65fea728029ecfead28110295cce149d30cd0c0e.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Armastusfilm",
    "producer": "Sami Taavetti Hyvönen",
    "director": "Sami Taavetti Hyvönen",
    "peaosa": [
      {
        "actor": "Santeri  Kirsilä",
        "playing": "Mika"
      }
    ]
  },
  {
    "id": 11473,
    "title": "Külm on",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11480/bf14f28564c0485d99b9d311997693cc62eced42.JPG",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Ivo Felt",
    "director": "Martti Helde",
    "peaosa": [
      {
        "actor": "Mikk Jürjens",
        "playing": "Aggivald"
      },
      {
        "actor": "Aarne Üksküla",
        "playing": "Vanaisa"
      },
      {
        "actor": "Gert Raudsep",
        "playing": "Isa"
      },
      {
        "actor": "Anne Reemann",
        "playing": "Ema"
      },
      {
        "actor": "Madis Mäeorg",
        "playing": "Vend"
      }
    ]
  },
  {
    "id": 11475,
    "title": "Legend vägevast seebist",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11482/863f9b99845807a287eb22712ffa74a347c5e780.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: UlmefilmŽanr: Seiklusfilm",
    "producer": "Evelin Soosaar",
    "director": "Andrew Bond",
    "peaosa": [
      {
        "actor": "Kristo Viiding",
        "playing": "Nimeta kangelane"
      },
      {
        "actor": "Andres Ots",
        "playing": "Seep/Vanamees"
      },
      {
        "actor": "Ilona Tsvetkova",
        "playing": "Puhtuse jumalanna"
      },
      {
        "actor": "Riina Maidre",
        "playing": "Mustuse jumalanna"
      },
      {
        "actor": "Elina Pähklimägi",
        "playing": "Nuustik"
      },
      {
        "actor": "Kene Vernik",
        "playing": "Nuustik"
      },
      {
        "actor": "Inga Salurand",
        "playing": "Hari"
      },
      {
        "actor": "Tiit Sukk",
        "playing": "Rätik"
      }
    ]
  },
  {
    "id": 11492,
    "title": "Põhku pugedes",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11500/2df3cf7834a919eadd5ec2103b5037ffeb036bc1.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Joosep Jürisson",
    "director": "Jaakko Rautava",
    "peaosa": [
      {
        "actor": "Igor Hobotov",
        "playing": "Mees"
      },
      {
        "actor": "Jouna Keränen",
        "playing": "Dr Balthazar"
      }
    ]
  },
  {
    "id": 11508,
    "title": "Leaf and Bullet",
    "year": "2007",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11516/015ebbbbc8a8cb967491fc451a1ce076ea14c02c.PNG",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Ulmefilm",
    "producer": "Rihards Olmanis",
    "director": "Peteris Rozitis",
    "peaosa": [
      {
        "actor": "Arturs Putnis",
        "playing": "Sandis"
      }
    ]
  },
  {
    "id": 11512,
    "title": "Jube õnnetus",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11520/cbb86571f5e2376d457e7d248826fa14d5680010.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "",
    "director": "",
    "peaosa": [
      {
        "actor": "Diana Jors",
        "playing": "Tütarlaps"
      }
    ]
  },
  {
    "id": 11516,
    "title": "Põrgu Jaan",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11524/67329500d9119308f5f833eb4e08994f7edb95ae.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Elari Lend",
    "director": "Kaur Kokk",
    "peaosa": [
      {
        "actor": "Meelis Rämmeld",
        "playing": "Jaan"
      },
      {
        "actor": "Mati Püss",
        "playing": "Vikatiga mees"
      },
      {
        "actor": "Ago Roo",
        "playing": "Kubjas"
      },
      {
        "actor": "Madis Kalmet",
        "playing": "Mõisnik"
      }
    ]
  },
  {
    "id": 11517,
    "title": "Ämblikud 4500 aastat tagasi",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11525/4ea4ac0613d450390c1961576247cde2ea75da41.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Tiiu-Ann Pello",
    "director": "Jaan  Tätte jr",
    "peaosa": [
      {
        "actor": "Jaan  Tätte jr",
        "playing": "Jaan Tätte jr"
      }
    ]
  },
  {
    "id": 11518,
    "title": "Koddo",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11526/d73d122faad4a7b669fa6159c2cd443c4eae55f0.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kristo Jürmann",
    "director": "Eik Tammemäe",
    "peaosa": [
      {
        "actor": "Helena Merzin",
        "playing": "Lydia"
      },
      {
        "actor": "Jüri Aarma",
        "playing": "Vanamees"
      }
    ]
  },
  {
    "id": 11519,
    "title": "Leipzigisse",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11527/e708886931953b09c29752ef5fb3c2d9477c635a.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "PõnevusfilmŽanr: Draama",
    "producer": "Andero Tõnissoo",
    "director": "Hardi Keerutaja",
    "peaosa": [
      {
        "actor": "Hendrik Toompere jr jr",
        "playing": "Karl"
      },
      {
        "actor": "Kerttu Veske",
        "playing": "Agnes"
      }
    ]
  },
  {
    "id": 11525,
    "title": "Tupik",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11533/f9905279baa8bafbfce65d7f01e06f384471266f.PNG",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "PõnevusfilmŽanr: Draama",
    "producer": "Kaisa Vaher",
    "director": "Priit Palumaa",
    "peaosa": [
      {
        "actor": "Marko Leht",
        "playing": "Karl"
      }
    ]
  },
  {
    "id": 11528,
    "title": "Armastuse lugu",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11536/cc3b844ad6fbdc1c27f6f914c8699e2f73c60a78.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "NoortefilmŽanr: Draama",
    "producer": "",
    "director": "Lizete Murovska",
    "peaosa": [
      {
        "actor": "Zane Dirina",
        "playing": "Tüdruk"
      },
      {
        "actor": "Oskar Lehemaa",
        "playing": "Poiss"
      }
    ]
  },
  {
    "id": 11539,
    "title": "The Ranger",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11547/ea9a6bc61d9933bb32a62cf421e61f105fbffddf.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "KomöödiafilmŽanr: NoortefilmŽanr: SeiklusfilmŽanr: Teekonnafilm",
    "producer": "Hardi Kalder",
    "director": "Kristjan Saar",
    "peaosa": [
      {
        "actor": "Hardi Kalder",
        "playing": "Reporter"
      }
    ]
  },
  {
    "id": 11542,
    "title": "Tehnopol - IDEA",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11550/d64e62fac4bc5af46afe7c6d00b3225a10e0654b.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "TeekonnafilmŽanr: Muinasjuttfilm",
    "producer": "Heli Jürisson",
    "director": "Oscar Henri Wollsten",
    "peaosa": [
      {
        "actor": "Tõnis Niinemets",
        "playing": "Idea"
      },
      {
        "actor": "Madis Mäeorg",
        "playing": "Kurjam"
      }
    ]
  },
  {
    "id": 11546,
    "title": "Man of the Day",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11555/2b044124d3d0ec579cad7cb6d67ae5875b480b7b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Muinasjuttfilm",
    "producer": "",
    "director": "Anna Kanska",
    "peaosa": [
      {
        "actor": "Kristians Avotins",
        "playing": "Supermees"
      }
    ]
  },
  {
    "id": 11551,
    "title": "Seotud silmadega",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11560/f2de64f780ce220054102aa790729cec6bc78182.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Ulmefilm",
    "producer": "Vladlena Rudusane",
    "director": "Jekaterina Hitruhhina",
    "peaosa": [
      {
        "actor": "Igor Krushelnitskij",
        "playing": "Kirjanik"
      }
    ]
  },
  {
    "id": 11552,
    "title": "See on nii nagu on",
    "year": "2007",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11561/37bfaec43c6a4422a3b44847c967f1684c21056f.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "NoortefilmŽanr: Draama",
    "producer": "Bernardas Andriušis",
    "director": "Bernardas Andriušis",
    "peaosa": [
      {
        "actor": "Karolis Mazhulis",
        "playing": "Danas"
      }
    ]
  },
  {
    "id": 11553,
    "title": "Valitud rajad",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11562/ce810a712e7cc15e52b220c5e4587431f8b8b038.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "NoortefilmŽanr: Draama",
    "producer": "Elina Päsok",
    "director": "Sergey Ananjev",
    "peaosa": [
      {
        "actor": "Kir N.",
        "playing": "Kofeiini ohver"
      }
    ]
  },
  {
    "id": 11555,
    "title": "Valguse läte",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11564/93cb5cbd99bf41d06a110fbf30a36ae18e31fa6e.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Alisa Kutsõk",
    "director": "Aleksandr Rachynskyi",
    "peaosa": [
      {
        "actor": "Sergei Furmanjuk",
        "playing": "Anton"
      },
      {
        "actor": "Ivan Savanteev",
        "playing": "Dima"
      }
    ]
  },
  {
    "id": 11571,
    "title": "Banana split",
    "year": "2007",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11580/792d893a782f389d73bd6e475e9db958e9d01bb0.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Draama",
    "producer": "",
    "director": "Zane Dirina",
    "peaosa": [
      {
        "actor": "Eva Ligi",
        "playing": "Tüdruk"
      },
      {
        "actor": "Mikk Metsniit",
        "playing": "Poiss"
      }
    ]
  },
  {
    "id": 11573,
    "title": "La Dolce Vita",
    "year": "2007",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11582/ddeeff5ca51aa401c6d2d37e80786711cf6ae287.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Draama",
    "producer": "",
    "director": "Gerli Nõmm",
    "peaosa": [
      {
        "actor": "Maria Kivirand",
        "playing": "Tüdruk"
      },
      {
        "actor": "Ivo  Leeman",
        "playing": "Poiss"
      }
    ]
  },
  {
    "id": 11574,
    "title": "Raamat",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11583/0b7d36fa23d8f552892d0d194ac7a3a46afe2f47.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Draama",
    "producer": "Anna Kanska, Anna Vilnite",
    "director": "Anna Kanska",
    "peaosa": [
      {
        "actor": "Ivars Jurševics",
        "playing": "Mees raamatukogus"
      },
      {
        "actor": "Edvards Vilnītis",
        "playing": "Poiss"
      },
      {
        "actor": "Maija Dubro",
        "playing": "Kontoritüdruk"
      }
    ]
  },
  {
    "id": 11577,
    "title": "Pidu",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11586/874730ae725e58391fec404c249f072758cc6aab.PNG",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Henri Nõmm",
    "director": "Harijs Arájs",
    "peaosa": [
      {
        "actor": "Henri Nõmm",
        "playing": "Henri"
      },
      {
        "actor": "Kristofer Piir",
        "playing": "Kristofer"
      },
      {
        "actor": "Mari-Liis Medar",
        "playing": "Pizza kättetoimetaja"
      }
    ]
  },
  {
    "id": 11578,
    "title": "Greed",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11587/a86e2b6e1bf2de6d155ec9d2b2003a62635058e7.PNG",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "",
    "director": "Eiris Teeveere",
    "peaosa": [
      {
        "actor": "Helen Krupp",
        "playing": "Mõrvar"
      }
    ]
  },
  {
    "id": 11581,
    "title": "Fiesta",
    "year": "2007",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11590/20ffc7e9eda1d8698f7e5dd40f195833f700a1cb.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Draama",
    "producer": "",
    "director": "Triin Ruumet",
    "peaosa": [
      {
        "actor": "Sten-Erik Toos",
        "playing": "Poiss"
      },
      {
        "actor": "Oskar Lehemaa",
        "playing": "Poiss"
      }
    ]
  },
  {
    "id": 11584,
    "title": "The Door",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11593/98d08ef12a402b1fc30c20e145b65b339be1f08f.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "PõnevusfilmŽanr: Ulmefilm",
    "producer": "",
    "director": "",
    "peaosa": [
      {
        "actor": "Mart Müürisepp",
        "playing": "Mees"
      }
    ]
  },
  {
    "id": 11586,
    "title": "Aastapäeva valu",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11595/006a2774a1066e67f109fe89cac3540803d34184.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "NoortefilmŽanr: UlmefilmŽanr: Armastusfilm",
    "producer": "Suive Pahrt",
    "director": "Suive Pahrt",
    "peaosa": [
      {
        "actor": "Gerli Tiganik",
        "playing": "Naine"
      },
      {
        "actor": "Villem Jahu",
        "playing": "Mees"
      }
    ]
  },
  {
    "id": 11587,
    "title": "Nüüd",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11596/f6b7a2d4864f5ff5e04bf53a404e2776c7315df1.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Armastusfilm",
    "producer": "Dirk Hoyer",
    "director": "Dirk Hoyer",
    "peaosa": [
      {
        "actor": "Kati Ong",
        "playing": "Liina"
      },
      {
        "actor": "Sten Karpov",
        "playing": "Kauri"
      },
      {
        "actor": "Kári Vidarsson",
        "playing": "Hlynur"
      },
      {
        "actor": "Liis Laigna",
        "playing": "Kerttu"
      }
    ]
  },
  {
    "id": 11591,
    "title": "Anniversary Ache II",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11600/40b5548d8603b944a26807a318927be85fb41e8c.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "NoortefilmŽanr: Draama",
    "producer": "Alisa Kutsõk, Olga Stesnjagina",
    "director": "Alisa Kutsõk",
    "peaosa": [
      {
        "actor": "Kim Zmeykin",
        "playing": "John"
      },
      {
        "actor": "Regina  Verner",
        "playing": "Jane"
      }
    ]
  },
  {
    "id": 11594,
    "title": "Vanapagan ja Ants",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11603/f6cd0459f16d0e2943aa54e0537912c227bedcad.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Muinasjuttfilm",
    "producer": "Keiti Väliste",
    "director": "Tatjana Kosminskaja",
    "peaosa": [
      {
        "actor": "Jaakko Rautava",
        "playing": "Vanapagan"
      },
      {
        "actor": "Max Kroonmann",
        "playing": "Ants"
      },
      {
        "actor": "Sirje Tõru",
        "playing": "Eit"
      }
    ]
  },
  {
    "id": 11595,
    "title": "Maalimise aktsioon",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11604/91c80f53a558dccb157d447800e3c222f4f3e1ac.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Natalia Ivanova",
    "director": "Olga Stesnjagina",
    "peaosa": [
      {
        "actor": "Anastasia Chikina",
        "playing": "Bunny"
      },
      {
        "actor": "Mark Sepp",
        "playing": "Pierre"
      }
    ]
  },
  {
    "id": 11602,
    "title": "Minu kindlus",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11611/403b8ffca8362fcb2d39123cb9be10e53335de36.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Sara Lago, Bárbara Villadelprat",
    "director": "Katrina Tomasicka",
    "peaosa": [
      {
        "actor": "Elóy Monteiro",
        "playing": "Paulo"
      },
      {
        "actor": "Filomena Gigante",
        "playing": "Kohvitädi"
      }
    ]
  },
  {
    "id": 11613,
    "title": "Ma olin temasse armunud",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11622/f36b8ab03194b779cc5a40f6b47d3786a40bb0c0.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Tatjana Kuznetsova",
    "director": "Elena Kuznetsova",
    "peaosa": [
      {
        "actor": "Oleg Pangsepp",
        "playing": "Skulptor"
      },
      {
        "actor": "Tatjana Kosmyinina",
        "playing": "Naine"
      },
      {
        "actor": "Darya Korniyenko",
        "playing": "Muusa"
      },
      {
        "actor": "Enrico Barone",
        "playing": "Mees"
      },
      {
        "actor": "Dmitri Grudin",
        "playing": "Poiss"
      }
    ]
  },
  {
    "id": 11614,
    "title": "Ole ettevaatlik nähtamatu suhtes",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11623/15057a0156f9dbacdbef17db9592126d474cd135.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Põnevusfilm",
    "producer": "Helen Krupp, Laura Laasi, Eiris Teeveere",
    "director": "Helen Krupp",
    "peaosa": [
      {
        "actor": "Gert Kark",
        "playing": "Edvard"
      }
    ]
  },
  {
    "id": 11647,
    "title": "Peitusemäng",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11656/d11349c49e0a7bbad7130cf69c3c785d4f9985d2.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Aleksandr Radžynskyi",
    "director": "Aleksandr Radžynskyi",
    "peaosa": [
      {
        "actor": "Miia-Estell Harkmaa",
        "playing": "Vera"
      }
    ]
  },
  {
    "id": 11650,
    "title": "Ellawood",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11659/34ffea1e2c9f7d6e5569740ad119c0c77a7d2f6a.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Armastusfilm",
    "producer": "Eva-Kristina Mill",
    "director": "Doris Tääker",
    "peaosa": [
      {
        "actor": "Katariina Tamm",
        "playing": "Karmuella/Armuella"
      },
      {
        "actor": "Risto Ring",
        "playing": "Flip \"Prints\" Charming"
      }
    ]
  },
  {
    "id": 432,
    "title": "Külaline",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11662/41c0943b298c02720cd0af83d7c91a3889c1779e.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Siret Täks",
    "director": "Robi Uppin",
    "peaosa": [
      {
        "actor": "Rasmus Kivi",
        "playing": "Lucifer"
      },
      {
        "actor": "Tormis Laanisto",
        "playing": "Assassin"
      }
    ]
  },
  {
    "id": 11653,
    "title": "Time",
    "year": "2007",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11663/37b9506218421661bb0f0ddea099a6b7dc687361.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Üleloomulik film",
    "producer": "",
    "director": "Robi Uppin",
    "peaosa": [
      {
        "actor": "Lina Multer",
        "playing": "Naine"
      }
    ]
  },
  {
    "id": 11662,
    "title": "The House with a Woman",
    "year": "2010",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11672/72bd658b8aea9bedf6e75a09d4e975fadae948a9.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "MelodraamaŽanr: Armastusfilm",
    "producer": "Simona Klavina",
    "director": "Agnese Laizane",
    "peaosa": [
      {
        "actor": "Aleksandr Lavrinenko",
        "playing": "Mart"
      }
    ]
  },
  {
    "id": 11668,
    "title": "Ettevõtja",
    "year": "2006",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11678/4fbf89792ffa318cc3dce791d07983734b96afb3.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Liina Paakspuu",
    "director": "Liina Paakspuu",
    "peaosa": [
      {
        "actor": "Kristiine Truu",
        "playing": "Marla"
      }
    ]
  },
  {
    "id": 11672,
    "title": "Valge ruut",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11682/40399c312ffae93b1fc4b9e84019980b5ef19b04.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Martin Ruus",
    "director": "Ivan Pavljutškov",
    "peaosa": [
      {
        "actor": "Anton Melnitšuk",
        "playing": "Saša"
      },
      {
        "actor": "Ivan Turapin",
        "playing": "Zahar"
      }
    ]
  },
  {
    "id": 11673,
    "title": "Aeg ei peatu",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11683/82320bd6749e65e5b75ae184cca90c64a3a02240.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: DraamaŽanr: Armastusfilm",
    "producer": "Elari Lend",
    "director": "Moonika Siimets",
    "peaosa": [
      {
        "actor": "Ene Järvis",
        "playing": "Malle"
      },
      {
        "actor": "Feliks Kark",
        "playing": "Jaan"
      },
      {
        "actor": "Carita Vaikjärv",
        "playing": "Miina"
      }
    ]
  },
  {
    "id": 11674,
    "title": "Võõrsil",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11684/29cc3b0708b11c6c0bd686f5a60fd2593b0d0da3.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Armastusfilm",
    "producer": "Gretlyn Palberg",
    "director": "Hardi Keerutaja",
    "peaosa": [
      {
        "actor": "Jaanika Arum",
        "playing": "Kristina"
      },
      {
        "actor": "Argo Aadli",
        "playing": "Aigar"
      }
    ]
  },
  {
    "id": 11678,
    "title": "Minu linn",
    "year": "2006",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11688/30df85fca17464e3b7ff057a93c0413f058a0348.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "KomöödiafilmŽanr: Teekonnafilm",
    "producer": "Ermo Säks",
    "director": "Ermo Säks",
    "peaosa": [
      {
        "actor": "Marju Alumäe",
        "playing": "Poola agraarbeib"
      }
    ]
  },
  {
    "id": 11680,
    "title": "Teekond",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11690/b09166e998afefc1f9429b0d08273431268092c2.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Teekonnafilm",
    "producer": "Ermo Säks",
    "director": "Ermo Säks",
    "peaosa": [
      {
        "actor": "Mattias Huik",
        "playing": "(Väike)mees"
      }
    ]
  },
  {
    "id": 11681,
    "title": "Proosaline elu",
    "year": "2006",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11691/7bb6aea0aff6e0616ed7dd183b22a96854a4f85d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Draama",
    "producer": "Ermo Säks",
    "director": "Ermo Säks",
    "peaosa": [
      {
        "actor": "Liis Nimik",
        "playing": "Ljudmilla/Olga"
      },
      {
        "actor": "Martti Helde",
        "playing": "Anatoli"
      }
    ]
  },
  {
    "id": 11469,
    "title": "See ei ole tema",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11694/721ef2fadf3e28ed067b4cf11f19e4d06fefad01.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Ulmefilm",
    "producer": "Enrico Barone",
    "director": "Oscar Henri Wollsten",
    "peaosa": [
      {
        "actor": "Viktoria Gezei",
        "playing": "Naine"
      }
    ]
  },
  {
    "id": 11709,
    "title": "Reisisaatja",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11721/62e6abc815d2e9b42c8aff6d36145c0297267dc6.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Elina Päsok",
    "director": "Elina Päsok",
    "peaosa": [
      {
        "actor": "Mark Sepp",
        "playing": "Reisisaatja"
      }
    ]
  },
  {
    "id": 11437,
    "title": "Cello",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11741/57fb1ab02c983a7d6995d754cfcdd4d60bb95211.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Paula Ligere",
    "director": "Paula Ligere",
    "peaosa": [
      {
        "actor": "Valters Pūce",
        "playing": "Daniel"
      },
      {
        "actor": "Liene Sebre",
        "playing": "Eva"
      }
    ]
  },
  {
    "id": 11810,
    "title": "Kõks",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11824/5c0f024e13b65b8685a7f6a96fd670afb6776e9e.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kristo Jürmann",
    "director": "Hardi Keerutaja",
    "peaosa": [
      {
        "actor": "Henrik Kalmet",
        "playing": "Jobu"
      },
      {
        "actor": "Mari Abel",
        "playing": "Ema"
      },
      {
        "actor": "Katariina Kabel",
        "playing": "Tüdruk"
      },
      {
        "actor": "Salme Poopuu",
        "playing": "Vanaema"
      }
    ]
  },
  {
    "id": 11812,
    "title": "Ainult meie kolm",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11826/06c65f773d6908061a1d32aa3e82f411adc4dd69.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Reinis Kalvinš",
    "director": "Giampietro Balia",
    "peaosa": [
      {
        "actor": "Jaune Kimmel",
        "playing": "Liisu"
      },
      {
        "actor": "Epp Eespäev",
        "playing": "Regina"
      },
      {
        "actor": "Märten Metsaviir",
        "playing": "Andres"
      },
      {
        "actor": "Kersti Heinloo",
        "playing": "Helen"
      }
    ]
  },
  {
    "id": 11813,
    "title": "Vikatimehe poeg",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11827/268ff8357ba0e6cd47cf800777003483c1ea7646.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: UlmefilmŽanr: Armastusfilm",
    "producer": "Maria Reinup, Kadriann Kibus",
    "director": "Sergei Kibus",
    "peaosa": [
      {
        "actor": "Mikk Jürjens",
        "playing": "Vikatimehe Poeg"
      },
      {
        "actor": "Mari Pokinen",
        "playing": "Neiu"
      }
    ]
  },
  {
    "id": 11814,
    "title": "Õhuta balloon",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11828/056347fdb3b54eae6131d870f0d00d90c9c49b51.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Eluloofilm",
    "producer": "Tomas Miniotas",
    "director": "Bernardas Andriušis",
    "peaosa": [
      {
        "actor": "Adomas Stančikas",
        "playing": "Jakie"
      },
      {
        "actor": "Darja Kolodieva",
        "playing": "Kira"
      }
    ]
  },
  {
    "id": 11839,
    "title": "Mõttetu",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11861/1244def7e3f594468b625303506d3274a6902f95.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Andero Tõnissoo",
    "director": "Eik Tammemäe",
    "peaosa": [
      {
        "actor": "Rednar Annus",
        "playing": "Krint Absur"
      }
    ]
  },
  {
    "id": 11840,
    "title": "Pealt kullakarvaline",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11862/de423d116b1e0ee2789ed77d25466b8392d2956a.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Margit Sauk",
    "director": "Nele Kirsipuu",
    "peaosa": [
      {
        "actor": "Kärt Tammjärv",
        "playing": "Tüdruk"
      },
      {
        "actor": "Reimo Sagor",
        "playing": "Poiss"
      }
    ]
  },
  {
    "id": 11842,
    "title": "Valge doomino",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11864/9eba70cd55608873c9a0bcd0cbd9502ab260ab4b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Maria Kljukina",
    "director": "Eva Kübar",
    "peaosa": [
      {
        "actor": "Maria Lee Liivak",
        "playing": "Tüdruk"
      },
      {
        "actor": "Sebastian Talmar",
        "playing": "Poiss"
      },
      {
        "actor": "Ülle Kaljuste",
        "playing": "Raamatukoguhoidja"
      },
      {
        "actor": "Peeter Jakobi",
        "playing": "Raamatukogutöötaja"
      }
    ]
  },
  {
    "id": 11848,
    "title": "Peata pulmad",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11870/daa7f886bb9ba9fe575f428d333ea9f75ae807ac.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Liina Tiido",
    "director": "Sandra Zaneva",
    "peaosa": [
      {
        "actor": "Alissa Šnaider",
        "playing": "Naine"
      }
    ]
  },
  {
    "id": 11907,
    "title": "Sein",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11929/31e1e9031df28f173f5c3631bee1315dd8252755.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Maria Kljukina",
    "director": "Anna Hints",
    "peaosa": [
      {
        "actor": "Ülle Kaljuste",
        "playing": "Naine"
      },
      {
        "actor": "Guido Kangur",
        "playing": "Mees"
      }
    ]
  },
  {
    "id": 11937,
    "title": "Härjasilmad",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11959/08979463778005cecf7a39d2e184b7fd695429c4.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Heli Jürisson",
    "director": "Heinrich Sepp",
    "peaosa": [
      {
        "actor": "Vallo Kirs",
        "playing": "Thesus"
      },
      {
        "actor": "Päär Pärenson",
        "playing": "Minotaurus"
      }
    ]
  },
  {
    "id": 11954,
    "title": "Uudishimu tapab",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11976/af5eca709758f9b705f7fb40464d8a7631b337f9.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "PõnevusfilmŽanr: Üleloomulik film",
    "producer": "Kaspar Ainelo",
    "director": "Sander Maran",
    "peaosa": [
      {
        "actor": "Peeter Maran",
        "playing": "Poiss"
      },
      {
        "actor": "Rita Rätsepp",
        "playing": "Ema"
      },
      {
        "actor": "Jaak Valdre",
        "playing": "Isa"
      }
    ]
  },
  {
    "id": 11967,
    "title": "Fundamentum",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/11989/b3b19428de33ff42f23d43572e57c677d7761291.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Hillar Indla",
    "director": "Margus Raid",
    "peaosa": [
      {
        "actor": "Ahti Puudersell",
        "playing": "Isa"
      },
      {
        "actor": "Liivika Hanstin",
        "playing": "Ema"
      },
      {
        "actor": "Marika Palm",
        "playing": "Tütar"
      }
    ]
  },
  {
    "id": 12079,
    "title": "ANKH",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/12101/5192ef603863a52dbf8d5944f34603e81c5ff084.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "UlmefilmŽanr: Üleloomulik film",
    "producer": "Heli Luik",
    "director": "Reino Aedmäe",
    "peaosa": [
      {
        "actor": "Hendrik Vissel",
        "playing": "Marc Eddard"
      },
      {
        "actor": "Klaudia Tiitsmaa",
        "playing": "Marya Eddard"
      }
    ]
  },
  {
    "id": 12081,
    "title": "Vaikused",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/12103/b2ae3abad397182ab5db08a0111c2f3631b035b7.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "UlmefilmŽanr: Seiklusfilm",
    "producer": "Sten-Jaago Vesso",
    "director": "Sten-Jaago Vesso",
    "peaosa": [
      {
        "actor": "Tauri Laane",
        "playing": "Kangelane"
      }
    ]
  },
  {
    "id": 13490,
    "title": "Mereröövlimäng",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/13503/fb95d0cf6ec5103fbe980626ae62bd72a4f46c16.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Teekonnafilm",
    "producer": "Heli Luik",
    "director": "Tõnn Sikk",
    "peaosa": [
      {
        "actor": "Talis Petersell",
        "playing": "Sten-Erik"
      },
      {
        "actor": "Anni Saar",
        "playing": "Maria"
      }
    ]
  },
  {
    "id": 14395,
    "title": "Distants",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/14412/0b31d9278f924510a5a8c2cf9fcce3922b079446.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kristjan Pütsep",
    "director": "Janno Jürgens",
    "peaosa": [
      {
        "actor": "Indrek Ojari",
        "playing": "Poeg"
      },
      {
        "actor": "Väino Laes",
        "playing": "Isa"
      }
    ]
  },
  {
    "id": 14672,
    "title": "Maxim",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/14691/76e2774ef2d7a8b6228369e394f25f7a0bd692ff.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Hanne-Loore Pajusoo",
    "director": "Rainer Helin",
    "peaosa": [
      {
        "actor": "Artur Leete",
        "playing": "Maxim"
      },
      {
        "actor": "Tuuli Maasikas",
        "playing": "Alexandra"
      },
      {
        "actor": "Jaan  Kalmus jr",
        "playing": "Philip"
      }
    ]
  },
  {
    "id": 15144,
    "title": "Tõsikindel Jänes",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/15165/37e0bf4d814413b38e4456fb995e4b1610dae8be.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: NoortefilmŽanr: Armastusfilm",
    "producer": "Kristofer Piir",
    "director": "Eik Tammemäe",
    "peaosa": [
      {
        "actor": "Roland Laos",
        "playing": "Poiss"
      },
      {
        "actor": "Margit Viirma",
        "playing": "Tüdruk"
      },
      {
        "actor": "Ester Pajusoo",
        "playing": "Vanaema"
      },
      {
        "actor": "Markus Dvinjaninov",
        "playing": "Gregor"
      },
      {
        "actor": "Jaan-Siim Vikerpuu",
        "playing": "Kuldjänes"
      }
    ]
  },
  {
    "id": 15262,
    "title": "Teine pirukarööv",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/15283/1c89b3e05916a62c014557b77944c7192548af8f.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Tiiu-Ann Pello",
    "director": "Kaur Kokk",
    "peaosa": [
      {
        "actor": "Maiken Schmidt",
        "playing": "Niina"
      },
      {
        "actor": "Pääru Oja",
        "playing": "Kalle"
      }
    ]
  },
  {
    "id": 15312,
    "title": "Kõik on võimalik",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/15333/26bc154f05718086a237b25b40584faa23e5094e.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Noortefilm",
    "producer": "Maie Rosmann",
    "director": "Jaan  Tätte jr",
    "peaosa": [
      {
        "actor": "Indrek Jõe",
        "playing": "Johannes"
      },
      {
        "actor": "Sohvi Viik",
        "playing": "Triin"
      }
    ]
  },
  {
    "id": 15324,
    "title": "Põhja",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/15345/673bbc7af7e395bc743c2d825aeb5b592c888ff9.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Draama",
    "producer": "Maie Rosmann",
    "director": "Triin Ruumet",
    "peaosa": [
      {
        "actor": "Margus Prangel",
        "playing": "Toivo"
      },
      {
        "actor": "Erki Laur",
        "playing": "Vello"
      }
    ]
  },
  {
    "id": 16026,
    "title": "Kõik muusikud on kaabakad",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16048/f0c9967798078c4c8c6d02de2f2f453c400a9ac7.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Täispikk mängufilm",
    "genre": "Draama",
    "producer": "Piret Tibbo-Hudgins",
    "director": "Heleri Saarik",
    "peaosa": [
      {
        "actor": "Riina Maidre",
        "playing": "Leila"
      },
      {
        "actor": "Nero Urke",
        "playing": "Toivo"
      },
      {
        "actor": "Jarek Kasar (ka Chalice)",
        "playing": "Shrek"
      }
    ]
  },
  {
    "id": 16027,
    "title": "Juhe, kiip ja suitsev kaheraudne",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16049/bce62b0ea0a7008d062185e3f04666c02c589820.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Põnevusfilm",
    "producer": "Richard Meitern",
    "director": "Urmas Reisberg",
    "peaosa": [
      {
        "actor": "Martin Kõiv",
        "playing": "Dr. Klaas"
      },
      {
        "actor": "Tarmo Tagamets",
        "playing": "Lpn. Pulk"
      },
      {
        "actor": "Enor Niinemägi",
        "playing": "Rms. Siig"
      },
      {
        "actor": "Veikko Täär",
        "playing": "Hr. President"
      }
    ]
  },
  {
    "id": 16091,
    "title": "Cisco",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16112/ec1a4e90f591ffec05677199979c31c350330ae5.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Hillar Indla",
    "director": "Reino Aedmäe",
    "peaosa": [
      {
        "actor": "Mihkel Kabel",
        "playing": "Cisco"
      },
      {
        "actor": "Marilin Kongo",
        "playing": "Maria"
      },
      {
        "actor": "Taavi Eelmaa",
        "playing": "Šeriff"
      },
      {
        "actor": "Kene Vernik",
        "playing": "Emilia"
      }
    ]
  },
  {
    "id": 16093,
    "title": "Vaba maa",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16114/47aa6d991fe54fd8ac4e91c6094c904221a206b6.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kaspar Ainelo",
    "director": "Anna Hints",
    "peaosa": [
      {
        "actor": "Rita Raave",
        "playing": "Grace"
      },
      {
        "actor": "Eili Sild",
        "playing": "Ilme"
      },
      {
        "actor": "Raivo Trass",
        "playing": "Heldur"
      }
    ]
  },
  {
    "id": 16094,
    "title": "Üksikjuhtum",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16115/0f8ed0d27c47c32bcc0ecedda7586bd21fdc3445.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Eva-Kristina Mill",
    "director": "Eva Kübar",
    "peaosa": [
      {
        "actor": "Rain Tolk",
        "playing": "Toomas"
      },
      {
        "actor": "Mari Abel",
        "playing": "Gerda"
      },
      {
        "actor": "Ülle Lichtfeldt",
        "playing": "Riina"
      },
      {
        "actor": "Marta Laan",
        "playing": "Hanna"
      },
      {
        "actor": "Andres Maimik",
        "playing": "Andres"
      },
      {
        "actor": "Tanel Saar",
        "playing": "Mart"
      },
      {
        "actor": "Pierrot Jean Papillon",
        "playing": "Hipi"
      },
      {
        "actor": "Tom Valsberg",
        "playing": "Hipi"
      }
    ]
  },
  {
    "id": 16150,
    "title": "Teiselpool vikerkaart",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16171/cff194f224997d7fed633b0581047b62f6f27f2d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Maie Rosmann, Tõnis Hiiesalu",
    "director": "Triin Ruumet",
    "peaosa": [
      {
        "actor": "Hendrik Toompere jr jr",
        "playing": "Aivar"
      },
      {
        "actor": "Katre Kaseleht",
        "playing": "Leeni"
      }
    ]
  },
  {
    "id": 16256,
    "title": "Võlutari Leivapätsid",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16277/30352ae2acadced4ef73cd31d65f2cd16c1ed6aa.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Heli Jürisson",
    "director": "Nele Kirsipuu",
    "peaosa": [
      {
        "actor": "Juuli Lill",
        "playing": "Martha"
      },
      {
        "actor": "Tõnu Oja",
        "playing": "Kunstnik (Karl)"
      }
    ]
  },
  {
    "id": 16268,
    "title": "Viimane trubaduur",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16305/651643c2ad39b1b2304c1c4c0a4882955524c6ac.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Liina Tiido",
    "director": "Heinrich Sepp",
    "peaosa": [
      {
        "actor": "Aleksander Eelmaa",
        "playing": "Jakob"
      },
      {
        "actor": "Ott Aardam",
        "playing": "Samuel"
      }
    ]
  },
  {
    "id": 16275,
    "title": "Marionett",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16310/618330b660a16c832af0f312e5a6ce8406e9bcd9.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Põnevusfilm",
    "producer": "Heli Luik",
    "director": "Raimo Kaubi",
    "peaosa": [
      {
        "actor": "Kati Ong",
        "playing": "Naine"
      },
      {
        "actor": "Anti Kobin",
        "playing": "Mees"
      },
      {
        "actor": "Raul Vaiksoo",
        "playing": "Võõras"
      }
    ]
  },
  {
    "id": 16298,
    "title": "Raisus südamed",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16372/e08dfffbd064aba88c1f7a38ae9c2361cd726934.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Teekonnafilm",
    "producer": "Kati Varblane",
    "director": "Edina Csüllög",
    "peaosa": [
      {
        "actor": "Juha Hippi",
        "playing": "Jan"
      },
      {
        "actor": "Madara Botmane",
        "playing": "Daina"
      }
    ]
  },
  {
    "id": 16304,
    "title": "Kelder",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16383/26c81ab59757dd02847b294f4361bdf5bacb8044.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "",
    "director": "Krista Jutt",
    "peaosa": [
      {
        "actor": "Tanel Tero",
        "playing": "Vang"
      },
      {
        "actor": "Krista Kilter",
        "playing": "Perenaine"
      }
    ]
  },
  {
    "id": 16316,
    "title": "Renessanss",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16398/26aca70a2710f8b6e9b4426f97e0c54764a60d39.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Aira Koort",
    "director": "Margus Raid",
    "peaosa": [
      {
        "actor": "Janek Joost",
        "playing": "Heinrich"
      },
      {
        "actor": "Karin Kask",
        "playing": "Moonika"
      }
    ]
  },
  {
    "id": 16317,
    "title": "Kevad à la carte",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16399/57553ca798f69996f29be97e9d95b3e8c6bdb674.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "MelodraamaŽanr: Muusika/tantsu",
    "producer": "Maria Kljukina",
    "director": "Doris Tääker",
    "peaosa": [
      {
        "actor": "Maiken Schmidt",
        "playing": "Aliide"
      },
      {
        "actor": "Vallo Toomla",
        "playing": "Walter"
      },
      {
        "actor": "Lauri Saatpalu",
        "playing": "Restoranipidaja"
      }
    ]
  },
  {
    "id": 16318,
    "title": "Amneesia rööbastel",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16400/34d585c16799164d61bde411aba19da09e89cd16.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Paul Aguraiuja",
    "director": "Sandra Sachs",
    "peaosa": [
      {
        "actor": "Ketter Habakukk",
        "playing": "Tüdruk"
      },
      {
        "actor": "Joonas Parve",
        "playing": "Reisija"
      }
    ]
  },
  {
    "id": 16321,
    "title": "Gracias a la Vida",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16403/55e1414d509d094747767169284b1af142196497.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Muusikavideo",
    "genre": "Armastusfilm",
    "producer": "Anneli Ahven",
    "director": "Kristo Viiding",
    "peaosa": [
      {
        "actor": "Indrek Kruusimaa",
        "playing": "Patrik"
      },
      {
        "actor": "Kersti Heinloo",
        "playing": "Rita"
      },
      {
        "actor": "Andres Lepik",
        "playing": "Roland Zagreus"
      }
    ]
  },
  {
    "id": 16324,
    "title": "Vanilli 2 Palli",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16424/5770f2b0dd823d646c8413df8ee55841905c51ab.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Muusikavideo",
    "genre": "KomöödiafilmŽanr: Noortefilm",
    "producer": "Eik Tammemäe",
    "director": "Eik Tammemäe",
    "peaosa": [
      {
        "actor": "Rait Õunapuu",
        "playing": "Jäätisepoiss Simmu"
      }
    ]
  },
  {
    "id": 16336,
    "title": "Oled see sina?",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16446/de0fe34a9ee0e7707b0442c861e0727b670f1762.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Peter Murdmaa",
    "director": "Moonika Siimets",
    "peaosa": [
      {
        "actor": "Ott Kartau",
        "playing": "Mees"
      },
      {
        "actor": "Liina Vahtrik",
        "playing": "Naine telefonis"
      }
    ]
  },
  {
    "id": 16337,
    "title": "Öö. Tänav. Latern",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16449/6a377a15b7a18f90151a33ba5ba3e119fd52e65b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "",
    "director": "Polina Udre",
    "peaosa": [
      {
        "actor": "Mark Sepp",
        "playing": "Mees"
      }
    ]
  },
  {
    "id": 16338,
    "title": "1+1",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16450/098cce94e2a452cc8b5ec1e409aa4ddae96bdd4f.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Melodraama",
    "producer": "",
    "director": "Aleksandr Rachynskyi",
    "peaosa": [
      {
        "actor": "Aivo Frosch",
        "playing": "Noor mees"
      },
      {
        "actor": "Ljubov Andreeva",
        "playing": "Noor naine"
      }
    ]
  },
  {
    "id": 16340,
    "title": "Puberteet",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16453/5a43300a95253ff65b5d70d0e01d976941014383.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Muusika/tantsu",
    "producer": "Tiiu-Ann Pello, Tõnis Hiiesalu",
    "director": "Triin Ruumet",
    "peaosa": [
      {
        "actor": "Anna-Maria Jams",
        "playing": "Maarja"
      },
      {
        "actor": "Grete Raudsepp",
        "playing": "Keiu"
      },
      {
        "actor": "Britt-Kathleen Mere",
        "playing": "Tuuli"
      },
      {
        "actor": "Rasmus Kaljujärv",
        "playing": "Pastor"
      },
      {
        "actor": "Kaisa Selde",
        "playing": "Ave"
      }
    ]
  },
  {
    "id": 16341,
    "title": "Viimane Romeo",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16454/227f962e6ef6a87b9f67a0d372507d5a806294af.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Muusikavideo",
    "genre": "Muusika/tantsu",
    "producer": "Elari Lend",
    "director": "Moonika Siimets",
    "peaosa": [
      {
        "actor": "Jörgen Liik",
        "playing": "Lembo"
      },
      {
        "actor": "Katre Kaseleht",
        "playing": "Liisu"
      },
      {
        "actor": "Indrek Taalmaa",
        "playing": "Isa Üllar"
      },
      {
        "actor": "Merle Jääger",
        "playing": "Ema Milvi"
      }
    ]
  },
  {
    "id": 16343,
    "title": "95",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16457/089b1d91fdc3bfc918763c4d7156665928477cab.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "KomöödiafilmŽanr: Noortefilm",
    "producer": "Martin Ruus",
    "director": "Hardi Keerutaja",
    "peaosa": [
      {
        "actor": "Jarmo Murumaa",
        "playing": "Poiss"
      }
    ]
  },
  {
    "id": 16344,
    "title": "Põud",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16458/0a8f7b3a617491cb2f4728821ef2ceb4e5547cb5.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Draama",
    "producer": "Margus Õunapuu",
    "director": "Ivar Murd",
    "peaosa": [
      {
        "actor": "Roland Laos",
        "playing": "Artur"
      },
      {
        "actor": "Gert Raudsep",
        "playing": "Thomas"
      },
      {
        "actor": "Katariina Tamm",
        "playing": "Maria"
      }
    ]
  },
  {
    "id": 16350,
    "title": "Tähetund",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16464/847b57da48377ea34cf32d237e05e6212e2b63ff.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Melodraama",
    "producer": "Jackel Chow",
    "director": "Marge Monko",
    "peaosa": [
      {
        "actor": "Eva Klemets",
        "playing": "Näitlejanna"
      },
      {
        "actor": "Indrek Ojari",
        "playing": "Kirjanik"
      },
      {
        "actor": "Toomas Täht",
        "playing": "Disainer"
      }
    ]
  },
  {
    "id": 16351,
    "title": "Peidetud sellesse filmi",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16465/19357c57e5501c92ae2173263c3e7b7733a25ec6.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Andero Tõnissoo",
    "director": "Jaan Penjam",
    "peaosa": [
      {
        "actor": "Sandra Z",
        "playing": "Laura"
      },
      {
        "actor": "Liis Lass",
        "playing": "Annika"
      },
      {
        "actor": "Ivo Uukkivi",
        "playing": "Kaspar"
      },
      {
        "actor": "Vallo Toomla",
        "playing": "Georg"
      }
    ]
  },
  {
    "id": 16352,
    "title": "Päikeseratas",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16466/54602a2f01866914e666ddc7ea77fe06ee113e72.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Elari Lend",
    "director": "Raigo Saariste",
    "peaosa": [
      {
        "actor": "Indrek Ojari",
        "playing": "Urmi"
      },
      {
        "actor": "Mikk Jürjens",
        "playing": "Ats"
      },
      {
        "actor": "Indrek Kruusimäe",
        "playing": "Rokkar"
      },
      {
        "actor": "Gert Urmet Uustani",
        "playing": "Väike poiss"
      },
      {
        "actor": "Märt Avandi",
        "playing": "Tööstur"
      },
      {
        "actor": "Katariina Kabel",
        "playing": "Tüdruk töösturi juures"
      },
      {
        "actor": "Ott Sepp",
        "playing": "Töösturi sõber"
      },
      {
        "actor": "Uku Uusberg",
        "playing": "Kristos"
      },
      {
        "actor": "Valera Volkov",
        "playing": "Kapten"
      }
    ]
  },
  {
    "id": 16353,
    "title": "Sireenid",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16467/4cd6fbbe0789dcb48b1762b590188c1ec674c029.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Draama",
    "producer": "Elari Lend",
    "director": "Kaur Kokk",
    "peaosa": [
      {
        "actor": "Ott Aardam",
        "playing": "Alexander"
      },
      {
        "actor": "Kristiina-Hortensia Port",
        "playing": "Mirjam"
      }
    ]
  },
  {
    "id": 16354,
    "title": "Paar tilka",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16468/96ede03583eb64f8c17c311e4dda8f9f1a93d8ad.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Lelde Prūse",
    "director": "Anna Kanska",
    "peaosa": [
      {
        "actor": "Ance Muižniece",
        "playing": "Dace"
      },
      {
        "actor": "Uldis Silinš",
        "playing": "Artūrs"
      },
      {
        "actor": "Madara Rutkēviča",
        "playing": "Īda (Dace hääl)"
      },
      {
        "actor": "Agnese Rutkēviča",
        "playing": "Aīda (Artūri hääl)"
      }
    ]
  },
  {
    "id": 16355,
    "title": "Slava",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16471/d7931f5d81d0ef338cd04e19bc7dcd2789b1fa5b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Ivan Pavljutškov",
    "director": "Ivan Pavljutškov",
    "peaosa": [
      {
        "actor": "Sergei Furmanjuk",
        "playing": "Slava"
      },
      {
        "actor": "Eva Ligi",
        "playing": "Tourist Girl"
      }
    ]
  },
  {
    "id": 16356,
    "title": "The Great Hike",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16472/2a35ecc09b2d9dd5ce8e8ee0ee6193d7cde217f7.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Yue Dawei, Pengjunqi",
    "director": "Andrew Bond",
    "peaosa": [
      {
        "actor": "Wang Ge",
        "playing": "Wang Hu"
      }
    ]
  },
  {
    "id": 16370,
    "title": "Üleastumine",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16488/a5adc2b930e5cf38359a4c387e3202adff641fd0.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "PõnevusfilmŽanr: Draama",
    "producer": "Reinis Kalvinš, Kristofer Piir",
    "director": "Oscar Henri Wollsten",
    "peaosa": [
      {
        "actor": "Tanel Saar",
        "playing": "Jasper"
      },
      {
        "actor": "Andrus Vaarik",
        "playing": "Isa"
      },
      {
        "actor": "Elina Pähklimägi",
        "playing": "Kadri"
      },
      {
        "actor": "Tõnu Oja",
        "playing": "Prohvet"
      }
    ]
  },
  {
    "id": 16371,
    "title": "Väljakutse",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16489/0814cbe956f05b65ee91f8fdffe2820841326fda.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Keiti Väliste",
    "director": "Marleen Roosna",
    "peaosa": [
      {
        "actor": "Rasmus Kaljujärv",
        "playing": "Rass"
      },
      {
        "actor": "Liis Lass",
        "playing": "Noora"
      },
      {
        "actor": "Joonas Paas",
        "playing": "Viktor"
      }
    ]
  },
  {
    "id": 16372,
    "title": "Õnne Manifest",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16490/14972981fad2510e68f49ab7cbe8ad3fdb592e4a.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kaspar Ainelo",
    "director": "Anna Hints",
    "peaosa": [
      {
        "actor": "Jekaterina Zakilova",
        "playing": "Õnne"
      },
      {
        "actor": "Rita Rätsepp",
        "playing": "Ema"
      },
      {
        "actor": "Toomas Tross",
        "playing": "Isa"
      }
    ]
  },
  {
    "id": 16373,
    "title": "Sellouts",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16491/a6104cb96105d4358aec7e99c0fc1c999cfbb143.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Natalia Ivanova",
    "director": "Aleksandr Rachynskyi",
    "peaosa": [
      {
        "actor": "Jana Levitina",
        "playing": "Jana"
      },
      {
        "actor": "Ruslan Bõkov",
        "playing": "Ruslan"
      },
      {
        "actor": "Juri Novikov",
        "playing": "Jurban"
      },
      {
        "actor": "Juri Lutsep",
        "playing": "Batman"
      }
    ]
  },
  {
    "id": 16374,
    "title": "Kolm",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16492/78cb45819d852bd3f90659f94a14554ae83551b3.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Liina Tiido",
    "director": "Eva Kübar",
    "peaosa": [
      {
        "actor": "Maarja Mitt",
        "playing": "Kristiina"
      }
    ]
  },
  {
    "id": 16375,
    "title": "Süütu",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16493/aaa3acf40c7cf47550a3e1bfd579ba4d97f12539.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Liina Tiido",
    "director": "Heinrich Sepp",
    "peaosa": [
      {
        "actor": "Mairen  Mangusson",
        "playing": "Magda"
      },
      {
        "actor": "Raivo E. Tamm",
        "playing": "Preester"
      }
    ]
  },
  {
    "id": 16376,
    "title": "Peaosa",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16495/1bc22aa0f165ee9dce38535da5d472faf94142dc.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Eepiline/ajalooline film",
    "producer": "Eva-Kristina Mill",
    "director": "Doris Tääker",
    "peaosa": [
      {
        "actor": "Jaanika Arum",
        "playing": "Marleen"
      },
      {
        "actor": "Hendrik Toompere jr jr",
        "playing": "Miikael"
      },
      {
        "actor": "Üllar Saaremäe",
        "playing": "Meister"
      }
    ]
  },
  {
    "id": 16390,
    "title": "Diana ja linn",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16513/b0f6f5d2905f77789933b08d0b211753727480cb.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Tõnis Hiiesalu",
    "director": "Triin Ruumet",
    "peaosa": [
      {
        "actor": "Kaisa Selde",
        "playing": "Diana"
      },
      {
        "actor": "Piret Krumm",
        "playing": "Tiina"
      },
      {
        "actor": "Mart Tartlan",
        "playing": "Juhataja"
      },
      {
        "actor": "Kristjan Tenso",
        "playing": "Nooruk"
      }
    ]
  },
  {
    "id": 16395,
    "title": "Viimane buss",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16518/1a26402dbdb4558c98c660244399401cf41d5d4a.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Gretlyn Palberg",
    "director": "Eik Tammemäe",
    "peaosa": [
      {
        "actor": "Valter Saaliste",
        "playing": "Peaosatäitja"
      },
      {
        "actor": "Margus Raid",
        "playing": "Sõber"
      },
      {
        "actor": "Allan Kress",
        "playing": "Turvamees"
      },
      {
        "actor": "Erlyn Palberg",
        "playing": "Turvanaine"
      }
    ]
  },
  {
    "id": 16403,
    "title": "Tasuja",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16526/2118576497ea252e08aa7c48dd4d84d53a557beb.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Frank Normet",
    "director": "Karl-Jonatan Karits",
    "peaosa": [
      {
        "actor": "Priit Strandberg",
        "playing": "Martin Pajusalu"
      },
      {
        "actor": "Märt Pius",
        "playing": "Robert Nool"
      },
      {
        "actor": "Maiken Schmidt",
        "playing": "Kadri Jõesuu"
      },
      {
        "actor": "Peeter Kaljumäe",
        "playing": "Kalju"
      },
      {
        "actor": "Gert Raudsep",
        "playing": "Toomas Kruus"
      },
      {
        "actor": "Lauri-Kare Laos",
        "playing": "Viktor Zaitsev"
      },
      {
        "actor": "Evelin Võigemast",
        "playing": "Anneli Õissaar"
      },
      {
        "actor": "Henri Nõmm",
        "playing": "Põld"
      }
    ]
  },
  {
    "id": 16411,
    "title": "Mälestus armastusest",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16534/f61bc29758fcd3e232b9940793b345d8a55c928f.JPG",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Muusika/tantsu",
    "producer": "Jackel Chow",
    "director": "Jackel Chow",
    "peaosa": [
      {
        "actor": "Peter Lin",
        "playing": "Simon Low"
      },
      {
        "actor": "Jasmine Gong",
        "playing": "Mysterious girl"
      }
    ]
  },
  {
    "id": 16424,
    "title": "Olga",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16547/c2c05989bf2d65bac3f3ce8328b7846c738c92f2.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Esko Rips",
    "director": "Kaur Kokk",
    "peaosa": [
      {
        "actor": "Svetlana Dorošenko",
        "playing": "Olga"
      },
      {
        "actor": "Raivo Rüütel",
        "playing": "Joel"
      }
    ]
  },
  {
    "id": 16425,
    "title": "Tupsu",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16548/783048f9af04a0ab9895cb06751d3639e3504900.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Tõnis Hiiesalu",
    "director": "Triin Ruumet",
    "peaosa": [
      {
        "actor": "Andrei Jakovlev",
        "playing": "Andrei"
      },
      {
        "actor": "Oliver Soomets",
        "playing": "Oliver"
      },
      {
        "actor": "Joosep Jürgenson",
        "playing": "Valeri"
      },
      {
        "actor": "Bianca Jakovlev",
        "playing": "Nastja"
      }
    ]
  },
  {
    "id": 16436,
    "title": "Äge",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16559/b61f72d248974c3fa9f65f6a92d033a13298b3f9.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Rainer Kala",
    "director": "Rein  Zobel",
    "peaosa": [
      {
        "actor": "Karl Gregor Kool",
        "playing": "Murat"
      }
    ]
  },
  {
    "id": 16437,
    "title": "Külaline",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16560/3c0e83f1802831a2fc3f401c80a0f85a4b8d70bb.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Karolina Veetamm",
    "director": "Erik Hans Sepp",
    "peaosa": [
      {
        "actor": "Elina Reinold",
        "playing": "Vilma"
      },
      {
        "actor": "Andero Ermel",
        "playing": "Vanem Josef"
      },
      {
        "actor": "Tõnu Tamm",
        "playing": "Noorem Josef"
      }
    ]
  },
  {
    "id": 16440,
    "title": "Öö Teheranis",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16563/e16e97323ac6fc22c4acf4501311dd9f46f46503.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Oliver Rauam",
    "director": "Jürgen Volmer",
    "peaosa": [
      {
        "actor": "Jaune Kimmel",
        "playing": "Sille"
      },
      {
        "actor": "Emil Orub",
        "playing": "Tarmo"
      },
      {
        "actor": "Tarik Labrighli",
        "playing": "Tõmmu"
      }
    ]
  },
  {
    "id": 16441,
    "title": "Mask",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16564/da5879460a8f25b45f3578a0bf0e3e1cc427d315.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kalev Smidt",
    "director": "Kristiina  Tang",
    "peaosa": [
      {
        "actor": "Carmen Mikiver",
        "playing": "Ema"
      },
      {
        "actor": "Tiina Adamson",
        "playing": "Helen"
      }
    ]
  },
  {
    "id": 16476,
    "title": "Suurim austaja",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16599/ee97798aaae380d38a03087ff923adfa2a690900.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Põnevusfilm",
    "producer": "Kristina Hakk",
    "director": "Jürgen Moor",
    "peaosa": [
      {
        "actor": "Oliver Soomets",
        "playing": "Mees"
      },
      {
        "actor": "Ülle Lichtfeldt",
        "playing": "Grete Kaljuste"
      }
    ]
  },
  {
    "id": 16488,
    "title": "Jobu",
    "year": "2008",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16609/a25dfe8f66bcefcdb83d1de6c42c3b847f39dbcf.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Draama",
    "producer": "Taavi Immato, Marita Mones",
    "director": "Taavi Immato, Marita Mones",
    "peaosa": [
      {
        "actor": "Taavi Immato",
        "playing": "Poiss"
      },
      {
        "actor": "Jüri  Nael",
        "playing": "Mees"
      },
      {
        "actor": "Epp Immato",
        "playing": "Naine"
      },
      {
        "actor": "Maria Butajeva",
        "playing": "Tüdruk"
      }
    ]
  },
  {
    "id": 16502,
    "title": "Lillemüüja",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16623/d25fa590301dd84608c53454780ac5d31876eea0.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Draama",
    "producer": "Jevgeni Bõstrov",
    "director": "Jevgeni Bõstrov",
    "peaosa": [
      {
        "actor": "Semjon Pripetško",
        "playing": "Semjon"
      },
      {
        "actor": "Olga Grišina",
        "playing": "Veronica"
      }
    ]
  },
  {
    "id": 16613,
    "title": "Hiis",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16734/44f02631eda9f91724c1bdb55fd845a0a373ebce.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Hanne-Loore Pajusoo",
    "director": "Nele Kirsipuu",
    "peaosa": [
      {
        "actor": "Siim Püvi",
        "playing": "Poiss"
      },
      {
        "actor": "Maris Nõlvak",
        "playing": "Hiieneitsi"
      }
    ]
  },
  {
    "id": 16614,
    "title": "Tallinna Ülikooli reklaam",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16735/f80bd38b96f850d46b54f9632b9369672bc4e3b4.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "",
    "producer": "Elis Rebbas",
    "director": "Sigrid Reede",
    "peaosa": [
      {
        "actor": "Andres Eran",
        "playing": "Isa"
      },
      {
        "actor": "Priit Pobbul",
        "playing": "Poeg"
      },
      {
        "actor": "Margus Kruusvall",
        "playing": "Onu"
      }
    ]
  },
  {
    "id": 16616,
    "title": "Kaardimaja",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16737/705f6f28e50909d7d2022deb38bf7d0fb9173b4a.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Tiiu-Ann Pello, Hendrik Mägar, Kristjan Pütsep",
    "director": "Carlos Eduardo Lesmes Lopéz",
    "peaosa": [
      {
        "actor": "Priit Pius",
        "playing": "Mart"
      },
      {
        "actor": "Pääru Oja",
        "playing": "Luukas"
      },
      {
        "actor": "Liis Lass",
        "playing": "Kayla"
      },
      {
        "actor": "Raivo E. Tamm",
        "playing": "Karl"
      },
      {
        "actor": "Villu Kangur",
        "playing": "Björn"
      }
    ]
  },
  {
    "id": 16618,
    "title": "Säde",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16739/d657fe16b6174e0b0f5ff7383628982b080fd847.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Veli Valentin Rajasaar",
    "director": "Indrek Kaine",
    "peaosa": [
      {
        "actor": "Artur Tedremägi",
        "playing": "Joel"
      },
      {
        "actor": "Mait Joorits",
        "playing": "Tanel"
      },
      {
        "actor": "Liisi Rohtung",
        "playing": "Eleri"
      },
      {
        "actor": "Ave Vellesalu",
        "playing": "Kristel"
      }
    ]
  },
  {
    "id": 16645,
    "title": "Öine vahetus",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16767/f64ef96e633e0b0fdc23005f37be7be5ba40f8c3.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Anni Aguraijuja",
    "director": "Janis Rižovs",
    "peaosa": [
      {
        "actor": "Klaudia Tiitsmaa",
        "playing": "Marya"
      },
      {
        "actor": "Ivo Uukkivi",
        "playing": "Pawel"
      },
      {
        "actor": "Liis-Katrin Avandi",
        "playing": "Anna"
      }
    ]
  },
  {
    "id": 16646,
    "title": "Õnneliku lõpuga massaaž",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16768/937e2278aec8e807ec0c84d77aa1387e3af2d95d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Keiti Väliste",
    "director": "Janar Aronija",
    "peaosa": [
      {
        "actor": "Mart Müürisepp",
        "playing": "Massöör"
      },
      {
        "actor": "Raivo E. Tamm",
        "playing": "Mees"
      },
      {
        "actor": "Karin Rask",
        "playing": "Naine"
      }
    ]
  },
  {
    "id": 16651,
    "title": "Kolmas",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16773/351ee1515a40489da3c8257c5794fe121e4f5e3b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "",
    "producer": "Anni Aguraijuja",
    "director": "Maria Reinup",
    "peaosa": [
      {
        "actor": "Madis Kats",
        "playing": "Poiss"
      },
      {
        "actor": "Kairit Krass",
        "playing": "Tüdruk"
      }
    ]
  },
  {
    "id": 16663,
    "title": "Maja, mis peegeldab ajalugu",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16785/d2261dcb14a0b81b8f1943bb75773a77ca27b9a4.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "",
    "producer": "Veli Valentin Rajasaar",
    "director": "Doris Tääker",
    "peaosa": [
      {
        "actor": "Helene  Vannari",
        "playing": "Koristaja"
      }
    ]
  },
  {
    "id": 16666,
    "title": "Õhuloss",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16788/b19115e5e458f0561b40fabe37a0b154d5892b6c.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "",
    "producer": "Keiti Väliste",
    "director": "Marleen Roosna",
    "peaosa": [
      {
        "actor": "Gustav Kõrvits",
        "playing": "Väike poiss"
      }
    ]
  },
  {
    "id": 16668,
    "title": "Kell peatus 6.30",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16790/4704604a8e6c391ea9d92307f8f6ceaf9bf99418.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Liva Vilnite",
    "director": "Liva Vilnite",
    "peaosa": [
      {
        "actor": "Grieta Sipola",
        "playing": "Emily"
      }
    ]
  },
  {
    "id": 16670,
    "title": "16 trepisammu",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16792/02011e28eb043549b9f6f2c34cccfe41caeebee0.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Draama",
    "producer": "Adele Thele Kuusk",
    "director": "Adele Thele Kuusk",
    "peaosa": [
      {
        "actor": "Tõnis Peeter Kull",
        "playing": "Markus"
      },
      {
        "actor": "Einar Kuusk",
        "playing": "Ivar"
      }
    ]
  },
  {
    "id": 16671,
    "title": "Ainult surm ootab...",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16793/75983be19e941032818a664d66cfcc636fb462af.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "",
    "producer": "Kristen Kivistik",
    "director": "Adrian  Ormaechea Leache",
    "peaosa": [
      {
        "actor": "Oskar Pruul",
        "playing": "Poiss"
      },
      {
        "actor": "Taaniel Tooming",
        "playing": "Surm"
      }
    ]
  },
  {
    "id": 16680,
    "title": "Jaani öö",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16802/88d45a1ea9cc64e3a9225d2513c0108ae13d788f.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Ingrid Hübscher",
    "director": "Ingrid Hübscher",
    "peaosa": [
      {
        "actor": "Martin Veinmann",
        "playing": "Jaan"
      }
    ]
  },
  {
    "id": 16681,
    "title": "Lase rong läbi",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16803/4b8275773278d721809c509e196357dd90427065.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "",
    "producer": "Madeleine Rodriguez",
    "director": "Lidiia Biriukova",
    "peaosa": [
      {
        "actor": "Anders-Patrick Takkis",
        "playing": "Poiss"
      }
    ]
  },
  {
    "id": 16687,
    "title": "Ema. Miljonite nimel",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16809/ceb282c314eb05993f8b0162497f297cabd57db4.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Eepiline/ajalooline film",
    "producer": "Vyacheslav (Slavik) Bihun, Veli Valentin Rajasaar, Yuriy Chyzhmar",
    "director": "Vyacheslav (Slavik) Bihun",
    "peaosa": [
      {
        "actor": "Lesia Lypchuk",
        "playing": "Ema"
      },
      {
        "actor": "Alexander Ivashkevich",
        "playing": "Vana poeg"
      }
    ]
  },
  {
    "id": 16692,
    "title": "Korduma kippuvad küsimused_1",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16814/a7f4d96c352a923d2a7e0ed298958834a3b4974a.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "",
    "producer": "Julia  Shelepkova, Grete Nellis, Enrico Barone",
    "director": "Enrico Barone",
    "peaosa": [
      {
        "actor": "Tomas Mikael",
        "playing": "Dirigent"
      }
    ]
  },
  {
    "id": 16693,
    "title": "Korduma kippuvad küsimused_2",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16815/c835c3bb367c72dd14bcd24d4f8f68f4fcae6684.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "",
    "producer": "Julia  Shelepkova, Grete Nellis, Enrico Barone",
    "director": "Enrico Barone",
    "peaosa": [
      {
        "actor": "Natalja Tregubova",
        "playing": "Sekretär"
      },
      {
        "actor": "Emma Lipasti",
        "playing": "Sekretär"
      },
      {
        "actor": "Marina Pushkar",
        "playing": "Ema"
      },
      {
        "actor": "Bianca Pushkar",
        "playing": "Tütar"
      },
      {
        "actor": "Tomas Mikael",
        "playing": "Poiss"
      },
      {
        "actor": "Petra-Emilia Toivinen",
        "playing": "Tüdruk"
      }
    ]
  },
  {
    "id": 16694,
    "title": "Korduma kippuvad küsimused_3",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16816/da5b1558201364c8247531293f661ec3c85686eb.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "",
    "producer": "Julia  Shelepkova, Grete Nellis, Enrico Barone",
    "director": "Enrico Barone",
    "peaosa": [
      {
        "actor": "Julia  Shelepkova",
        "playing": "Naine sõrmusega"
      },
      {
        "actor": "Natalja Tregubova",
        "playing": "Naine kõrgete kontsadega"
      },
      {
        "actor": "Tomas Mikael",
        "playing": "Mees"
      },
      {
        "actor": "Nadja Girich",
        "playing": "Jooksev naine"
      },
      {
        "actor": "Kaarel Tiidus",
        "playing": "Suitsetav mees"
      }
    ]
  },
  {
    "id": 16695,
    "title": "Chateau D'Ivre",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16817/e95177249d31672eca63f4ed8e98d2fb2acfe0a4.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "",
    "producer": "Andri Peetso",
    "director": "Rainer Helin",
    "peaosa": [
      {
        "actor": "Andres Tabun",
        "playing": "Mees"
      },
      {
        "actor": "Kiiri Tamm",
        "playing": "Naine"
      }
    ]
  },
  {
    "id": 16698,
    "title": "Reiki müsteerium",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16820/d5c2f47a992257e75c1d9a5230df1a893c8686f8.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Tatjana Kosminskaja, Sigrid Reede",
    "director": "Sigrid Reede",
    "peaosa": [
      {
        "actor": "Kristine Beitika",
        "playing": "Marta"
      },
      {
        "actor": "Aivar Hunt",
        "playing": "Poiss korterist"
      },
      {
        "actor": "Sulev Võrno",
        "playing": "Reiki Meister"
      }
    ]
  },
  {
    "id": 16700,
    "title": "Tallinna Ülikooli reklaam - Soome",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16822/e94f20b38f41d22c08bd11e682c06bbd3184e0b6.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "",
    "producer": "Kristofer Piir",
    "director": "Marleen Roosna",
    "peaosa": [
      {
        "actor": "Peeter Kaljumäe",
        "playing": "Isa"
      },
      {
        "actor": "Simo Andre Kadastu",
        "playing": "Poeg"
      },
      {
        "actor": "Gunnar Jaanovits",
        "playing": "Onu"
      }
    ]
  },
  {
    "id": 16703,
    "title": "Ta võttis pudeli, aga jättis tüdruku",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16825/e0fb89fa914553027cee026522258af5fe74e526.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "PõnevusfilmŽanr: Draama",
    "producer": "Kristofer Piir, Reinis Kalvinš",
    "director": "Reinis Kalvinš",
    "peaosa": [
      {
        "actor": "Toms  Liepājnieks",
        "playing": "Toms"
      },
      {
        "actor": "Madara Botmane",
        "playing": "Marina"
      },
      {
        "actor": "Lauma Balode",
        "playing": "Ieva"
      },
      {
        "actor": "Martinš Meiers",
        "playing": "Karlis"
      }
    ]
  },
  {
    "id": 16704,
    "title": "Kaasaegne ooper",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16826/f19d15805a29c890c4a4705ffb3395bc6a80be1a.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "Komöödiafilm",
    "producer": "Kadri Penjam",
    "director": "Kadri Penjam",
    "peaosa": [
      {
        "actor": "Raiko Suits",
        "playing": "Role"
      }
    ]
  },
  {
    "id": 16709,
    "title": "E-Riigi Akadeemia reklaam",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16831/485a45be6d0710826d6c1c92b21cba69711b8bb9.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "",
    "producer": "Jaan Kristjan Utno, Mairi Sõelsepp",
    "director": "Kristjan Neufeld",
    "peaosa": [
      {
        "actor": "Ireene Kanep",
        "playing": "Vanaema"
      },
      {
        "actor": "Thomas Kolli",
        "playing": "Isa"
      },
      {
        "actor": "Aia Kokk",
        "playing": "Ema"
      },
      {
        "actor": "Merike Liiva",
        "playing": "Tütar"
      }
    ]
  },
  {
    "id": 16710,
    "title": "Noa",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16832/6889b9cf4084c13faca7e677bbdf1efd08df0e13.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Liis Milk",
    "director": "Jaanus Lensment",
    "peaosa": [
      {
        "actor": "Kristiine Truu",
        "playing": "Dr Hera"
      }
    ]
  },
  {
    "id": 16725,
    "title": "Minetus",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16847/8e833a685da4758d6a513828f7420298683c6cbb.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Tuuliki Tedre-Orgjõe, Martin Haljaste",
    "director": "Martin Haljaste",
    "peaosa": [
      {
        "actor": "Simeoni Sundja",
        "playing": "Mattias"
      },
      {
        "actor": "Allan Kress",
        "playing": "Mr Braun"
      },
      {
        "actor": "Marian Heinat",
        "playing": "Anna"
      }
    ]
  },
  {
    "id": 16730,
    "title": "Hoia raudteelt eemale",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16852/99c6db9b40805d13ebf29412795d390c8a926b15.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "",
    "producer": "Victor Forest",
    "director": "Victor Forest",
    "peaosa": [
      {
        "actor": "Torm Toomas Täht",
        "playing": "Väike poiss"
      },
      {
        "actor": "Amelie Kubi",
        "playing": "Väike tüdruk"
      }
    ]
  },
  {
    "id": 16731,
    "title": "Turvalisus on valik",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16853/170998b9edaa7c0cc8c406f2fe51e6041cf6ec4d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "",
    "producer": "Vladislav Mukovnin, Jennifer Scholz",
    "director": "Vladislav Mukovnin",
    "peaosa": [
      {
        "actor": "Mattias Koit",
        "playing": "Poiss"
      }
    ]
  },
  {
    "id": 16734,
    "title": "Juuksekoguja",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16856/28b4bb2e8feda21f8aaeb6935fb4fc87c98d6b57.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Põnevusfilm",
    "producer": "Darta Putnina",
    "director": "Sigrid Reede",
    "peaosa": [
      {
        "actor": "Aivar Hunt",
        "playing": "Mees"
      },
      {
        "actor": "Janela Lääne",
        "playing": "Naine"
      },
      {
        "actor": "Darta Putnina",
        "playing": "Ettekandja"
      }
    ]
  },
  {
    "id": 16735,
    "title": "SMS armastus",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/16857/0b0355e009480d457c37be12b78ee1c1b0560083.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Sigrid Reede, Elis Rebbas",
    "director": "Sigrid Reede",
    "peaosa": [
      {
        "actor": "Andri Pääbus",
        "playing": "Noormees"
      },
      {
        "actor": "Elis Rebbas",
        "playing": "Tütarlaps"
      }
    ]
  },
  {
    "id": 16895,
    "title": "Vesper Leand - Clay",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17017/b48d728456e828dd051d00a1e47f9f51fd29fca3.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Muusikavideo",
    "genre": "Draama",
    "producer": "Kristi Prik",
    "director": "Maxim Filatov",
    "peaosa": [
      {
        "actor": "Erik Vent",
        "playing": "Poeg"
      },
      {
        "actor": "Allan Kress",
        "playing": "Isa"
      }
    ]
  },
  {
    "id": 16909,
    "title": "See õige",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17031/df124724735d08fa6e310400ccab0d3ab7d45d21.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Elari Lend",
    "director": "Ivan Pavljutškov",
    "peaosa": [
      {
        "actor": "Mart Toome",
        "playing": "Ivari"
      },
      {
        "actor": "Marin Mägi-Efert",
        "playing": "Emma"
      }
    ]
  },
  {
    "id": 16913,
    "title": "Kultuur elab siin",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17035/8e3823809b53bc080df13f5765f292a85cf208a1.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "",
    "producer": "Jenna James Jylhä",
    "director": "Rihards Bereza",
    "peaosa": [
      {
        "actor": "Kaisa Kattai",
        "playing": "Tantsija"
      },
      {
        "actor": "Aleksandra Kirikal",
        "playing": "Viiulimängija"
      },
      {
        "actor": "Joao Polido Gomes",
        "playing": "Rulasõitja"
      },
      {
        "actor": "Karl Tipp",
        "playing": "Saksofonimängija"
      }
    ]
  },
  {
    "id": 16916,
    "title": "Tõrv ja Sulg",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17038/44873f342241f66b4f226e5d5785604edc177323.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Rainer Kala",
    "director": "Jon-Arnold Mikiver",
    "peaosa": [
      {
        "actor": "Janek Vadi",
        "playing": "Herbert"
      },
      {
        "actor": "Peeter Kaljumäe",
        "playing": "Arst"
      },
      {
        "actor": "Marilyn Jurman",
        "playing": "Tuuli"
      },
      {
        "actor": "Mart Madiste",
        "playing": "Kanamees"
      }
    ]
  },
  {
    "id": 16919,
    "title": "Tosin küsimust Eesti kohta: Vältimatu",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17041/4a60f553452a083306a745df711de48b5d20f62b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Veli Valentin Rajasaar, Kalev Smidt, Rainer Kala, Karolina Veetamm, Kristina Hakk, Andreas Kask, Anni Aguraijuja",
    "director": "Kristiina  Tang",
    "peaosa": [
      {
        "actor": "Tarik Labrighli",
        "playing": "Omar"
      },
      {
        "actor": "Tarmo Laur",
        "playing": "Jaan"
      },
      {
        "actor": "Helvin Kaljula",
        "playing": "Toomas"
      }
    ]
  },
  {
    "id": 16920,
    "title": "Tosin küsimust Eesti kohta: Laulu teekond",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17042/dc5614f642fade344993f2a92502a0a0f2d698d3.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Eepiline/ajalooline filmŽanr: Draama",
    "producer": "Veli Valentin Rajasaar, Kalev Smidt, Rainer Kala, Karolina Veetamm, Kristina Hakk, Andreas Kask, Anni Aguraijuja",
    "director": "Jürgen Volmer",
    "peaosa": [
      {
        "actor": "Tõnu Oja",
        "playing": "Peremees Ants"
      },
      {
        "actor": "Jarmo Reha",
        "playing": "Noorperemees Andres"
      },
      {
        "actor": "Ester Kuntu",
        "playing": "Naabertalu Siiri"
      },
      {
        "actor": "Saara Nüganen",
        "playing": "Jõeotsa Viivi"
      }
    ]
  },
  {
    "id": 16921,
    "title": "Tosin küsimust Eesti kohta: Eesti kuningas",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17043/0879a97b00f33e2bd2d27b727d62fa7017fcd90c.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Veli Valentin Rajasaar, Kalev Smidt, Rainer Kala, Karolina Veetamm, Kristina Hakk, Andreas Kask, Anni Aguraijuja",
    "director": "Rein  Zobel",
    "peaosa": [
      {
        "actor": "Indrek Taalmaa",
        "playing": "Kõrtsmik"
      },
      {
        "actor": "Rauno Polman",
        "playing": "Rändur"
      },
      {
        "actor": "Mart Müürisepp",
        "playing": "Eesti kuningas"
      },
      {
        "actor": "Maldar-Mikk Kuusk",
        "playing": "Eesti kuningas"
      },
      {
        "actor": "Einar Maarits",
        "playing": "Eesti kuningas"
      },
      {
        "actor": "Anti Radik",
        "playing": "Eesti kuningas"
      },
      {
        "actor": "Peter Kegel",
        "playing": "Valdemar II"
      }
    ]
  },
  {
    "id": 16922,
    "title": "Tosin küsimust Eesti kohta: Igor",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17044/aa892892172bc5c6086fb94afa1ce13bfbdf889b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Veli Valentin Rajasaar, Kalev Smidt, Rainer Kala, Karolina Veetamm, Kristina Hakk, Andreas Kask, Anni Aguraijuja",
    "director": "Janis Rižovs",
    "peaosa": [
      {
        "actor": "Oleg Želudkov",
        "playing": "Igor"
      },
      {
        "actor": "Tiiu Kruus",
        "playing": "Tädi 1"
      },
      {
        "actor": "Elvi-Adele Peedu",
        "playing": "Tädi 2"
      }
    ]
  },
  {
    "id": 16923,
    "title": "Tosin küsimust Eesti kohta: Ülemiste Vanake",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17045/04cd8c36d5961ac2bf82bbde0971ab810497b02d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Veli Valentin Rajasaar, Kalev Smidt, Rainer Kala, Karolina Veetamm, Kristina Hakk, Andreas Kask, Anni Aguraijuja",
    "director": "Jürgen Moor",
    "peaosa": [
      {
        "actor": "Indrek Lukso",
        "playing": "Ülemiste Vanake"
      },
      {
        "actor": "Indrek Ojari",
        "playing": "Ülemiste Vanakese hääl"
      },
      {
        "actor": "Piret Järvis",
        "playing": "Intervjueerija"
      },
      {
        "actor": "Kalev Smidt",
        "playing": "Jutustaja"
      }
    ]
  },
  {
    "id": 16924,
    "title": "Tosin küsimust Eesti kohta: Kas Eestis elavad jääkarud?",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17046/f9c0f973b41593797f285c4033d8ce93ff4159d8.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Veli Valentin Rajasaar, Kalev Smidt, Rainer Kala, Karolina Veetamm, Kristina Hakk, Anni Aguraijuja",
    "director": "Kristiina  Tang",
    "peaosa": [
      {
        "actor": "Marianne Leheroo",
        "playing": "Liis"
      },
      {
        "actor": "Mariette Leheroo",
        "playing": "Liis"
      },
      {
        "actor": "Ever Siitam",
        "playing": "Kassu"
      },
      {
        "actor": "Heinar Loosaar",
        "playing": "Jõuluvana"
      }
    ]
  },
  {
    "id": 16925,
    "title": "Tosin küsimust Eesti kohta: Kaali",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17047/34637ff1750b2a2abbadcc5ba0dbd758f3b55db4.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Veli Valentin Rajasaar, Kalev Smidt, Rainer Kala, Karolina Veetamm, Kristina Hakk, Andreas Kask, Anni Aguraijuja",
    "director": "Gabriel Motta-Ferreira",
    "peaosa": [
      {
        "actor": "Mauri Liiv",
        "playing": "Martin"
      },
      {
        "actor": "Laura Peterson",
        "playing": "Liisa"
      },
      {
        "actor": "Roman Maksimuk",
        "playing": "Hõimu mees"
      },
      {
        "actor": "Annie Banchina",
        "playing": "Hõimu naine"
      },
      {
        "actor": "Dayvid Nightvid",
        "playing": "Balazs"
      }
    ]
  },
  {
    "id": 16926,
    "title": "Tosin küsimust Eesti kohta: Pööripäev",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17048/06e81d5400a06e3a6c1c02853dd78ac79cb3193e.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Veli Valentin Rajasaar, Kalev Smidt, Rainer Kala, Karolina Veetamm, Kristina Hakk, Andreas Kask, Anni Aguraijuja",
    "director": "Janis Rižovs",
    "peaosa": [
      {
        "actor": "Rain Tolk",
        "playing": "Priit"
      },
      {
        "actor": "Mari Abel",
        "playing": "Evelin"
      }
    ]
  },
  {
    "id": 16927,
    "title": "Tosin küsimust Eesti kohta: Millesse eestlased usuvad?",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17049/1a01afe900f8a5b4c5fefbe215a9627a2c3476aa.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Veli Valentin Rajasaar, Kalev Smidt, Rainer Kala, Karolina Veetamm, Kristina Hakk, Andreas Kask, Anni Aguraijuja",
    "director": "Indrek Kaine",
    "peaosa": [
      {
        "actor": "Margus Prangel",
        "playing": "Isa"
      },
      {
        "actor": "Jekaterina Kordas",
        "playing": "Ema"
      },
      {
        "actor": "Marc-Daniel Paul",
        "playing": "Poeg"
      },
      {
        "actor": "Getter Keres",
        "playing": "Tütar"
      }
    ]
  },
  {
    "id": 16928,
    "title": "Tosin küsimust Eesti kohta: Error",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17050/e53eb06d62012ded68a5a394eb4d304f7205011c.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Karolina Veetamm, Veli Valentin Rajasaar, Kristina Hakk, Kalev Smidt, Rainer Kala, Andreas Kask, Anni Aguraijuja",
    "director": "Joosep Ehasalu",
    "peaosa": [
      {
        "actor": "Tõnis Jürgens",
        "playing": "Priit"
      },
      {
        "actor": "Katariina Tamm",
        "playing": "Brita"
      },
      {
        "actor": "Karl Annus",
        "playing": "Sorts"
      }
    ]
  },
  {
    "id": 16929,
    "title": "Tosin küsimust Eesti kohta: Koit",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17051/883e2db09afe3b73d2b15a6540377c697d4b0290.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Veli Valentin Rajasaar, Kalev Smidt, Rainer Kala, Karolina Veetamm, Kristina Hakk, Andreas Kask, Anni Aguraijuja",
    "director": "Giampietro Balia",
    "peaosa": [
      {
        "actor": "Tõnis Mägi",
        "playing": "Toomas"
      },
      {
        "actor": "Martin Markii",
        "playing": "Mees 1"
      },
      {
        "actor": "Alvar Haav",
        "playing": "Mees 2 (kitarriga)"
      },
      {
        "actor": "Sebastian Talmar",
        "playing": "Mees 3"
      },
      {
        "actor": "Andres Reinart",
        "playing": "Mees 4"
      },
      {
        "actor": "Tarmo Laur",
        "playing": "Mees 5"
      },
      {
        "actor": "Tarmo Haav",
        "playing": "Liider"
      }
    ]
  },
  {
    "id": 16930,
    "title": "Tosin küsimust Eesti kohta: Oleme pilves",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17052/5d02cd45785a2b4fe42d4327ab3d41393753fa35.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Veli Valentin Rajasaar, Kalev Smidt, Rainer Kala, Karolina Veetamm, Kristina Hakk, Andreas Kask, Anni Aguraijuja",
    "director": "Andri Allas",
    "peaosa": [
      {
        "actor": "Kristo Viiding",
        "playing": "Juhataja"
      },
      {
        "actor": "Kadri Sammel",
        "playing": "Neiu pilves"
      },
      {
        "actor": "Indrek Mesikäpp",
        "playing": "Noormees pilves"
      }
    ]
  },
  {
    "id": 16934,
    "title": "Mineviku reaalsus",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17056/0433ab0d80b8312bdbfdae263154639c0795f546.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Draama",
    "producer": "Erik Pree",
    "director": "Moona-Liisa Mänd, Siim Škepast",
    "peaosa": [
      {
        "actor": "Meelis Holsting",
        "playing": "Ants"
      },
      {
        "actor": "Priit Saareleht",
        "playing": "Andrei"
      },
      {
        "actor": "Erik Pree",
        "playing": "Noor Ants"
      },
      {
        "actor": "Krister Mattias Nõu",
        "playing": "Noor Andrei"
      }
    ]
  },
  {
    "id": 16937,
    "title": "Ootamatu",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17059/abf5fd7eaf52326ce2791833c3d4f4b32ee20f00.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "PõnevusfilmŽanr: Draama",
    "producer": "Jackel Chow",
    "director": "Jackel Chow",
    "peaosa": [
      {
        "actor": "Artur Svorobovich",
        "playing": "Constantine"
      },
      {
        "actor": "Gabriele Malinauskaite",
        "playing": "Martina"
      },
      {
        "actor": "Ken Ahern Dayvid",
        "playing": "Intervjueerija"
      },
      {
        "actor": "Dayvid Nightvid",
        "playing": "Intervjueerija 2"
      },
      {
        "actor": "Tamilia Malika",
        "playing": "Intervjueerija 3"
      }
    ]
  },
  {
    "id": 16975,
    "title": "Bingo",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17097/c0fc89e619058f8ad2f6c6acf8cf232f3a22ae19.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Kristina Amor",
    "director": "Kristina Amor, Ramin Pourmand",
    "peaosa": [
      {
        "actor": "Annika Parv",
        "playing": "Naine"
      },
      {
        "actor": "Aare Vaida",
        "playing": "Lihunik"
      }
    ]
  },
  {
    "id": 16985,
    "title": "Punane kaabu",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17107/637152c32d440eb15ebc93b448bc4442b884b7d0.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kristi Luht",
    "director": "Marleen Moss",
    "peaosa": [
      {
        "actor": "Karl Saarits",
        "playing": "Poiss"
      },
      {
        "actor": "Sanna Karina Aab",
        "playing": "Ema"
      },
      {
        "actor": "Uku Talmar",
        "playing": "Isa"
      }
    ]
  },
  {
    "id": 16995,
    "title": "Teine maailm",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17117/2a0822bca543f13b797f5a1afc0408850379dec4.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kristen Kivistik, Karit Kohv",
    "director": "Saana Kuosa",
    "peaosa": [
      {
        "actor": "Rene Rumberg",
        "playing": "Aleksander"
      }
    ]
  },
  {
    "id": 17002,
    "title": "Hommikune hullus - William Must Hunt",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17124/96625ed6240524b27f55d762a2c47451ee40a1c9.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Muusikavideo",
    "genre": "",
    "producer": "Loore Jaanson",
    "director": "Madeleine Rodriguez",
    "peaosa": [
      {
        "actor": "Tõnis Aaliste",
        "playing": "Mees"
      },
      {
        "actor": "Sten Mikk",
        "playing": "Poiss"
      }
    ]
  },
  {
    "id": 17075,
    "title": "Sagedus",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17196/97ee80a6c81d0a195882b969ce589d684a219d75.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "",
    "producer": "Kadri Penjam",
    "director": "Liva Vilnite",
    "peaosa": [
      {
        "actor": "Aleksis Aleksandrs Vilnitis",
        "playing": "Alex"
      }
    ]
  },
  {
    "id": 17079,
    "title": "Parem elu",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17200/5d8c2c4c68318be8bbcfb1a458204ff624ebfade.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Draama",
    "producer": "Oscar Henri Wollsten",
    "director": "Oscar Henri Wollsten",
    "peaosa": [
      {
        "actor": "Tarvo Vridolin",
        "playing": "Ago Kukk"
      },
      {
        "actor": "Kaili Viidas",
        "playing": "Sara"
      }
    ]
  },
  {
    "id": 17089,
    "title": "Perekonnaõpetuse tund",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17210/12e149d37de313b7bd6b8dfa2a63c1c0b2fa0965.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "Komöödiafilm",
    "producer": "Hanna Martinson, Kadri Nikopensius, Karolin Kivimäe, Sandra Kattai",
    "director": "Kadri Nikopensius",
    "peaosa": [
      {
        "actor": "Galina Tikerpuu",
        "playing": "Õpetaja"
      }
    ]
  },
  {
    "id": 17090,
    "title": "Pidu ja laen",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17211/5128f0c1c383ff5cbb5fa69c365993dc5be686de.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "Komöödiafilm",
    "producer": "Kadri Nikopensius, Hanna Martinson, Karolin Kivimäe, Sandra Kattai",
    "director": "Hanna Martinson, Kadri Nikopensius",
    "peaosa": [
      {
        "actor": "Kaspar Rätsep",
        "playing": "Noormees"
      }
    ]
  },
  {
    "id": 17092,
    "title": "Disainimajakas",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17214/dc69a50e21ee0cdba0f98fda3e8ae580208a679a.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "",
    "producer": "Kalev Smidt",
    "director": "Janis Rižovs",
    "peaosa": [
      {
        "actor": "Liis Tamm",
        "playing": "Tüdruk"
      },
      {
        "actor": "Kaarel Valter",
        "playing": "Kalamees"
      }
    ]
  },
  {
    "id": 17097,
    "title": "Lõunavalgus",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17219/300463fa7333aeadc14ade99918f3c0d613af08b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "",
    "producer": "Liis Milk",
    "director": "Kairit Krass",
    "peaosa": [
      {
        "actor": "Ursula Ratasepp",
        "playing": "Ruth"
      }
    ]
  },
  {
    "id": 17120,
    "title": "Ahv, kes mängis Vene ruletti",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17242/8bf89440138275302a22bacfdf56fa5554caedcd.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kristo Jürmann",
    "director": "Margus Raid",
    "peaosa": [
      {
        "actor": "Ivo Uukkivi",
        "playing": "Erik"
      },
      {
        "actor": "Natalja Murina-Puustusmaa",
        "playing": "Sofia"
      }
    ]
  },
  {
    "id": 17161,
    "title": "Taavi Peterson - \"Story of Life\"",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17283/4660b050bf864f173e0f7e36a1e3dd48b9f7708d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Muusikavideo",
    "genre": "",
    "producer": "Kristen Kivistik",
    "director": "Saana Kuosa",
    "peaosa": [
      {
        "actor": "Mati Pebre",
        "playing": "Vanahärra"
      }
    ]
  },
  {
    "id": 17266,
    "title": "Müügimees",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17388/adf97040b9dee5bf10d961ec4b30c0dd6af8e205.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Kristen Kivistik",
    "director": "Johan Kudu",
    "peaosa": [
      {
        "actor": "Alo-Jarmo Küppas",
        "playing": "Müügimees"
      },
      {
        "actor": "Tormi Torop",
        "playing": "Maamees"
      }
    ]
  },
  {
    "id": 17276,
    "title": "Tankla",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17398/84b84b19f4f7539283d2bb61164982e988f2380e.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Kristen Kivistik",
    "director": "Johan Kudu",
    "peaosa": [
      {
        "actor": "Tormi Torop",
        "playing": "Röövel"
      },
      {
        "actor": "Rauno Kuusik",
        "playing": "Röövel"
      }
    ]
  },
  {
    "id": 17310,
    "title": "Mees majast",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17432/5caebf37551dd487516800881b335ca8fbddfb4a.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Frank Normet",
    "director": "Pauls Kesteris",
    "peaosa": [
      {
        "actor": "Alo-Jarmo Küppas",
        "playing": "Robin Tripp"
      },
      {
        "actor": "Ülane Vilumets",
        "playing": "Chrisy"
      },
      {
        "actor": "Jennifer Whisler",
        "playing": "Jo"
      },
      {
        "actor": "Nicola Fyfe",
        "playing": "Mrs Roper"
      },
      {
        "actor": "Scott Abel",
        "playing": "Mr Roper"
      },
      {
        "actor": "Ann Vaida",
        "playing": "Gabriel"
      }
    ]
  },
  {
    "id": 17397,
    "title": "Elu elamist väärt",
    "year": "2011",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17519/1ab3c4ea7051803ce7e0c562ec6a23e405795459.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Sander Tammist",
    "director": "Suive Pahrt",
    "peaosa": [
      {
        "actor": "Tiit Tammeleht",
        "playing": "Urmas"
      },
      {
        "actor": "Mare Kabel",
        "playing": "Mare"
      },
      {
        "actor": "Ruuben Meier",
        "playing": "Juhan"
      },
      {
        "actor": "Pärt Pertel",
        "playing": "Margus"
      }
    ]
  },
  {
    "id": 17422,
    "title": "Vaba",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17545/3265355e5fc3b370548563d606c9f6e696a3ce0a.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Draama",
    "producer": "Madeleine Rodriguez",
    "director": "Saana Kuosa",
    "peaosa": [
      {
        "actor": "Adele Thele Kuusk",
        "playing": "Neiu"
      },
      {
        "actor": "Leena Ohde",
        "playing": "Vanaema"
      }
    ]
  },
  {
    "id": 17485,
    "title": "Terror",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17609/3144c8600d8b973ddea94330ebd48c549d632a4b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kristina Hakk",
    "director": "Indrek Kaine",
    "peaosa": [
      {
        "actor": "Roland Laos",
        "playing": "Ander"
      },
      {
        "actor": "Kärt Tammjärv",
        "playing": "Kerli"
      }
    ]
  },
  {
    "id": 17490,
    "title": "Keeldu uppumast",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17614/76ee3441b82f83f742883c6b0b57cd962e3016c4.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Anni Aguraijuja",
    "director": "Kristiina  Tang",
    "peaosa": [
      {
        "actor": "Joanna Kotkas",
        "playing": "Elsa"
      },
      {
        "actor": "Sebastian Talmar",
        "playing": "Karl"
      },
      {
        "actor": "Sandra Vahala",
        "playing": "Margaret"
      }
    ]
  },
  {
    "id": 17493,
    "title": "Nadja",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17617/fa71cbb4da729cc6ae0ae8c6e5616b62d6d257db.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Anni Aguraijuja",
    "director": "Janis Rižovs",
    "peaosa": [
      {
        "actor": "Ivo Uukkivi",
        "playing": "Janus"
      },
      {
        "actor": "Maiken Schmidt",
        "playing": "Nadja"
      }
    ]
  },
  {
    "id": 17510,
    "title": "Näljanädal",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17634/934afe127c2beeec5ddc50e6853d26ae19108f19.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Veli Valentin Rajasaar",
    "director": "Rein  Zobel",
    "peaosa": [
      {
        "actor": "Indrek Lukso",
        "playing": "Vilbe"
      },
      {
        "actor": "Silver Kaljula",
        "playing": "Raudmets"
      },
      {
        "actor": "Hannes-Egmond Ivask",
        "playing": "Männik"
      },
      {
        "actor": "Henri Tabur",
        "playing": "Loore"
      },
      {
        "actor": "Aleksandr Žilenko",
        "playing": "Danilov"
      },
      {
        "actor": "Tormi Kevvai",
        "playing": "Tarap"
      },
      {
        "actor": "Helena Pruuli",
        "playing": "Helen"
      }
    ]
  },
  {
    "id": 17532,
    "title": "Lõputu suvi",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17656/613ad1be1ec46efe79620e6542118439c373c230.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Kristina Hakk, Andreas Kask",
    "director": "Jaan Penjam",
    "peaosa": [
      {
        "actor": "Jaan Penjam",
        "playing": "Maik"
      },
      {
        "actor": "Mattias Naan",
        "playing": "Ott"
      },
      {
        "actor": "Johannes Naan",
        "playing": "Sten"
      },
      {
        "actor": "Rea Lest",
        "playing": "Elen"
      }
    ]
  },
  {
    "id": 17535,
    "title": "1652",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17659/0302ea3ac8d4c23b036987ac2e39c7fdf586e032.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Liva Kalnina",
    "director": "Liva Kalnina",
    "peaosa": [
      {
        "actor": "Signe Ruicena",
        "playing": "Alma"
      },
      {
        "actor": "Karlis Niemanis",
        "playing": "Filip"
      },
      {
        "actor": "Tõnu Talpsep",
        "playing": "Vana mees"
      }
    ]
  },
  {
    "id": 17701,
    "title": "Hääle värv",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17826/30558e6530dc5638769964d9c79daaf5c27893e1.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Vytautas Tinteris, Liva Kalnina",
    "director": "Vytautas Tinteris",
    "peaosa": [
      {
        "actor": "Gerda Lukkonen",
        "playing": "Anna"
      },
      {
        "actor": "Patrick Johnson",
        "playing": "Patrick"
      }
    ]
  },
  {
    "id": 17705,
    "title": "Armastus kahe karbi antibiootikumide eest",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17830/80e3f4b792798456700d343ece31aa637baad5e9.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Veli Valentin Rajasaar",
    "director": "Rein  Zobel",
    "peaosa": [
      {
        "actor": "Joonas Parve",
        "playing": "Robert"
      },
      {
        "actor": "Klaudia Tiitsmaa",
        "playing": "Stella"
      },
      {
        "actor": "Lauri Tõnspoeg",
        "playing": "Harry"
      },
      {
        "actor": "Indrek Kivi",
        "playing": "Urmo"
      }
    ]
  },
  {
    "id": 17708,
    "title": "Aasta isa",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17833/d03f91ef2bcb31b748b6476236cbcb866f1c4e2d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "",
    "producer": "Eeva Mägi",
    "director": "Eeva Mägi",
    "peaosa": [
      {
        "actor": "Külli Teetamm",
        "playing": "Pereema"
      }
    ]
  },
  {
    "id": 17709,
    "title": "Vaikivad orhideed",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17834/0b747fc175c2831bbd247e3c70d97b776904236d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Draama",
    "producer": "Kaisa Sammelselg",
    "director": "Wang Him Yip",
    "peaosa": [
      {
        "actor": "Külli Reinumägi",
        "playing": "Kristi"
      },
      {
        "actor": "Rainar Aasrand",
        "playing": "Markus"
      },
      {
        "actor": "Mikk-Hardi Tuisk",
        "playing": "Mika"
      },
      {
        "actor": "Are Uder",
        "playing": "Joonas"
      }
    ]
  },
  {
    "id": 17710,
    "title": "Toome helbed",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17835/f7ca42e5253431f79e397c5f9a1b6d4abb0d9599.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Oliver Rauam",
    "director": "Jürgen Volmer",
    "peaosa": [
      {
        "actor": "Heleriin Lass",
        "playing": "Leeni"
      },
      {
        "actor": "Ott  Salla",
        "playing": "Vidrik"
      },
      {
        "actor": "Greta Liisa Grünberg",
        "playing": "Marie"
      },
      {
        "actor": "Emil Orub",
        "playing": "Kusta"
      }
    ]
  },
  {
    "id": 17711,
    "title": "Pikk tee alla",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17836/7199ac59be678c4c3913949470de8a0816193402.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Draama",
    "producer": "Oscar Henri Wollsten",
    "director": "Oscar Henri Wollsten",
    "peaosa": [
      {
        "actor": "Kristjan Sarv",
        "playing": "Ivo"
      },
      {
        "actor": "Laine Mägi",
        "playing": "Hilje"
      },
      {
        "actor": "Ivo Reinko",
        "playing": "Mikk"
      }
    ]
  },
  {
    "id": 17719,
    "title": "Kui sa teda kohtad",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17844/70cae4a6d80f3c6a64335a2a37d38e5c5e270ad0.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kristina Hakk",
    "director": "Jürgen Moor",
    "peaosa": [
      {
        "actor": "Helena Pruuli",
        "playing": "Kaisa"
      },
      {
        "actor": "Lauri Nebel",
        "playing": "Lembit"
      }
    ]
  },
  {
    "id": 17721,
    "title": "Lõpetamine",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17846/fe20960a1c22e703abac8236264e3b17e81c6f73.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "PõnevusfilmŽanr: Draama",
    "producer": "Oliver Rauam",
    "director": "Oscar Henri Wollsten",
    "peaosa": [
      {
        "actor": "Tõnn Lamp",
        "playing": "Ants Linnus"
      },
      {
        "actor": "Robert Annus",
        "playing": "Margus Kuusk"
      },
      {
        "actor": "Raivo Trass",
        "playing": "Isa"
      }
    ]
  },
  {
    "id": 17727,
    "title": "Kivamees",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17852/dbdc9b75facbddbadf1dfb243dced67230cc4bbd.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Põnevusfilm",
    "producer": "Regina Rähn, Andreas Saulus",
    "director": "Ronet Tänav",
    "peaosa": [
      {
        "actor": "Pääru Oja",
        "playing": "Kalev / Kivamees"
      },
      {
        "actor": "Kaspar Velberg",
        "playing": "Enn Tamm"
      },
      {
        "actor": "Doris Tislar",
        "playing": "Krõõt"
      },
      {
        "actor": "Anne Türnpu",
        "playing": "Kõlahull"
      },
      {
        "actor": "Andres Roosileht",
        "playing": "Kivi (hääl)"
      }
    ]
  },
  {
    "id": 17731,
    "title": "Pilk",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17856/8aa23b6167c98eeea0a3549d239b0f19ae364ad2.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Adeele Tähemaa",
    "director": "Mairi Sõelsepp",
    "peaosa": [
      {
        "actor": "Karl Joosep Ilves",
        "playing": "Andres"
      },
      {
        "actor": "Are Uder",
        "playing": "Jaan"
      },
      {
        "actor": "Reili Nõupuu",
        "playing": "Anneli"
      }
    ]
  },
  {
    "id": 17732,
    "title": "Öised linnud",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17857/8b937f2f7044496ac06602fd6dd08497acc5f900.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Laura Lizuma, Darta Putnina, Elina Zazerska",
    "director": "Darta Putnina",
    "peaosa": [
      {
        "actor": "Toms Treinis",
        "playing": "Krists"
      },
      {
        "actor": "Sandra Klavina",
        "playing": "Ineta"
      },
      {
        "actor": "Agnese Cirule",
        "playing": "Unda"
      },
      {
        "actor": "Aivars Freimanis",
        "playing": "Drunkard"
      }
    ]
  },
  {
    "id": 17733,
    "title": "Kaks kokka",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17858/5ecc2ec37c0611803213dfdc6a7bb2d5d2a98b57.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Telesaade",
    "genre": "",
    "producer": "Keit Lilium",
    "director": "Liis Mehine",
    "peaosa": [
      {
        "actor": "Martin Haljaste",
        "playing": "Martin"
      },
      {
        "actor": "Karl Mattias Arulepp",
        "playing": "Karl"
      },
      {
        "actor": "Reimo Rand",
        "playing": "Pitsakokk"
      }
    ]
  },
  {
    "id": 17735,
    "title": "Kalad meres",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17860/0c58c680fe3d370cc82064cbcb87425e34aea8af.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kertu Viira",
    "director": "Aino M. Salmi",
    "peaosa": [
      {
        "actor": "Liisa Linhein",
        "playing": "Vera"
      },
      {
        "actor": "Ott Kartau",
        "playing": "Ben"
      }
    ]
  },
  {
    "id": 17736,
    "title": "Släkkerid EP01 - Rabarberikook",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17861/71e108e426dea79968e8637115b12578a2407d35.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Telesaade",
    "genre": "Komöödiafilm",
    "producer": "Brigitta-Liis Palumäe",
    "director": "Karl-Jonatan Karits",
    "peaosa": [
      {
        "actor": "Silver Kaljula",
        "playing": "Tuudur"
      },
      {
        "actor": "Peep Maasik",
        "playing": "Konrad"
      }
    ]
  },
  {
    "id": 17738,
    "title": "Meieküla Lood",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17863/aa94d6ae92bac52ca133a4aca1822ec1bcfd5543.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Telesaade",
    "genre": "Komöödiafilm",
    "producer": "Regina Rähn, Kristi Prik, Mari Tamm",
    "director": "Hardi Kalder",
    "peaosa": [
      {
        "actor": "Lauri Kink",
        "playing": "Andrus"
      },
      {
        "actor": "Marilyn Jurman",
        "playing": "Tuuli"
      },
      {
        "actor": "Peeter Kaljumäe",
        "playing": "Kalle"
      },
      {
        "actor": "Liisa Linhein",
        "playing": "Epp"
      }
    ]
  },
  {
    "id": 17739,
    "title": "Pop Up Saade",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17864/d7262d9b4b8430446cb4785c869d96e0fe97edeb.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Telesaade",
    "genre": "",
    "producer": "Laura Reimann",
    "director": "Laura Reimann, Kertu Laadoga",
    "peaosa": [
      {
        "actor": "Mirjam Marjatta Olesk",
        "playing": "Saatejuht"
      },
      {
        "actor": "Martin Põldvee",
        "playing": "Saatejuht"
      }
    ]
  },
  {
    "id": 17744,
    "title": "Hall",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17869/3e9539b062e052ae1c162029c4ae24e33e834876.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Karolina Veetamm",
    "director": "Jürgen Volmer",
    "peaosa": [
      {
        "actor": "Aita Vaher",
        "playing": "Ema"
      },
      {
        "actor": "Indrek Sammul",
        "playing": "Isa"
      },
      {
        "actor": "Linda Vaher",
        "playing": "Õde"
      },
      {
        "actor": "Robin Aabreldaal",
        "playing": "Mart"
      }
    ]
  },
  {
    "id": 17751,
    "title": "Hüvasti, Nõmme!",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17876/9dc196bd0340f03ff9fc6d9f74e7f087c51de94f.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Max Kroonmann, Regina Rähn",
    "director": "Max Kroonmann",
    "peaosa": [
      {
        "actor": "Kaarel Jaksi",
        "playing": "Jaksi"
      },
      {
        "actor": "Orm Oja",
        "playing": "Orm"
      }
    ]
  },
  {
    "id": 17752,
    "title": "Aeg on Sibul",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17877/0359ad771db6a776d95a9d441f56e5749d0b0248.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Martin Ruus",
    "director": "Ekke Vasli",
    "peaosa": [
      {
        "actor": "Natali Lohk",
        "playing": "Sandra"
      },
      {
        "actor": "Tormi Torop",
        "playing": "Rain"
      },
      {
        "actor": "Uno Nagelmaa",
        "playing": "Onu"
      }
    ]
  },
  {
    "id": 17766,
    "title": "8 kg",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17891/1c435a70f0b9e170290b1970fc225fbe874b0078.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Carina-Claudia Paas",
    "director": "Marleen Roosna",
    "peaosa": [
      {
        "actor": "Karl Laumets",
        "playing": "Priit"
      },
      {
        "actor": "Liisa Linhein",
        "playing": "Maria"
      },
      {
        "actor": "Roomet Poom",
        "playing": "Rene"
      }
    ]
  },
  {
    "id": 17774,
    "title": "Ajarändurid Alex ja Tom",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17899/2d2bc20a0197bbf6d8e3eb4c37672364fa73b6ba.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Telesaade",
    "genre": "",
    "producer": "Jennifer Scholz",
    "director": "Kadi Poll",
    "peaosa": [
      {
        "actor": "Hans Oskar Aaviksoo",
        "playing": "Alex"
      },
      {
        "actor": "Jan-Mattias Kottise",
        "playing": "Tom"
      }
    ]
  },
  {
    "id": 17781,
    "title": "Vandenõu",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17906/b620be8e97441baa54d6734e6cc0baaaae2fd844.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Telesaade",
    "genre": "Komöödiafilm",
    "producer": "Heli Jürisson",
    "director": "Oskar Lehemaa",
    "peaosa": [
      {
        "actor": "Kristjan Lüüs",
        "playing": "Kristjan"
      },
      {
        "actor": "Sander Rebane",
        "playing": "Sander"
      },
      {
        "actor": "Indrek Lukso",
        "playing": "Indrek"
      }
    ]
  },
  {
    "id": 17782,
    "title": "MTA (Maksu- ja Tolliamet)",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17907/e6f20a3275a0ebe160eee145449ff374ff535f93.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Telesaade",
    "genre": "Komöödiafilm",
    "producer": "Heli Jürisson",
    "director": "Oskar Lehemaa",
    "peaosa": [
      {
        "actor": "Kristjan Lüüs",
        "playing": "Kristjan"
      },
      {
        "actor": "Mihkel Kallaste",
        "playing": "Mihkel"
      },
      {
        "actor": "Ivo Uukkivi",
        "playing": "Maksuameti eriüksuse boss"
      },
      {
        "actor": "Liis Lindmaa",
        "playing": "Agent Lindmaa"
      },
      {
        "actor": "Indrek Lukso",
        "playing": "Uurija Lukso"
      },
      {
        "actor": "Oskar Lehemaa",
        "playing": "Hipster režissöör"
      }
    ]
  },
  {
    "id": 17787,
    "title": "Bänd",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17912/e696a31441f0372da32336005317d2a6b9c384df.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Telesaade",
    "genre": "Komöödiafilm",
    "producer": "Heli Jürisson",
    "director": "Oskar Lehemaa",
    "peaosa": [
      {
        "actor": "Kristjan Lüüs",
        "playing": "Sorts"
      },
      {
        "actor": "Kaarel Targo",
        "playing": "Bläkk"
      },
      {
        "actor": "Birgit Landberg",
        "playing": "Cätly"
      },
      {
        "actor": "Indrek Jõe",
        "playing": "Bert"
      },
      {
        "actor": "Indrek Lukso",
        "playing": "Uus poiss"
      }
    ]
  },
  {
    "id": 17798,
    "title": "Süüdlane",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17923/eaf856c878833e8cfa89c15bd3a4efb63810cb3f.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kalev Smidt",
    "director": "Indrek Kaine",
    "peaosa": [
      {
        "actor": "Robin Laanemaa",
        "playing": "Indrek"
      },
      {
        "actor": "Märt Kruusmann",
        "playing": "Denis"
      },
      {
        "actor": "Maarja Jakobson",
        "playing": "Ema"
      }
    ]
  },
  {
    "id": 17815,
    "title": "Volbriöö",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17940/c09e4e8bfb3908f83c8f964dcee7631d0b47d56b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "PõnevusfilmŽanr: Üleloomulik film",
    "producer": "Diana Põdra, Vladislav Mukovnin",
    "director": "Vladislav Mukovnin",
    "peaosa": [
      {
        "actor": "Anna Varkki",
        "playing": "Tütarlaps"
      }
    ]
  },
  {
    "id": 17831,
    "title": "Kalevipoeg",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17956/95f2505caeaccedb774ecbccb846ff09f91ed54e.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Kalev Smidt",
    "director": "Jürgen Moor",
    "peaosa": [
      {
        "actor": "Henry (Genka) Kõrvits",
        "playing": "Kalevipoeg / Märt"
      },
      {
        "actor": "Simeoni Sundja",
        "playing": "Paul"
      },
      {
        "actor": "Jaan Pehk",
        "playing": "Vello"
      },
      {
        "actor": "Kristjan Lüüs",
        "playing": "Priit"
      },
      {
        "actor": "Indrek Lukso",
        "playing": "Martin"
      }
    ]
  },
  {
    "id": 17843,
    "title": "Peegel",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17968/7966b12ffebebd632e6459dfa453d643f47ca3e9.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Liva Vilnite",
    "director": "Liva Vilnite",
    "peaosa": [
      {
        "actor": "Velga Vilnite",
        "playing": "Vana naine"
      },
      {
        "actor": "Liene Vilnite",
        "playing": "Keskealine naine"
      },
      {
        "actor": "Ance Vilnite",
        "playing": "Noor naine"
      },
      {
        "actor": "Elza Rasa Vilnite",
        "playing": "Väike tüdruk"
      }
    ]
  },
  {
    "id": 17855,
    "title": "Õnnelik lõpp",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/17980/a3007e9255ba5fc29ed5a28d980d0c32fc3f1545.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Muusikavideo",
    "genre": "KomöödiafilmŽanr: Muusika/tantsu",
    "producer": "Wang Him Yip, Jackel Chow",
    "director": "Wang Him Yip",
    "peaosa": [
      {
        "actor": "Ott Aunver",
        "playing": "Victor Parker"
      },
      {
        "actor": "Ada Davis-Nuori",
        "playing": "Leila"
      }
    ]
  },
  {
    "id": 17891,
    "title": "Kaleidoskoop",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18016/591613b7db99ea004b306dc6be75bea98257de70.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kairi Kivirähk",
    "director": "Kairi Kivirähk",
    "peaosa": [
      {
        "actor": "Kärt Tammjärv",
        "playing": "Hanna"
      },
      {
        "actor": "Linda Kolde",
        "playing": "Liis"
      },
      {
        "actor": "Markus Dvinjaninov",
        "playing": "Joonatan"
      },
      {
        "actor": "Ragnar Uustal",
        "playing": "Kasper"
      }
    ]
  },
  {
    "id": 17939,
    "title": "E-valimiste reklaam",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18064/730657d4084bd84e1c9ae0a6da52f9cfd03d6ff8.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "",
    "producer": "Lidiia Biriukova",
    "director": "Peteris Masjenčenko",
    "peaosa": [
      {
        "actor": "Karl Arthur Strandberg",
        "playing": "Poiss"
      },
      {
        "actor": "Hanna Linda Korp",
        "playing": "Tüdruk"
      },
      {
        "actor": "Pille Raudkivi",
        "playing": "Õpetaja"
      }
    ]
  },
  {
    "id": 17941,
    "title": "PIZZA Delivery Date",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18066/b16d8c63b1859ba35350e3a1c69744103d06b2e9.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Domenico Malcangi",
    "director": "Domenico Malcangi",
    "peaosa": [
      {
        "actor": "Ülle Lichtfeldt",
        "playing": "Gilda"
      },
      {
        "actor": "Hans Kristian Õis",
        "playing": "Pitsapoiss"
      }
    ]
  },
  {
    "id": 17954,
    "title": "Mängime (Let’s play)",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18079/efb5b9ca806c3c7cd278acca2e4597afb31f738b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Põnevusfilm",
    "producer": "Ilina Perianova",
    "director": "Ilina Perianova",
    "peaosa": [
      {
        "actor": "Timur Danilov",
        "playing": "Sasha"
      },
      {
        "actor": "Gabriela Cetvergaite",
        "playing": "Julia"
      },
      {
        "actor": "Rostislav Popov",
        "playing": "Julia saber"
      },
      {
        "actor": "Aleksander Supin",
        "playing": "Deemon"
      }
    ]
  },
  {
    "id": 17972,
    "title": "Töömesilased",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18097/e422fcc8682247f981ec167776b7a45a0352cc74.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Telesaade",
    "genre": "",
    "producer": "Karl-Jonatan Karits",
    "director": "Frank Normet",
    "peaosa": [
      {
        "actor": "Martin Kõrv",
        "playing": "Saatejuht"
      }
    ]
  },
  {
    "id": 17994,
    "title": "Simulaator",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18119/7a9f551c842b19065e5836dfde314a644b061f5f.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Vytautas Tinteris, Liva Kalnina",
    "director": "Vytautas Tinteris, Liva Kalnina",
    "peaosa": [
      {
        "actor": "Carolyn Niitla",
        "playing": "Neiu"
      },
      {
        "actor": "Grigori Rozuk",
        "playing": "Noormees"
      }
    ]
  },
  {
    "id": 17997,
    "title": "Advendikalender",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18122/8fdc5f1db032679796e8df0972c7c219a9e475a4.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kairi Kivirähk",
    "director": "Ronet Tänav",
    "peaosa": [
      {
        "actor": "Eelar Jernits",
        "playing": "Jõulumees"
      },
      {
        "actor": "Teele Kivirähk",
        "playing": "Väike tüdruk"
      },
      {
        "actor": "Ingrid Kivirähk",
        "playing": "Vanaema"
      }
    ]
  },
  {
    "id": 18000,
    "title": "Elas kord",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18125/a18d334d92482928e0076904b89a1f8f6df68bd6.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Põnevusfilm",
    "producer": "Kristjan Pütsep",
    "director": "Maria Reinup",
    "peaosa": [
      {
        "actor": "Birgit Landberg",
        "playing": "Anna"
      },
      {
        "actor": "Jaanika Tammaru",
        "playing": "Ellen"
      },
      {
        "actor": "Märt Koik",
        "playing": "Rudolf"
      },
      {
        "actor": "Rauno Polman",
        "playing": "Gustav"
      },
      {
        "actor": "Laura Niils",
        "playing": "Leila"
      },
      {
        "actor": "Liina Leinberg",
        "playing": "Kare"
      },
      {
        "actor": "Mihkel Kallaste",
        "playing": "Andres"
      },
      {
        "actor": "Silver Kaljula",
        "playing": "Ott"
      },
      {
        "actor": "Kaarel Targo",
        "playing": "Ain"
      },
      {
        "actor": "Kaija Maarit Kalvet",
        "playing": "Piret"
      },
      {
        "actor": "Kristo Veinberg",
        "playing": "Taavet"
      }
    ]
  },
  {
    "id": 18002,
    "title": "Unistaja",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18127/d0ab34a43d3d8637e02e8c1386483dbbf914a2e4.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Vladimir Kamenski",
    "director": "Baiba  Jakubaite",
    "peaosa": [
      {
        "actor": "Aurel Mustjatse",
        "playing": "Mees"
      },
      {
        "actor": "Julia Chaplygina",
        "playing": "Naine"
      }
    ]
  },
  {
    "id": 18010,
    "title": "Gesture",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18135/b881b3bae35f37a9ab8b21f92e262891c902bc4d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "",
    "producer": "",
    "director": "Anil Kapur",
    "peaosa": [
      {
        "actor": "Johan Kudu",
        "playing": "Kodutu mees"
      },
      {
        "actor": "Sten-Robert Pullerits",
        "playing": "Ärimees"
      }
    ]
  },
  {
    "id": 18085,
    "title": "Naljapäev",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18211/6f41b17787555422b73d5d5917ecc536ffe8bafc.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Komöödiafilm",
    "producer": "Anett Naruskberg",
    "director": "Anett Naruskberg",
    "peaosa": [
      {
        "actor": "Anett Naruskberg",
        "playing": "Neiu"
      },
      {
        "actor": "Quentin Dekeukelaere",
        "playing": "Noormees"
      }
    ]
  },
  {
    "id": 18098,
    "title": "Vaikus",
    "year": "2016",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18224/41818a99922031a0d2972d69f0335f091887dc4c.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Telesaade",
    "genre": "KomöödiafilmŽanr: Draama",
    "producer": "Loore Jaanson",
    "director": "Loore Jaanson",
    "peaosa": [
      {
        "actor": "Veiko Umal",
        "playing": "Toomas"
      },
      {
        "actor": "Kadi Põder",
        "playing": "Jaana"
      },
      {
        "actor": "Karolin Jürise",
        "playing": "Agnes"
      },
      {
        "actor": "Mihkel Mereküla",
        "playing": "Mart"
      },
      {
        "actor": "Anna Pert",
        "playing": "Tiina"
      },
      {
        "actor": "Taimo Kaldma",
        "playing": "Juhan Siil"
      }
    ]
  },
  {
    "id": 18199,
    "title": "Hommik",
    "year": "2016",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18325/f611a9154b599af8677de78b2cbf2ebc143e01f1.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Draama",
    "producer": "Anett Naruskberg, Ekaterina Nemtsova",
    "director": "Anett Naruskberg",
    "peaosa": [
      {
        "actor": "Ekaterina Nemtsova",
        "playing": "Alvery"
      },
      {
        "actor": "Ivan Sostaric",
        "playing": "Viktor"
      },
      {
        "actor": "Quentin Dekeukelaere",
        "playing": "Poiss"
      }
    ]
  },
  {
    "id": 18282,
    "title": "Presidendipoeg",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18409/110558b48d3b85438e47aa952a0c1ea7f40a3fe8.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Margareth Meri, Greta Varts",
    "director": "Ott-Kaarel Martens, Henri Kaido Veermäe",
    "peaosa": [
      {
        "actor": "Robert Reesar",
        "playing": "Karl Anton"
      },
      {
        "actor": "Karoliine Pruul",
        "playing": "Kätlin"
      },
      {
        "actor": "Madis Trahov",
        "playing": "Joosep"
      }
    ]
  },
  {
    "id": 18365,
    "title": "Ihaobjekt",
    "year": "2013",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18492/1b137952318d4afb8c7cd7adb92456f8e369851d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Üleloomulik film",
    "producer": "Raiko Suits",
    "director": "Raiko Suits",
    "peaosa": [
      {
        "actor": "Kadri Penjam",
        "playing": "Naine"
      }
    ]
  },
  {
    "id": 18372,
    "title": "Mida täiskasvanud mängivad?",
    "year": "2016",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18499/e8b847ca37278e7ea81cadf561b883f6d167e9ff.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Diana Põdra",
    "director": "Vladislav Mukovnin",
    "peaosa": [
      {
        "actor": "Aleksandr Järv",
        "playing": "Maksim"
      },
      {
        "actor": "Roman Maksimuk",
        "playing": "Danil"
      },
      {
        "actor": "Aleksandr Kutšmezov",
        "playing": "Viktor"
      },
      {
        "actor": "Marina Malova",
        "playing": "Nastja"
      }
    ]
  },
  {
    "id": 18377,
    "title": "Kontrapunkt",
    "year": "2016",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18509/2ac71170a620958b7fe0624ccb213cefb4a666aa.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Johanna Maria Paulson",
    "director": "Tõnis Pill",
    "peaosa": [
      {
        "actor": "Lembit Peterson",
        "playing": "Aleksander Hõbe"
      },
      {
        "actor": "Celia Peterson",
        "playing": "Mia"
      }
    ]
  },
  {
    "id": 18378,
    "title": "Lugu sellest, kuidas ...",
    "year": "2016",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18510/0f81a32b0f1de1abc00b86cc42ba32134a3a71c9.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Olari Oja",
    "director": "Sandra Kartau",
    "peaosa": [
      {
        "actor": "Helena Rummo",
        "playing": "Rahel"
      },
      {
        "actor": "Jaanika Tammaru",
        "playing": "Julia"
      },
      {
        "actor": "Ülle Lichtfeldt",
        "playing": "Ema"
      }
    ]
  },
  {
    "id": 18379,
    "title": "Kuidas teha joogivett",
    "year": "2016",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18511/3072e49c8b7728fb6d91b8b84dd758912bf807d5.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "Komöödiafilm",
    "producer": "Keidi Mäe, Lina Vonsaviciute",
    "director": "Johannes Straßner",
    "peaosa": [
      {
        "actor": "Harri Ausmaa",
        "playing": "Toomas"
      },
      {
        "actor": "Fred Raagmets",
        "playing": "Boss"
      }
    ]
  },
  {
    "id": 18383,
    "title": "Üürike ilu",
    "year": "2016",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18515/cd7d5260355a2287480a738a7c1a851d9e9de498.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Hanna Kruusi",
    "director": "Tormi Torop",
    "peaosa": [
      {
        "actor": "Jaan Pehk",
        "playing": "Kaido"
      },
      {
        "actor": "Hennariika Laaksola",
        "playing": "Liisa"
      }
    ]
  },
  {
    "id": 18385,
    "title": "Diamondjaw",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18517/3ce716c583790630213b2a4a4bb9d355ab6656a2.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Põnevusfilm",
    "producer": "Joonas Mattias Sarapuu",
    "director": "Tormi Torop",
    "peaosa": [
      {
        "actor": "Kaarel Targo",
        "playing": "Jaanus"
      },
      {
        "actor": "Karel Marcus Haav",
        "playing": "Jaanus"
      },
      {
        "actor": "Hanna Kruusi",
        "playing": "Õde"
      },
      {
        "actor": "Mihkel Nõmm",
        "playing": "Arst"
      },
      {
        "actor": "Kalev Smidt",
        "playing": "Arst"
      },
      {
        "actor": "Aleksandra Koel",
        "playing": "Ema"
      },
      {
        "actor": "Hanna Kruusi",
        "playing": "Ema"
      },
      {
        "actor": "Anne-Maarja Olei",
        "playing": "Ema"
      }
    ]
  },
  {
    "id": 18386,
    "title": "Sirius",
    "year": "2016",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18518/dae28fca78ec038bbf99edfd89d0e1c6b8dfc12f.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Carina-Claudia Paas",
    "director": "Rebeka Rummel",
    "peaosa": [
      {
        "actor": "Liisa Saaremäel",
        "playing": "Joanna"
      },
      {
        "actor": "Ron Jonathan Singson",
        "playing": "Rasmus"
      }
    ]
  },
  {
    "id": 18390,
    "title": "Üle müüri",
    "year": "2016",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18534/b465203333e9466f83d4cbb26252b469306434d2.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Mona Mi Mikkin",
    "director": "Eret Kuusk",
    "peaosa": [
      {
        "actor": "Märt Visnapuu",
        "playing": "Mees"
      },
      {
        "actor": "Katrin Saukas",
        "playing": "Naine"
      }
    ]
  },
  {
    "id": 18391,
    "title": "Päeva parim nali",
    "year": "2016",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18535/04047732ce3860db1d2d2d9371358a0f2bd51122.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Draama",
    "producer": "Joonas Mattias Sarapuu",
    "director": "Ulrike Brett Uukkivi",
    "peaosa": [
      {
        "actor": "Jaan Rekkor",
        "playing": "Rein Päev"
      },
      {
        "actor": "Mattias Naan",
        "playing": "Ants Päev"
      }
    ]
  },
  {
    "id": 18392,
    "title": "Ohverdus",
    "year": "2016",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18536/32966256794c1ff207ebcd41a2c0b14a8ff9d2df.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Draama",
    "producer": "Andri Peetso",
    "director": "Oksana Nakorchevska",
    "peaosa": [
      {
        "actor": "Üllar Saaremäe",
        "playing": "Isa"
      },
      {
        "actor": "Margus Grosnõi",
        "playing": "Metsajumal"
      },
      {
        "actor": "Triinu Paomets",
        "playing": "Tütar"
      }
    ]
  },
  {
    "id": 18393,
    "title": "Crazy Daisy",
    "year": "2014",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18537/ab8da279c1c5bb171122f2f3aa3f263bc8b24a20.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "",
    "producer": "Karolina Veetamm",
    "director": "Erik Hans Sepp",
    "peaosa": [
      {
        "actor": "Mario Kartezi",
        "playing": "Sass"
      },
      {
        "actor": "Janet Vavilov",
        "playing": "Liis"
      },
      {
        "actor": "Loore Martma",
        "playing": "Julia"
      },
      {
        "actor": "Tõnu Tamm",
        "playing": "Fred"
      },
      {
        "actor": "Marvin Veinman",
        "playing": "Kristo"
      }
    ]
  },
  {
    "id": 18397,
    "title": "Snegurochka (Lumeneiu)",
    "year": "2016",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18541/d7d7b6fe113f3ade68aa905bed28ddbb995f2994.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Draama",
    "producer": "Ilina Perianova",
    "director": "Ilina Perianova",
    "peaosa": [
      {
        "actor": "Helen Rekkor",
        "playing": "Snegurochka"
      },
      {
        "actor": "Ekaterina Egorova",
        "playing": "Olga"
      },
      {
        "actor": "Jevgeni Gaitšuk",
        "playing": "Sergey"
      },
      {
        "actor": "Aleksandr Žilenko",
        "playing": "Vladimir"
      }
    ]
  },
  {
    "id": 18404,
    "title": "Söö mind",
    "year": "2016",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18549/e836e073f9688de7063c33a040e9e66cdbd96939.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Muusikavideo",
    "genre": "KomöödiafilmŽanr: Muusika/tantsu",
    "producer": "Ilina Perianova",
    "director": "Ilina Perianova",
    "peaosa": [
      {
        "actor": "Luiza Grigorova",
        "playing": "Laura"
      },
      {
        "actor": "Nigel Barber",
        "playing": "Robert"
      }
    ]
  },
  {
    "id": 18405,
    "title": "Ridade vahelt lugedes",
    "year": "2016",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18550/60492a5e862244cca012cac17a89b1ac63b41764.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Ilze Lagzdina, Karolina Veetamm",
    "director": "Nadja Girich",
    "peaosa": [
      {
        "actor": "Alina Karmazina",
        "playing": "Anna"
      },
      {
        "actor": "Ivo Uukkivi",
        "playing": "Aleksander"
      }
    ]
  },
  {
    "id": 18409,
    "title": "Astrid",
    "year": "2016",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18554/337daa7603194d8bbdc4f9de8f168f7d1e68d3c0.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Mari-Liis Kriisa, Lina Vonsaviciute",
    "director": "Sander Koit",
    "peaosa": [
      {
        "actor": "Ester Pajusoo",
        "playing": "Astrid"
      },
      {
        "actor": "Rauno Polman",
        "playing": "Tom"
      },
      {
        "actor": "Sander Rebane",
        "playing": "Ardi"
      },
      {
        "actor": "Liivika Hanstin",
        "playing": "Eve"
      },
      {
        "actor": "Aleksei Podlesnov",
        "playing": "Andrei"
      }
    ]
  },
  {
    "id": 18416,
    "title": "Meeleseisund",
    "year": "2016",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18561/0ea6267507a96fc44ec8f7340a3a149fbe4a0ca5.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kairi Kivirähk, Ronet Tänav, Sten-Robert Pullerits",
    "director": "Sten-Robert Pullerits",
    "peaosa": [
      {
        "actor": "Roland Laos",
        "playing": "Frank"
      },
      {
        "actor": "Mart Müürisepp",
        "playing": "Karl"
      },
      {
        "actor": "Liina Tennosaar",
        "playing": "Dr Krusenstern"
      }
    ]
  },
  {
    "id": 18419,
    "title": "Emajõgi",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18564/a9667ca299d37124458a6ca848490a0152098b2e.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Urmas Reisberg, Edina Csüllög",
    "director": "Priit Põhjala",
    "peaosa": [
      {
        "actor": "Helgur Rosental",
        "playing": "Kalamees"
      }
    ]
  },
  {
    "id": 18424,
    "title": "Tudengimuusikal",
    "year": "2009",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18569/a5f5d270c75b49efb80067e267418f1f4b298ca7.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: NoortefilmŽanr: ArmastusfilmŽanr: Muusika/tantsu",
    "producer": "Richard Meitern, Elo Madissoon",
    "director": "Richard Meitern, Martin Liira",
    "peaosa": [
      {
        "actor": "Adeele Sepp",
        "playing": "Elen"
      },
      {
        "actor": "Dmitri Kurilov",
        "playing": "Dima"
      },
      {
        "actor": "Katre Luik",
        "playing": "Kati"
      },
      {
        "actor": "Kaarel Targo",
        "playing": "Kaarel"
      },
      {
        "actor": "Merli Plink",
        "playing": "Liis"
      },
      {
        "actor": "Kristjan Lüüs",
        "playing": "Andres"
      },
      {
        "actor": "Rasmus Kull",
        "playing": "Remo"
      },
      {
        "actor": "Kalev Tarkpea",
        "playing": "füüsika õppejõud (iseendana)"
      }
    ]
  },
  {
    "id": 18600,
    "title": "Bye",
    "year": "2012",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18745/8c0ee4e80a0867ccb596ae4b48bb1371f0778a2b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Muusikavideo",
    "genre": "",
    "producer": "Heli Jürisson",
    "director": "Baiba  Jakubaite",
    "peaosa": [
      {
        "actor": "Robin Juhkental",
        "playing": "Mees"
      },
      {
        "actor": "Britt Kõrsmaa",
        "playing": "Naine"
      }
    ]
  },
  {
    "id": 18642,
    "title": "Pobeda",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18791/fb18cd027feac956e09f3bcc51552d7cf82ef3cf.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Diana Põdra",
    "director": "Vladislav Mukovnin",
    "peaosa": [
      {
        "actor": "Nikita Sotskov",
        "playing": "Poiss"
      },
      {
        "actor": "Aleksander Ivaškevitš",
        "playing": "Pobeda juht"
      },
      {
        "actor": "Dimitri Kosjakov",
        "playing": "Isa"
      },
      {
        "actor": "Natalja Murina-Puustusmaa",
        "playing": "Ema"
      }
    ]
  },
  {
    "id": 18649,
    "title": "Pööriöö",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18798/3d75fdf491af1e9a16619d8022fd1efc2a30d6b1.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Hanne-Loore Pajusoo",
    "director": "Marleen Roosna",
    "peaosa": [
      {
        "actor": "Aarne Soro",
        "playing": "Raivo"
      },
      {
        "actor": "Maarja Heinastu",
        "playing": "Tütar Loora"
      },
      {
        "actor": "Karin Rask",
        "playing": "Raivo abikaasa"
      },
      {
        "actor": "Raivo E. Tamm",
        "playing": "Naabrimees"
      },
      {
        "actor": "Liina Tennosaar",
        "playing": "Naabrinaine"
      },
      {
        "actor": "Erko Elblaus",
        "playing": "Sten"
      }
    ]
  },
  {
    "id": 18659,
    "title": "Tagaajamine",
    "year": "2016",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18808/96d9abf04bcbad716c0a69768fe9dcfda83e6c0f.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Draama",
    "producer": "Dagmara Kucinska",
    "director": "Dagmara Kucinska",
    "peaosa": [
      {
        "actor": "Joe Uibokand",
        "playing": "Noormees"
      },
      {
        "actor": "Kristo Aav",
        "playing": "Noormees"
      }
    ]
  },
  {
    "id": 18687,
    "title": "Ametniku surm",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18836/126fa4765791e2bb36daf2b7a8fc0f00d61a9acd.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Draama",
    "producer": "Hanna Kruusi",
    "director": "Rebeka Rummel",
    "peaosa": [
      {
        "actor": "Mart Toome",
        "playing": "Ametnik Ivan"
      },
      {
        "actor": "Priit Pius",
        "playing": "Kindral Brizzalov"
      },
      {
        "actor": "Anne Reemann",
        "playing": "Ametniku naine"
      }
    ]
  },
  {
    "id": 18690,
    "title": "Taasta side",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18839/45f878ef4456b81cd2c86177d6368c58aef026bb.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Mona Mi Mikkin",
    "director": "Tõnis Pill",
    "peaosa": [
      {
        "actor": "Mart Nurk",
        "playing": "Kristjan"
      },
      {
        "actor": "Reimo Sagor",
        "playing": "Siim"
      },
      {
        "actor": "Taavi Eelmaa",
        "playing": "Vello"
      }
    ]
  },
  {
    "id": 18700,
    "title": "Käsilane",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18849/768b1476208ebdc19a562d91776a3d8722cf1262.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Hele-Riin Metsal",
    "director": "Harri Turunen",
    "peaosa": [
      {
        "actor": "Rauno Meronen",
        "playing": "Mega Boy"
      },
      {
        "actor": "Toivo Värbu",
        "playing": "Cool Man"
      },
      {
        "actor": "Maria Liiger",
        "playing": "Doktor Schmutz"
      },
      {
        "actor": "Kristjan Lüüs",
        "playing": "Jutustaja"
      }
    ]
  },
  {
    "id": 18714,
    "title": "Säde",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18863/369a807da75b1fa0cdd8bf09d2c1c38f4f17619c.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Johanna Maria Paulson",
    "director": "Rebeka Rummel",
    "peaosa": [
      {
        "actor": "Pääru Oja",
        "playing": "Tristan"
      },
      {
        "actor": "Aleksander Eelmaa",
        "playing": "Vanaisa"
      },
      {
        "actor": "Elo-Mirt Oja",
        "playing": "Säde"
      }
    ]
  },
  {
    "id": 18715,
    "title": "9mm",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18864/22f3fe58bfd87d54b1864794cf4b7b9bd07e61a2.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Hanna Kruusi",
    "director": "Erik Hans Sepp",
    "peaosa": [
      {
        "actor": "Silver Kaljula",
        "playing": "Rene"
      },
      {
        "actor": "Karl Edgar Tammi",
        "playing": "Juht"
      },
      {
        "actor": "Jaune Kimmel",
        "playing": "Rita"
      }
    ]
  },
  {
    "id": 18716,
    "title": "1/2 last",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18865/2a4467f464a2c1065c28aca13d9bbfa9780f7f6a.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Joonas Mattias Sarapuu",
    "director": "Ulrike Brett Uukkivi",
    "peaosa": [
      {
        "actor": "Tarmo Song",
        "playing": "Toomas"
      },
      {
        "actor": "Mari Abel",
        "playing": "Kärt"
      },
      {
        "actor": "Hendrik Kaljuvee",
        "playing": "Oliver"
      }
    ]
  },
  {
    "id": 18717,
    "title": "Mõrv hotellis",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18866/3ddb80ace0755ffbeb2a3583730110b5cf41f02b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Õudusfilm",
    "producer": "Olari Oja",
    "director": "Tormi Torop",
    "peaosa": [
      {
        "actor": "Jaanika Arum",
        "playing": "Victoria"
      },
      {
        "actor": "Tõnu Oja",
        "playing": "Taavet"
      },
      {
        "actor": "Andres Ots",
        "playing": "Jimmy"
      },
      {
        "actor": "Roland Laos",
        "playing": "Robert"
      },
      {
        "actor": "Kristo Viiding",
        "playing": "Juhan"
      },
      {
        "actor": "Päär Päärenson",
        "playing": "Martin"
      }
    ]
  },
  {
    "id": 18720,
    "title": "Olevik",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18869/b5be9ba4fbf811b481cd4928394546466adef9ea.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Carina-Claudia Paas",
    "director": "Kristiina  Tang",
    "peaosa": [
      {
        "actor": "Kätlin Hallik",
        "playing": "Naine"
      },
      {
        "actor": "Tõnu Maasar",
        "playing": "Vanaisa"
      },
      {
        "actor": "Kirke Nora Pärlin",
        "playing": "Tüdruk"
      }
    ]
  },
  {
    "id": 18740,
    "title": "Hilisõhtune Naansense",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18889/69d197500472919ee7339ef240ab7da23928c73d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Telesaade",
    "genre": "",
    "producer": "Triin Ahonen",
    "director": "Vladlen Pobjaržin, Kadi Poll",
    "peaosa": [
      {
        "actor": "Mattias Naan",
        "playing": "Saatejuht"
      },
      {
        "actor": "Rene Puura",
        "playing": "Muusik"
      },
      {
        "actor": "Kristel Aaslaid",
        "playing": "Saatekülaline"
      },
      {
        "actor": "Tuuli Rand",
        "playing": "Saatekülaline"
      },
      {
        "actor": "Jan Uuspõld",
        "playing": "Saatekülaline"
      }
    ]
  },
  {
    "id": 18744,
    "title": "Afgaan",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18893/4237c9758d958f69c64c82c9c66463709bffb55d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Telesaade",
    "genre": "Draama",
    "producer": "Sten-Erik Toos",
    "director": "Eiko Kink",
    "peaosa": [
      {
        "actor": "Erik Vent",
        "playing": "Jan"
      },
      {
        "actor": "Gunnar Jaanovits",
        "playing": "Gunn"
      },
      {
        "actor": "Imre Koort",
        "playing": "Armin"
      },
      {
        "actor": "Martin Ruiso",
        "playing": "Ruiso"
      }
    ]
  },
  {
    "id": 18750,
    "title": "Armastus?",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18899/0f4ce9a38c661528c1b451611f100384c70c365f.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "PõnevusfilmŽanr: Draama",
    "producer": "Maris Saar, Sissel-Maria Mägi",
    "director": "Anil Kapur",
    "peaosa": [
      {
        "actor": "Vallo Kirs",
        "playing": "Tom"
      },
      {
        "actor": "Klaudia Tiitsmaa",
        "playing": "Liis"
      },
      {
        "actor": "Kaarel Targo",
        "playing": "Märt"
      }
    ]
  },
  {
    "id": 18751,
    "title": "Igatsused",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18900/4152462825f964d8885f812bb45422a275387e04.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Johannes Magnus Aule",
    "director": "Cesar Reyna",
    "peaosa": [
      {
        "actor": "Sonata Visockaite",
        "playing": "Maria"
      },
      {
        "actor": "Gytis Reiters",
        "playing": "Külastaja"
      },
      {
        "actor": "Domantas Storukas",
        "playing": "Ivan"
      },
      {
        "actor": "Remy  Klooster",
        "playing": "Noor Ivan"
      }
    ]
  },
  {
    "id": 18753,
    "title": "Callas Monti Votto",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18902/d323798e791bf404ae3c87d2deaec5a46c4bfdcf.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Aisté Kalčyté",
    "director": "Sintija Andersone",
    "peaosa": [
      {
        "actor": "Elina Bojarkina",
        "playing": "Lauma"
      },
      {
        "actor": "Marta Lovisa  Jančevska",
        "playing": "Merija"
      },
      {
        "actor": "Karlis Kalninš",
        "playing": "Niks"
      }
    ]
  },
  {
    "id": 18767,
    "title": "Mesinädalad",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18916/1f46bb8f865598ba3b40cc473267b76f21e89fc8.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Brigitta-Liis Palumäe, Enrico Barone",
    "director": "Enrico Barone",
    "peaosa": [
      {
        "actor": "Maarja Mitt",
        "playing": "Helen"
      },
      {
        "actor": "Darta Danevicsa",
        "playing": "Laima"
      },
      {
        "actor": "Ott Kartau",
        "playing": "Toomas"
      },
      {
        "actor": "Külli Teetamm",
        "playing": "Lea"
      }
    ]
  },
  {
    "id": 18769,
    "title": "Vormindus",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18918/21246469c9e43ac031814529cf7a213c164ace0f.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Ulmefilm",
    "producer": "Roomet Poom",
    "director": "Tarvi Roos",
    "peaosa": [
      {
        "actor": "Kätriin Helena Huttunen",
        "playing": "Emma"
      },
      {
        "actor": "Tambet Tuisk",
        "playing": "Isa"
      }
    ]
  },
  {
    "id": 18772,
    "title": "Aeg kasvab läbi me luudest",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18921/989f1e1fd9e6f0f1c76735b331526eb51faa6aa9.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Helen Räim",
    "director": "Dora Lall",
    "peaosa": [
      {
        "actor": "Aivo Liinsoo",
        "playing": "Jaanus"
      }
    ]
  },
  {
    "id": 18773,
    "title": "Armuavaldus",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18922/076eb72b87508fff7643eb5a3483c8d171ece53d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Olari Oja",
    "director": "Tormi Torop",
    "peaosa": [
      {
        "actor": "Marian Heinat",
        "playing": "Katrin"
      },
      {
        "actor": "Ragnar Uustal",
        "playing": "Turvamees"
      },
      {
        "actor": "Andrus Vaarik",
        "playing": "Autojuht"
      },
      {
        "actor": "Roland Laos",
        "playing": "Nolk 1"
      },
      {
        "actor": "Artur Linnus",
        "playing": "Nolk 2"
      }
    ]
  },
  {
    "id": 18780,
    "title": "Viimane reede",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18929/d58b1e58a6dd0f069c0c0ed3b0e904c2cd674fc8.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "",
    "producer": "Danoa Kampe",
    "director": "Danoa Kampe",
    "peaosa": [
      {
        "actor": "Aleksander Ots",
        "playing": "Isa"
      },
      {
        "actor": "Nora Von B",
        "playing": "Ema"
      },
      {
        "actor": "Adeele Aavasalu",
        "playing": "Tütar"
      }
    ]
  },
  {
    "id": 18781,
    "title": "Pyramus ja Thisbe",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/18930/2c7fea65696d57cb3542d92d62b493abb754ce9e.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Carina-Claudia Paas",
    "director": "Laura Raud",
    "peaosa": [
      {
        "actor": "Carolin Ligi",
        "playing": "Thisbe"
      },
      {
        "actor": "Risto Vaidla",
        "playing": "Pyramus"
      }
    ]
  },
  {
    "id": 18868,
    "title": "Naine on süüdi",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19017/e796594e66a54ddcf7d8c819e178fef50392e7d7.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Johanna Maria Paulson",
    "director": "Sandra Kartau",
    "peaosa": [
      {
        "actor": "Katariina Unt",
        "playing": "Leili Peterson"
      },
      {
        "actor": "Rain Simmul",
        "playing": "Andres Peterson"
      },
      {
        "actor": "Liina Tennosaar",
        "playing": "Marta Kask"
      },
      {
        "actor": "Eduard Salmistu",
        "playing": "Jaanus Kask"
      }
    ]
  },
  {
    "id": 18870,
    "title": "Mäel",
    "year": "2016",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19019/b7dfb14908379f5963d30674a50ac1c51fea7b9b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Joonas Mattias Sarapuu",
    "director": "Ulrike Brett Uukkivi",
    "peaosa": [
      {
        "actor": "Ivo Uukkivi",
        "playing": "Georgi"
      },
      {
        "actor": "Kristel Leesment",
        "playing": "Maria"
      }
    ]
  },
  {
    "id": 18874,
    "title": "Vasakhaak",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19023/f4637729d7628376203a06b5e8d5f99a0d54adb1.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Carina-Claudia Paas",
    "director": "Sander Saard",
    "peaosa": [
      {
        "actor": "Ergo Pajuväli",
        "playing": "Martin"
      },
      {
        "actor": "Anelle Trepp",
        "playing": "Kelly"
      },
      {
        "actor": "Mart Pöör",
        "playing": "Treener"
      }
    ]
  },
  {
    "id": 19171,
    "title": "Kodu",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19322/310fbd6265e0f704e68b2f13d4101ee99951f7b4.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "",
    "producer": "Doris Tääker",
    "director": "Israel Bañuelos",
    "peaosa": [
      {
        "actor": "Liis Vares",
        "playing": "Naine"
      }
    ]
  },
  {
    "id": 19247,
    "title": "Ärkamine",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19398/0e32f758a4faf9addec831e8c64670b7f205d931.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Ramin Pourmand",
    "director": "Ramin Pourmand",
    "peaosa": [
      {
        "actor": "Ramin Pourmand",
        "playing": "Muusik, Markus, Investor"
      },
      {
        "actor": "Külli Pärtel",
        "playing": "Naine"
      },
      {
        "actor": "Triin Sagen",
        "playing": "Ettekandja, mustlane"
      },
      {
        "actor": "Ilme-Liina Raidma",
        "playing": "Naine"
      },
      {
        "actor": "Viljar Viliste",
        "playing": "Sportlane"
      }
    ]
  },
  {
    "id": 19250,
    "title": "Rebekka",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19401/497a678385bcfc72ab33b5d4aa796d165601af6f.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kristina Amor",
    "director": "Ramin Pourmand",
    "peaosa": [
      {
        "actor": "Inger Kivari",
        "playing": "Rebekka"
      },
      {
        "actor": "Hele-Riin Tamm",
        "playing": "Emily"
      },
      {
        "actor": "Karl Gregor Kool",
        "playing": "David"
      }
    ]
  },
  {
    "id": 19476,
    "title": "Homme",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19627/9ed8bd5ee94b28f4604204a736cc865d1aaac9c4.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Armastusfilm",
    "producer": "Kertu Viira",
    "director": "Silvia Lorenzi",
    "peaosa": [
      {
        "actor": "Liis Lindmaa",
        "playing": "Triin"
      },
      {
        "actor": "Andrus Vaarik",
        "playing": "Oliver"
      },
      {
        "actor": "Kristi Kimmel",
        "playing": "Zelda"
      },
      {
        "actor": "Rauno Polman",
        "playing": "Baarman"
      }
    ]
  },
  {
    "id": 19477,
    "title": "Nina",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19628/2d1d9ab227b8054d62dcef709288952a49b85b18.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Pawel Dyzio Wlazewicz",
    "director": "Pawel Dyzio Wlazewicz",
    "peaosa": [
      {
        "actor": "Agata Różycka",
        "playing": "Nina"
      },
      {
        "actor": "Adrianna Gruszka",
        "playing": "Naine"
      },
      {
        "actor": "Daniel  Chryc",
        "playing": "Mees"
      }
    ]
  },
  {
    "id": 19483,
    "title": "Tanel Padar \"Soovin head\"",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19634/e2dcf4d938aa07b5a80651bcbf8244c12700381e.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Muusikavideo",
    "genre": "",
    "producer": "Liina Ristoja",
    "director": "Laura Lisete  Roosaar",
    "peaosa": [
      {
        "actor": "Tanel Padar",
        "playing": "Mees"
      },
      {
        "actor": "Alla Uusleer",
        "playing": "Naine"
      }
    ]
  },
  {
    "id": 19494,
    "title": "Kass öösel",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19645/a8b9d2ab7bf2cf7741f298f0cfc863b00b7fc981.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Alex Asikainen",
    "director": "Alex Asikainen",
    "peaosa": [
      {
        "actor": "Anna Andersson",
        "playing": "Ave"
      },
      {
        "actor": "Ilkka  Hämäläinen",
        "playing": "Tobias"
      }
    ]
  },
  {
    "id": 19495,
    "title": "Õnnetused pole juhuslikud",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19646/acddfedc659a9a1f6d1b31f07b4a0ab73dfcd2df.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Melodraama",
    "producer": "Nicol Susi",
    "director": "Polina Linovitskaja",
    "peaosa": [
      {
        "actor": "Aleksandra Zhavoronkova",
        "playing": "Marina"
      },
      {
        "actor": "Eduard Tee",
        "playing": "Aleksey"
      },
      {
        "actor": "Dan Jeršov",
        "playing": "Zhenya"
      }
    ]
  },
  {
    "id": 19508,
    "title": "Jahiloom",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19659/658dd56cca227f365dd3bff583f35e215c100a56.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Clare Fogerty",
    "director": "Jeronimo Sarmiento",
    "peaosa": [
      {
        "actor": "Frida Jantson-Köstner",
        "playing": "Liis"
      },
      {
        "actor": "Mardi Truus",
        "playing": "Jaan"
      },
      {
        "actor": "Franz  Malmsten jr",
        "playing": "Olev"
      },
      {
        "actor": "Ivonna-Ly Pachel",
        "playing": "Kadri"
      }
    ]
  },
  {
    "id": 19515,
    "title": "Roof Knocking",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19666/80d9482a9ba2b39560b1ae80e9951d47b3c6af00.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Sergio Salazar",
    "director": "Sina Salimi",
    "peaosa": [
      {
        "actor": "Sameera Asir",
        "playing": "Lana"
      },
      {
        "actor": "Ahmed Abdelrazek",
        "playing": "Agent"
      },
      {
        "actor": "Alaa Zubaydi",
        "playing": "Kareem"
      },
      {
        "actor": "Leila Ziyad",
        "playing": "Leila"
      }
    ]
  },
  {
    "id": 19516,
    "title": "Impromptu",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19667/6b3a81e63834647cab2496ddd8d8320d34752e88.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Põnevusfilm",
    "producer": "Ingemar Ruiz",
    "director": "Yasir Kareem",
    "peaosa": [
      {
        "actor": "Anu Lamp",
        "playing": "Mari Ann"
      },
      {
        "actor": "Nero Urke",
        "playing": "Lewis"
      }
    ]
  },
  {
    "id": 19517,
    "title": "Muusa",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19668/8f3ab1d32300aba9c344541704b4931f45226ec7.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Helen Räim",
    "director": "Rauno Polman",
    "peaosa": [
      {
        "actor": "Ruuben-Joosua Palu",
        "playing": "Kristjan"
      },
      {
        "actor": "Marion Tammet",
        "playing": "Saara"
      },
      {
        "actor": "Karmel Naudre",
        "playing": "Nora"
      },
      {
        "actor": "Mihkel Kuusk",
        "playing": "Taavi"
      }
    ]
  },
  {
    "id": 19562,
    "title": "Jätkub",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19713/b7e096c27bb7b2fcd5913123fdf09e76401ad779.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "",
    "producer": "Eik Tammemäe",
    "director": "Eik Tammemäe",
    "peaosa": [
      {
        "actor": "Emilia Annus",
        "playing": "Väike tüdruk"
      },
      {
        "actor": "Mart Müürisepp",
        "playing": "Rulataja Mikk"
      },
      {
        "actor": "Tõnis Niinemets",
        "playing": "Terrorist Pär"
      }
    ]
  },
  {
    "id": 19568,
    "title": "Tegelikult",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19719/3fcf421dc3bc52e5bae396e1446dc6b3d1f8fee5.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Üleloomulik filmŽanr: Õudusfilm",
    "producer": "Liana Kross",
    "director": "Mart Sander",
    "peaosa": [
      {
        "actor": "Jekaterina Novosjolova",
        "playing": "Naine"
      },
      {
        "actor": "Toomas Kolk",
        "playing": "Mees"
      },
      {
        "actor": "Mart Sander",
        "playing": "Vanem mees"
      }
    ]
  },
  {
    "id": 19569,
    "title": "Laps tagaistmel",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19720/09d3f20637d9777b3abaa84c7a2e5efcbdb64173.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kertu Viira, Kristina Amor",
    "director": "Epp Kubu",
    "peaosa": [
      {
        "actor": "Linda Vaher",
        "playing": "Naine"
      },
      {
        "actor": "Igor Rogatšov",
        "playing": "Taksojuht"
      }
    ]
  },
  {
    "id": 19570,
    "title": "Sõlm",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19721/8b1db52af5721029a04925ef7c65312162e51e4f.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Aili  Maarja",
    "director": "Teresa Väli",
    "peaosa": [
      {
        "actor": "Kristi Kimmel",
        "playing": "Saara"
      },
      {
        "actor": "Mihkel Kuusk",
        "playing": "Felix"
      }
    ]
  },
  {
    "id": 19574,
    "title": "Maša",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19725/92f53d83059ea2f5c5aba9999fd89fbc146bddfd.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Andreas Kask",
    "director": "Kairit Krass, Triin Kadaja",
    "peaosa": [
      {
        "actor": "Rebecca Viitala",
        "playing": "Maša"
      },
      {
        "actor": "Jarmo Reha",
        "playing": "Karu"
      }
    ]
  },
  {
    "id": 19583,
    "title": "Ülalpeetav",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19734/3114dcd2f430173134e098ff23c31d3ba4eebb5b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Kriminaalfilm",
    "producer": "Nora Aleksandra Tsahkna",
    "director": "Dmitri Makarenko",
    "peaosa": [
      {
        "actor": "Keron Sepp",
        "playing": "Joonas Tähepõld"
      },
      {
        "actor": "Heino Kalm",
        "playing": "Kaarel Tähepõld"
      },
      {
        "actor": "Jürjo  Võisula",
        "playing": "Ragnar Kivimäe"
      },
      {
        "actor": "Katrin Mesilane",
        "playing": "Silvia"
      },
      {
        "actor": "Kristo Aav",
        "playing": "Artur"
      }
    ]
  },
  {
    "id": 19632,
    "title": "Tagasilükatud",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19783/3d28cfcb52015eeb5e50cfd8254e1b397a45d942.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Inger Põder",
    "director": "Janeli Pelska",
    "peaosa": [
      {
        "actor": "Valdek Ott",
        "playing": "Henri"
      },
      {
        "actor": "Annabel Tanila",
        "playing": "Baaritüdruk"
      },
      {
        "actor": "Mariann Tammaru",
        "playing": "Marili"
      }
    ]
  },
  {
    "id": 19648,
    "title": "Petlik välimus",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19799/becf5938c8785bf84efd7ec7adccdd9f0315fc24.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Telesaade",
    "genre": "Põnevusfilm",
    "producer": "Raivo Malter",
    "director": "Jaan  Kalmus jr",
    "peaosa": [
      {
        "actor": "Kärt Tammjärv",
        "playing": "Teele"
      },
      {
        "actor": "Klaudia Tiitsmaa",
        "playing": "Luise"
      },
      {
        "actor": "Peeter Jürgens",
        "playing": "Juhan"
      }
    ]
  },
  {
    "id": 19666,
    "title": "Stefan",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19817/6c942ff43ed42c616dcd6a109678b02e31648f34.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: DraamaŽanr: Fantaasiafilm",
    "producer": "Ann Einberg",
    "director": "Ann Einberg",
    "peaosa": [
      {
        "actor": "Jaan Penjam",
        "playing": "Stefan"
      },
      {
        "actor": "Signe Luuk",
        "playing": "Ajakirjanik"
      }
    ]
  },
  {
    "id": 19669,
    "title": "Meestest",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19820/90aee23a7db6c875301f239ca4d25bec0f6e29fb.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Margot Privoi",
    "director": "Teemu Kettunen",
    "peaosa": [
      {
        "actor": "Rainer Elhi",
        "playing": "Erik"
      },
      {
        "actor": "Mihkel Vendel",
        "playing": "Peter"
      },
      {
        "actor": "Mihkel Kallaste",
        "playing": "Mart"
      },
      {
        "actor": "Mauri Liiv",
        "playing": "Siim"
      },
      {
        "actor": "Melissa Mariel Korjus",
        "playing": "Kelli"
      }
    ]
  },
  {
    "id": 19677,
    "title": "Õnne soovime mul",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19828/ef0be5315c67c47e678ec6c2acf638ebbe304458.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Mirjam Johanna Korsten",
    "director": "Dora Lall",
    "peaosa": [
      {
        "actor": "Rainer Elhi",
        "playing": "Miko"
      },
      {
        "actor": "Maria Paiste",
        "playing": "Miina"
      }
    ]
  },
  {
    "id": 19679,
    "title": "Above the speed of light",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19830/1936f9ae204329a232c102d3718f143bbc3aa59e.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Fantaasiafilm",
    "producer": "Mariam Agladze, Mari-Liis Kriisa",
    "director": "Vytautas Tinteris",
    "peaosa": [
      {
        "actor": "Arvi Tapver",
        "playing": "Max"
      },
      {
        "actor": "Abraham Kenny",
        "playing": "Jonas"
      }
    ]
  },
  {
    "id": 19682,
    "title": "Tõusev päike",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19833/6ace734af2b4a9c2654d02bcf4d3f8994b6d33f1.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Sameli Muurimäki, Ilona Hiltunen",
    "director": "Sameli Muurimäki",
    "peaosa": [
      {
        "actor": "Heli Hyttinen",
        "playing": "Laura"
      }
    ]
  },
  {
    "id": 19689,
    "title": "Postiljon",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19840/6313ffff59c6a1711e3ab6bbc4e754b676147f97.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Brit Tammeleht",
    "director": "Sven Olters",
    "peaosa": [
      {
        "actor": "Raul  Talmar",
        "playing": "Viktor"
      }
    ]
  },
  {
    "id": 19701,
    "title": "Maakler",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19852/cddb61e145f0962d8ce9aad53c98f23d17a1406a.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Annaliise Kalamees",
    "director": "Sander Gering",
    "peaosa": [
      {
        "actor": "Karl Edgar Tammi",
        "playing": "Dima Beljajev"
      },
      {
        "actor": "Jürjo  Võisula",
        "playing": "Ragnar Kivimäe"
      },
      {
        "actor": "Kertu Luiga",
        "playing": "Jane Kivimäe"
      },
      {
        "actor": "Heino Kalm",
        "playing": "Kaarel Tähepõld"
      }
    ]
  },
  {
    "id": 19702,
    "title": "Kingitus",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19853/246c6adc1e8a159a66e4592ff8012c8a6807121d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Sander Gering",
    "director": "Feliks Mangus",
    "peaosa": [
      {
        "actor": "Aave Kampe",
        "playing": "Hilde"
      },
      {
        "actor": "Heinar Loosaar",
        "playing": "Enno"
      },
      {
        "actor": "Susan Kolde",
        "playing": "Noor Hilde"
      }
    ]
  },
  {
    "id": 19703,
    "title": "Koodnimetus: Ajatu",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19854/fe0d5a99a4b189ccf8faf0f4a2dbe4960296f8bc.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Fantaasiafilm",
    "producer": "Nata Jokhadze",
    "director": "Collin Browne",
    "peaosa": [
      {
        "actor": "Anastasia Popova",
        "playing": "Emily Turner"
      },
      {
        "actor": "Sean Westbrook",
        "playing": "Frank Biscoby"
      },
      {
        "actor": "Clare Fogerty",
        "playing": "Liza Bell"
      },
      {
        "actor": "Jie Yin",
        "playing": "Victor Yin"
      }
    ]
  },
  {
    "id": 19704,
    "title": "Tomorrow Island",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19855/78a2cc7df8631b0c59914b173c0be3222fc82e46.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Shruti Sidhan",
    "director": "Gwenn Joyaux",
    "peaosa": [
      {
        "actor": "Dary Butryk",
        "playing": "Sveta"
      },
      {
        "actor": "Vitali Vassiljev",
        "playing": "Vlad"
      },
      {
        "actor": "Oleg Jashinin",
        "playing": "Seersant"
      },
      {
        "actor": "Jegor Sevastjanov",
        "playing": "Sõdur"
      },
      {
        "actor": "Juri Lemeshenko",
        "playing": "Kontrollpunkti sõdur"
      }
    ]
  },
  {
    "id": 19708,
    "title": "Su nädal kõlab tuttavalt",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19859/5d5f6834e8be7594adf4c8528d38e71989b4f26e.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Telesaade",
    "genre": "",
    "producer": "Jarmo Seljamaa",
    "director": "Laura Lisete  Roosaar",
    "peaosa": [
      {
        "actor": "Katariina Tamm",
        "playing": "Saatejuht"
      },
      {
        "actor": "Märt Koik",
        "playing": "Saatejuht"
      }
    ]
  },
  {
    "id": 19712,
    "title": "Täiuslik elu",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19863/6f259cbc9b7361ccaaddc613c0f0645999f09be3.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "PõnevusfilmŽanr: Draama",
    "producer": "Liisa Aadussoo",
    "director": "Ralf Tafenau",
    "peaosa": [
      {
        "actor": "Amanda Hermiine Künnapas",
        "playing": "Maria"
      },
      {
        "actor": "Sander Roosimägi",
        "playing": "Tom"
      }
    ]
  },
  {
    "id": 19794,
    "title": "Short and fiction",
    "year": "2016",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19945/04a74f90ea9d50fba6443f32de9f7bb5161eb2ca.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Maria Kriisa",
    "director": "Sintija Andersone",
    "peaosa": [
      {
        "actor": "Kersti Heinloo",
        "playing": "Naine"
      },
      {
        "actor": "Helena Pertens",
        "playing": "Tütarlaps"
      },
      {
        "actor": "Hanno Parksepp",
        "playing": "Mees"
      }
    ]
  },
  {
    "id": 19795,
    "title": "Nokturn",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19946/9f654d7705158ec598a2ce9ab7501ee6afa6cbcf.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Johannes Magnus Aule",
    "director": "Viktor Marvin",
    "peaosa": [
      {
        "actor": "Miika Pihlak",
        "playing": "Hugo"
      },
      {
        "actor": "Kersti Selli",
        "playing": "Silja"
      },
      {
        "actor": "Elise Pottmann",
        "playing": "Hanna"
      }
    ]
  },
  {
    "id": 19844,
    "title": "Prospekt Mira",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/19995/2db32eb5fab4727d3dd5181e0d71f0baa7fd2a16.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Jeanna Koba",
    "director": "Lidiia Nye",
    "peaosa": [
      {
        "actor": "Marina Vysotskaya",
        "playing": "Marina"
      },
      {
        "actor": "Irina Bencivenga",
        "playing": "Vanaema"
      },
      {
        "actor": "Nikita Davydov",
        "playing": "Sanya"
      },
      {
        "actor": "Sergey Torgood",
        "playing": "Konstantin"
      }
    ]
  },
  {
    "id": 19849,
    "title": "Marta",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20001/4c5569e2ebbadc3e1d3f619d3985958cd76c85fe.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Stina Tiigimäe, Karolina Veetamm",
    "director": "German Golub",
    "peaosa": [
      {
        "actor": "Elis Järvsoo",
        "playing": "Marta"
      },
      {
        "actor": "Miika Pihlak",
        "playing": "Vend"
      },
      {
        "actor": "Indrek Ojari",
        "playing": "Isa"
      }
    ]
  },
  {
    "id": 19850,
    "title": "U48 2018: Remont",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20002/38ae87d1e611799024375b9494bacde0684e0f60.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kamilla Selina Lepik",
    "director": "Teemu Kettunen",
    "peaosa": [
      {
        "actor": "Mihkel Vendel",
        "playing": "Poeg"
      },
      {
        "actor": "Meelis Rondo",
        "playing": "Isa"
      },
      {
        "actor": "Svetlana Novoseltseva",
        "playing": "Tütar"
      }
    ]
  },
  {
    "id": 19898,
    "title": "Laiali olek",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20050/48a5efd37bf64898559ae926c0a717bffb4768a4.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Johanna Allegra",
    "director": "Aleksis Siksnis",
    "peaosa": [
      {
        "actor": "Leda Basille",
        "playing": "Tüdruk"
      },
      {
        "actor": "Markus Siksnis",
        "playing": "Poiss"
      }
    ]
  },
  {
    "id": 19899,
    "title": "Võõrastetuba",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20051/3f7be8c90e350ef57fe634716c7056e1a1fa708c.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Ekaterina Nemtsova",
    "director": "Felicia Liu",
    "peaosa": [
      {
        "actor": "Siret Tuula",
        "playing": "Mia"
      },
      {
        "actor": "Marleen Olen",
        "playing": "Minnie"
      },
      {
        "actor": "Jegor Sevastjanov",
        "playing": "Juno"
      },
      {
        "actor": "Svea Rohtla",
        "playing": "Ruth"
      }
    ]
  },
  {
    "id": 19912,
    "title": "Valvuri evolutsioon",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20065/997e88ae6babd554986433f36d939d1d1c061a34.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Inger Põder",
    "director": "Dora Lall",
    "peaosa": [
      {
        "actor": "Tõnu Oja",
        "playing": "Valvur"
      },
      {
        "actor": "Toomas Koppel",
        "playing": "Poiss"
      },
      {
        "actor": "Margo Teder",
        "playing": "Ülemus"
      }
    ]
  },
  {
    "id": 19914,
    "title": "Külaline",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20067/7d1f5a9c902e2947d052e164429d84f5e026c966.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Helen Räim",
    "director": "Teresa Väli",
    "peaosa": [
      {
        "actor": "Pääru Oja",
        "playing": "Paul"
      },
      {
        "actor": "Ursula Ratasepp",
        "playing": "Lee"
      },
      {
        "actor": "Henessi Schmidt",
        "playing": "Kärt"
      }
    ]
  },
  {
    "id": 19922,
    "title": "The Baltic Apartment",
    "year": "2015",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20075/c6ce5a7ace707381bbbe25716616bec8110dbb1e.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Domenico Malcangi, Laura Koivisto, Carol Liis Metsla, Irina Frederika Tarvida",
    "director": "Domenico Malcangi",
    "peaosa": [
      {
        "actor": "Ettore Scarabelli",
        "playing": "Riccardo"
      },
      {
        "actor": "Anastassia Tsubina",
        "playing": "Vera"
      }
    ]
  },
  {
    "id": 19931,
    "title": "Hea tüdruk",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20084/62a092cbc85a3537a1e52137b2f1488f80bd35ed.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Merja Maijanen",
    "director": "Merja Maijanen",
    "peaosa": [
      {
        "actor": "Dana Faarinen",
        "playing": "Tüdruk"
      },
      {
        "actor": "Annastiina Gylling",
        "playing": "Ema"
      },
      {
        "actor": "Jyrki Tammi",
        "playing": "Isa"
      }
    ]
  },
  {
    "id": 19932,
    "title": "Mina ja Sherlock",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20085/ed1563de49fbfcdc296e52acf2f5b0e5a2db3555.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Draama",
    "producer": "Hanna Maria Toome",
    "director": "Vivian Melder",
    "peaosa": [
      {
        "actor": "Eliise Künnis",
        "playing": "Miina"
      },
      {
        "actor": "Joosep Spirka",
        "playing": "Sherlock"
      }
    ]
  },
  {
    "id": 19933,
    "title": "The Boondocks “That’s Why”",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20086/1bc7f84e5bfe767293e01bf901ba0c4608886dad.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Muusikavideo",
    "genre": "",
    "producer": "Liis Lindmaa, Maxim Tuul",
    "director": "Liis Lindmaa",
    "peaosa": [
      {
        "actor": "Rea Lest",
        "playing": "Naine"
      },
      {
        "actor": "Jörgen Liik",
        "playing": "Mees"
      }
    ]
  },
  {
    "id": 19941,
    "title": "Pärandus",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20094/38a2dc8c0fc272800abd23e7a656639dac812f5e.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Johannes Magnus Aule",
    "director": "Janeli Pelska",
    "peaosa": [
      {
        "actor": "Liisa Saaremäel",
        "playing": "Malle"
      },
      {
        "actor": "Jürgen Gansen",
        "playing": "Urmas"
      },
      {
        "actor": "Meelis Rondo",
        "playing": "Kaarel"
      },
      {
        "actor": "Maria  Oja",
        "playing": "Ülle"
      },
      {
        "actor": "Ines Aru",
        "playing": "Marta"
      },
      {
        "actor": "Anti Kobin",
        "playing": "Enn"
      },
      {
        "actor": "Andres Roosileht",
        "playing": "Ain"
      }
    ]
  },
  {
    "id": 19942,
    "title": "Ta teab, mis ma tegin mullu suvel",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20095/fa7d2fd10fa2f2eba1cf7c574f4503fac7d90999.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Fantaasiafilm",
    "producer": "Aili  Maarja",
    "director": "Viktor Marvin",
    "peaosa": [
      {
        "actor": "Aleksander Domowoy",
        "playing": "Jüri"
      }
    ]
  },
  {
    "id": 19943,
    "title": "Omakohus",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20096/a52cc7ed498683e511b754f14390c0198876b599.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Mirjam Johanna Korsten",
    "director": "German Golub",
    "peaosa": [
      {
        "actor": "Üllar Saaremäe",
        "playing": "Jüri"
      },
      {
        "actor": "Erki Laur",
        "playing": "Võõras"
      }
    ]
  },
  {
    "id": 20012,
    "title": "Siidkindad",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20165/dc862aebe637f34b87c93003c65508f0cd82b43c.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Veera Tapper",
    "director": "Veera Tapper",
    "peaosa": [
      {
        "actor": "Alma Äijö",
        "playing": "Aino"
      },
      {
        "actor": "Alma Nurminen",
        "playing": "Sini"
      }
    ]
  },
  {
    "id": 20020,
    "title": "Kui eestlased...",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20173/61611cf34d1fb2240c3c4575e47835d7eb2a073e.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Telesaade",
    "genre": "",
    "producer": "Anatoli Tafitšuk",
    "director": "Liis Lindmaa",
    "peaosa": [
      {
        "actor": "Mari Pokinen",
        "playing": "Eestlane"
      },
      {
        "actor": "Mikk Jürjens",
        "playing": "Eestlane"
      },
      {
        "actor": "Tõnis Niinemets",
        "playing": "Eestlane"
      },
      {
        "actor": "Anatoli Tafitšuk",
        "playing": "Eestlane"
      },
      {
        "actor": "Märt Pius",
        "playing": "Eestlane"
      },
      {
        "actor": "Maiken Schmidt",
        "playing": "Eestlane"
      },
      {
        "actor": "Saara Kadak",
        "playing": "Eestlane"
      },
      {
        "actor": "Kait Kall",
        "playing": "Eestlane"
      },
      {
        "actor": "Ott Kartau",
        "playing": "Eestlane"
      },
      {
        "actor": "Linda Kolde",
        "playing": "Eestlane"
      },
      {
        "actor": "Doris Tääker",
        "playing": "Eestlane"
      }
    ]
  },
  {
    "id": 20027,
    "title": "Kõik teavad",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20180/7dbd1e2dda179957d063379dd67db3296e7ba4fb.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Sander Lebreht",
    "director": "Siddhartha Nuni",
    "peaosa": [
      {
        "actor": "Marii Piller",
        "playing": "Marii"
      },
      {
        "actor": "Andri Arula",
        "playing": "Isa"
      },
      {
        "actor": "Marika Suu",
        "playing": "Ema"
      },
      {
        "actor": "Christer Tasa",
        "playing": "Christer"
      }
    ]
  },
  {
    "id": 20028,
    "title": "Eluvõlu",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20181/f03edd5f13750f0f1a3db370a2762be65788389d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Telesaade",
    "genre": "",
    "producer": "Brit Suurraid",
    "director": "Ketevan Urushadze",
    "peaosa": [
      {
        "actor": "Helgi Ilo",
        "playing": "Anne"
      }
    ]
  },
  {
    "id": 20031,
    "title": "Väljapääs",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20184/7fa8ab94731f59630ec63fc74a21f85efefbcd65.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Stina Tiigimäe",
    "director": "Rauno Polman",
    "peaosa": [
      {
        "actor": "Kristjan Poom",
        "playing": "Villem"
      },
      {
        "actor": "Stefan Hein",
        "playing": "Aarold"
      },
      {
        "actor": "Jaune Kimmel",
        "playing": "Maile"
      },
      {
        "actor": "Karl Bussov",
        "playing": "Maile mees"
      },
      {
        "actor": "Volli Käro",
        "playing": "Juulius"
      }
    ]
  },
  {
    "id": 20049,
    "title": "Patt",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20202/7fa1f35cdeeca1e24bf513de8dbaf7ae2f65df94.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Matthias  Markus",
    "director": "John Strandberg",
    "peaosa": [
      {
        "actor": "Anja Bargum",
        "playing": "Päivi"
      },
      {
        "actor": "Omar Albajare",
        "playing": "Abdulla"
      },
      {
        "actor": "Thomas Henriksson",
        "playing": "Vikaar"
      }
    ]
  },
  {
    "id": 20053,
    "title": "REC",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20206/dd143345e7128198f49c32ff6646d7150c5c0c18.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Põnevusfilm",
    "producer": "Sindija Vitola",
    "director": "Linda Ekaterincheva",
    "peaosa": [
      {
        "actor": "Argo Ilves",
        "playing": "Turvamee"
      }
    ]
  },
  {
    "id": 20054,
    "title": "Pugeja",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20207/cafb925d5d40f8ba4a65d599094c438a21354c9f.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Johannes Magnus Aule, Maria Kriisa",
    "director": "Peter Chestnut",
    "peaosa": [
      {
        "actor": "Jaanika Arum",
        "playing": "Maria Salu"
      },
      {
        "actor": "Meelis Rämmeld",
        "playing": "Edgar Janson"
      },
      {
        "actor": "Maria  Luiga",
        "playing": "Katarina Leps"
      },
      {
        "actor": "Aarne Piigert",
        "playing": "Jaanus Kolm"
      }
    ]
  },
  {
    "id": 20064,
    "title": "Lõpp",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20217/07f7e0ca5dff9cdfa04bc4a0cc11fabbd2b5f343.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Hanna Kruusi",
    "director": "Sandra Kartau",
    "peaosa": [
      {
        "actor": "Katariina Unt",
        "playing": "Linda Laas"
      },
      {
        "actor": "Jonas Nurmsalu",
        "playing": "Jakob Välu"
      }
    ]
  },
  {
    "id": 20078,
    "title": "Roosi",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20231/fde416fee35e5c7a4e08a105e346e5025a694707.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Põnevusfilm",
    "producer": "Els Kaev",
    "director": "Laura Smolski",
    "peaosa": [
      {
        "actor": "Maria Helena Seppik",
        "playing": "Roosi"
      },
      {
        "actor": "Reemus Tõniste",
        "playing": "Karl"
      },
      {
        "actor": "Jürgen Gansen",
        "playing": "Tom"
      }
    ]
  },
  {
    "id": 20119,
    "title": "Lummuses",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20272/47e2c8a3a78cbc63672aa6a1451f06069c7f645c.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Armastusfilm",
    "producer": "Sander Lebreht",
    "director": "Alesja Suzdaltseva",
    "peaosa": [
      {
        "actor": "Tõnu Talpsep",
        "playing": "Vello"
      },
      {
        "actor": "Külli Pallo",
        "playing": "Silvi"
      }
    ]
  },
  {
    "id": 20128,
    "title": "Sõlm",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20281/6bee4a053d1e6cb1bc7f5631239e0103012ee1d3.JPG",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Noorahaya Lahtee",
    "director": "Andres Losada",
    "peaosa": [
      {
        "actor": "Hans Matthias Kari",
        "playing": "Anton"
      },
      {
        "actor": "Markus Lehtsalu",
        "playing": "Markus"
      },
      {
        "actor": "Miikael Aun",
        "playing": "Aksel"
      },
      {
        "actor": "Teet Tammelaan",
        "playing": "Gingerhead"
      },
      {
        "actor": "Aaron Thor Härm",
        "playing": "Blondie"
      }
    ]
  },
  {
    "id": 20137,
    "title": "Vahetus",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20290/e270ff89dec119a6ca1cd642aacfe6f76e30a7df.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "PõnevusfilmŽanr: DraamaŽanr: Õudusfilm",
    "producer": "Nare Leone Ter-Gabrielyan",
    "director": "Noah Ambrose",
    "peaosa": [
      {
        "actor": "Lauli Otsar",
        "playing": "Tuuli"
      },
      {
        "actor": "Ott Kartau",
        "playing": "Kaspar"
      },
      {
        "actor": "Peeter Volkonski",
        "playing": "Šamaan"
      }
    ]
  },
  {
    "id": 20150,
    "title": "Tuhk ja tolm",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20303/77f51c20e5a92c96775376fa2d52b8adc07d7b29.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Laura Laasi",
    "director": "Liis Lindmaa",
    "peaosa": [
      {
        "actor": "Liis Lass",
        "playing": "Klara"
      }
    ]
  },
  {
    "id": 20162,
    "title": "U48 2017: Ema surm",
    "year": "2017",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20315/b3daed746d5432c787c942a90c57ce66ae185f9f.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kamilla Selina Lepik",
    "director": "Teemu Kettunen",
    "peaosa": [
      {
        "actor": "Carmen Mikiver",
        "playing": "Sofia"
      },
      {
        "actor": "Karina Nõgisto",
        "playing": "Õie"
      },
      {
        "actor": "Meelis Rondo",
        "playing": "Petri"
      }
    ]
  },
  {
    "id": 20175,
    "title": "Taas on päev",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20328/b2f4fe19df42abcc1a5ae3f3dc20c3ec517ca6db.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Muusika/tantsu",
    "producer": "",
    "director": "Emeri Abel",
    "peaosa": [
      {
        "actor": "Mehis Saaber",
        "playing": "Tantsija"
      }
    ]
  },
  {
    "id": 20181,
    "title": "Instituut",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20334/c6c648086ecb891fef4a4a12feef1ab3c269ae9d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Ulmefilm",
    "producer": "Mart Albert Mustkivi, Marko Aia",
    "director": "Mart Albert Mustkivi",
    "peaosa": [
      {
        "actor": "Johannes Viik",
        "playing": "Patsient"
      },
      {
        "actor": "Eky Yerin",
        "playing": "Richard Hill"
      }
    ]
  },
  {
    "id": 20197,
    "title": "Üle lahe",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20350/3a62b298d02e196285406cf67ae09397bfefd824.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Sander Lebreht",
    "director": "Oliver Remma",
    "peaosa": [
      {
        "actor": "Jonathan Peterson",
        "playing": "Ivo"
      },
      {
        "actor": "Helari Saaremäe",
        "playing": "Praktikant"
      },
      {
        "actor": "Villem Roosa",
        "playing": "Ehitaja"
      }
    ]
  },
  {
    "id": 20199,
    "title": "Kaevik",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20352/4d52a454ef3beabfb55c38527b88a7f5fffc9460.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Mattias Veermets",
    "director": "Tarvi Roos",
    "peaosa": [
      {
        "actor": "Märten Matsu",
        "playing": "Reamees Lepp"
      }
    ]
  },
  {
    "id": 20234,
    "title": "Mockingbird",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20387/8934602978e1f9e77606c47d610c1d3b3796aaaa.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Siddhartha Nuni",
    "director": "Siddhartha Nuni",
    "peaosa": [
      {
        "actor": "Marili Kobin",
        "playing": "Marili"
      },
      {
        "actor": "Kerly Ritval",
        "playing": "Scout"
      }
    ]
  },
  {
    "id": 20335,
    "title": "Värvid must-valgel",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20488/01d84d63c3c2637b5066631348f9ab3f090f6c3f.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Inger Põder",
    "director": "German Golub",
    "peaosa": [
      {
        "actor": "Tiina Tauraite",
        "playing": "Paula"
      },
      {
        "actor": "Gert Raudsep",
        "playing": "Olavi"
      },
      {
        "actor": "Luule Komissarov",
        "playing": "Reet"
      },
      {
        "actor": "Karmel Naudre",
        "playing": "Tiina"
      }
    ]
  },
  {
    "id": 20337,
    "title": "Amber",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20490/9c02e7a417f81538fcb4c62817e0c6defb705308.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Noorahaya Lahtee",
    "director": "Maria Cecilia Garcia, Martynas Norvaišas",
    "peaosa": [
      {
        "actor": "Liis Lass",
        "playing": "Gabriela"
      },
      {
        "actor": "Doris Tislar",
        "playing": "Amber"
      }
    ]
  },
  {
    "id": 20338,
    "title": "Süsi",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20491/16af84cb8bc47b9149842fbd4fa808883028d038.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Nare Leone Ter-Gabrielyan",
    "director": "Anastasiya Maksymchuk",
    "peaosa": [
      {
        "actor": "Jaanika Arum",
        "playing": "Alice"
      },
      {
        "actor": "Jarmo Reha",
        "playing": "Vlad"
      }
    ]
  },
  {
    "id": 20343,
    "title": "Zoro",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20496/d583eec42c8e3044cc11a2735ecda41c6c5553d5.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Noorahaya Lahtee",
    "director": "Antonio Tainha",
    "peaosa": [
      {
        "actor": "Ülo Haljasorg",
        "playing": "Zoro"
      }
    ]
  },
  {
    "id": 20345,
    "title": "Yasmeena",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20498/da1b99e092d959b3aef2edaed559fac898101214.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Fantaasiafilm",
    "producer": "Merili  Laur",
    "director": "Samer Nimri",
    "peaosa": [
      {
        "actor": "Mirtel Kollo",
        "playing": "Yasmeena"
      },
      {
        "actor": "Kristo Klausson",
        "playing": "Isa"
      }
    ]
  },
  {
    "id": 20346,
    "title": "Reinhold Rotermani",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20499/b15d86effa35d7c682992545929ff3aa57423a8e.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kati Vuks",
    "director": "Khaled M. Almasri",
    "peaosa": [
      {
        "actor": "Saara Nüganen",
        "playing": "Piret"
      },
      {
        "actor": "Liina Tennosaar",
        "playing": "Frida"
      }
    ]
  },
  {
    "id": 20347,
    "title": "Pappnägu",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20500/ba089973aafdc4cd4335e09ca7c7e8565ea6d492.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Detektiivfilm",
    "producer": "Aili  Maarja",
    "director": "Rauno Polman",
    "peaosa": [
      {
        "actor": "Karl Edgar Tammi",
        "playing": "Robert"
      },
      {
        "actor": "Jaanika Tammaru",
        "playing": "Mirt"
      },
      {
        "actor": "Lii Tedre",
        "playing": "Hildegard"
      }
    ]
  },
  {
    "id": 20348,
    "title": "Reiv",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20501/9bfa8fb47f80a040c2c74a58d33accc34b1099a4.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Õudusfilm",
    "producer": "Aili  Maarja",
    "director": "Johannes Magnus Aule",
    "peaosa": [
      {
        "actor": "Kristiin Räägel",
        "playing": "Maarja"
      },
      {
        "actor": "Mart Müürisepp",
        "playing": "Juhan"
      },
      {
        "actor": "Henessi Schmidt",
        "playing": "Eva"
      }
    ]
  },
  {
    "id": 20362,
    "title": "The Organ",
    "year": "2018",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20515/52efb940c68f911df2f0e6ac6ea3103b0bb9d7d6.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Jekaterina Balashova",
    "director": "Ville Kristian Koskinen",
    "peaosa": [
      {
        "actor": "Tiiu Liventaal",
        "playing": "Naine"
      },
      {
        "actor": "Oleg Jashinin",
        "playing": "Boss"
      }
    ]
  },
  {
    "id": 20380,
    "title": "Karm liin",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20534/52ff400fa141cab38363df8b454262622ef8f49e.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Mirjam Johanna Korsten",
    "director": "Teresa Väli",
    "peaosa": [
      {
        "actor": "Ruben Tolk",
        "playing": "Andrus"
      },
      {
        "actor": "Amanda Raadik",
        "playing": "Zanna"
      },
      {
        "actor": "Margaret Inno",
        "playing": "Vera"
      },
      {
        "actor": "Thor Alunurm",
        "playing": "Tiki"
      },
      {
        "actor": "Kert Sihver",
        "playing": "Otto"
      }
    ]
  },
  {
    "id": 20385,
    "title": "Suur skandaal",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20539/3f774d12a7bcd2b5f438c9d209e987f1a4c9b5ef.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kätlin Palmsalu",
    "director": "Anu Sildnik",
    "peaosa": [
      {
        "actor": "Liisu Krass",
        "playing": "Daam rohelises"
      },
      {
        "actor": "Kristian Põldma",
        "playing": "Kaardimängija"
      },
      {
        "actor": "Jürgen Gansen",
        "playing": "Kaardimängija"
      },
      {
        "actor": "Tristan Nava",
        "playing": "Kelner"
      },
      {
        "actor": "Tarvo Sõmer",
        "playing": "August Gailit"
      },
      {
        "actor": "Laura Hirvoja",
        "playing": "Daam kohvikus"
      },
      {
        "actor": "Triinu Paomets",
        "playing": "Pirki daam"
      },
      {
        "actor": "Karl Agapuu",
        "playing": "Akordionist"
      }
    ]
  },
  {
    "id": 20399,
    "title": "Duubel",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20553/e0fc24b531fcc63a674ebab2d9c319be34fcdc8b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Sander Lebreht",
    "director": "Oliver Remma",
    "peaosa": [
      {
        "actor": "Mark Erik Savi",
        "playing": "Timmu"
      },
      {
        "actor": "Hardi Möller",
        "playing": "Uku"
      },
      {
        "actor": "Maarja Mõts",
        "playing": "Kärt"
      },
      {
        "actor": "Roos Parmas",
        "playing": "Liinuška"
      }
    ]
  },
  {
    "id": 20400,
    "title": "Piknik",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20554/45e3065703b473fe8d37eb917f71fffefe1f3e2e.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Kati Vuks",
    "director": "Leo Vissak",
    "peaosa": [
      {
        "actor": "Tuuli Maarja Põldma",
        "playing": "Ursula"
      },
      {
        "actor": "Erik Richard Salumäe",
        "playing": "Sass"
      }
    ]
  },
  {
    "id": 20408,
    "title": "Janu",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20562/f8d87e0881753b0b02007488a09c09dff9c92bab.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Õudusfilm",
    "producer": "Helen Räim",
    "director": "Janeli Pelska",
    "peaosa": [
      {
        "actor": "Rea Lest",
        "playing": "Veronica"
      },
      {
        "actor": "Jaanus Tepomees",
        "playing": "Koeraomanik / Ohver"
      },
      {
        "actor": "Loore Martma",
        "playing": "Annika"
      },
      {
        "actor": "Maarja Johanna Mägi",
        "playing": "Baaridaam"
      },
      {
        "actor": "Markus Truup",
        "playing": "Siim"
      },
      {
        "actor": "Markus Dvinjaninov",
        "playing": "Jüri"
      },
      {
        "actor": "Märten Matsu",
        "playing": "Mihkel"
      }
    ]
  },
  {
    "id": 20409,
    "title": "Toru töö",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20563/827ccc453ae55de293c2c8c29f9ff1a0616b3e86.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Õudusfilm",
    "producer": "Merili  Laur",
    "director": "Raoul  Kirsima",
    "peaosa": [
      {
        "actor": "Mark Erik Savi",
        "playing": "Jaanus"
      },
      {
        "actor": "Merlin Kivi",
        "playing": "Emma"
      },
      {
        "actor": "Jass Kalev Mäe",
        "playing": "Illimar"
      },
      {
        "actor": "Elisabeth Kužovnik",
        "playing": "Lea"
      }
    ]
  },
  {
    "id": 20410,
    "title": "Emme",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20564/c79e193867be023c47956f0c46e48ccc77d85a3a.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Draama",
    "producer": "Sofia Mihhaljova",
    "director": "Raoul  Kirsima",
    "peaosa": [
      {
        "actor": "Kristan Kirsima",
        "playing": "Timo"
      }
    ]
  },
  {
    "id": 20411,
    "title": "Rotimürk",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20565/40e4bc8adbb11b6468108bb84171a685d545f933.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kati Vuks",
    "director": "Alesja Suzdaltseva",
    "peaosa": [
      {
        "actor": "Karel Käos",
        "playing": "Erik"
      },
      {
        "actor": "Maria Teresa Kalmet",
        "playing": "Meeri"
      }
    ]
  },
  {
    "id": 20412,
    "title": "Öörahu",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20566/49c6caa9ed8faf72e7643a6b3a8ac9a55583f1ad.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Antero Noor",
    "director": "Teresa Juksaar",
    "peaosa": [
      {
        "actor": "Margaret Sarv",
        "playing": "Milla"
      }
    ]
  },
  {
    "id": 20413,
    "title": "Koduigatsus",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20567/ff3c38cdf05388956ec3ddec6210675d1e7b54bd.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Jonathan Peterson",
    "director": "Silver Õun",
    "peaosa": [
      {
        "actor": "Kalju-Karl Kivi",
        "playing": "Siim"
      }
    ]
  },
  {
    "id": 20417,
    "title": "Langenud Kättemaksja",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20571/225d004a66959e8d9e918d88303250f979b9f389.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Telesaade",
    "genre": "Komöödiafilm",
    "producer": "Ahmed Fouad Ragab",
    "director": "Olli Niemi",
    "peaosa": [
      {
        "actor": "Christian Reeve",
        "playing": "Vapula"
      }
    ]
  },
  {
    "id": 20421,
    "title": "Süütunne",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20575/eccc191333a488d2920a30d4bd5dad62ada5c463.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Merili  Laur",
    "director": "Silver Õun",
    "peaosa": [
      {
        "actor": "Sander Roosimägi",
        "playing": "Ben"
      }
    ]
  },
  {
    "id": 20423,
    "title": "Eugen",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20577/3bf89f637cb7cafe8e7301bff0b54d94070d66f5.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Merili  Laur",
    "director": "Katariina Aule",
    "peaosa": [
      {
        "actor": "Ingvar Toomas Heamägi",
        "playing": "Eugen"
      }
    ]
  },
  {
    "id": 20425,
    "title": "Et nad ei eksiks",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20580/a65b4185fd7f1c5701281f7d519a3ff2e57f15cd.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "PõnevusfilmŽanr: Draama",
    "producer": "Ahmed Fouad Ragab",
    "director": "Ville Niemi",
    "peaosa": [
      {
        "actor": "Sofia Smeds",
        "playing": "Tütar"
      },
      {
        "actor": "Elina Harju",
        "playing": "Ema"
      },
      {
        "actor": "Mikko Salminen",
        "playing": "Alexander Ekstrom"
      }
    ]
  },
  {
    "id": 20431,
    "title": "God's Infinite Silence",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20586/d7e3445d99360bac66b2f95481c9f199705bc74b.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Telesaade",
    "genre": "Draama",
    "producer": "Baran Ismail Ulas, Jaroslav Bortsov, Eldar Basmanov",
    "director": "Eldar Basmanov",
    "peaosa": [
      {
        "actor": "Eduard Tee",
        "playing": "Isa Fyodor"
      },
      {
        "actor": "Aleksei Philippov",
        "playing": "Victor"
      }
    ]
  },
  {
    "id": 20432,
    "title": "Naerumaa",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20587/ba713169c691ac04f9abf0e1bba744896b99b755.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Katharina Kuusemets",
    "director": "Pedro Daniel Vital",
    "peaosa": [
      {
        "actor": "Meelis Rondo",
        "playing": "Töömees"
      }
    ]
  },
  {
    "id": 20434,
    "title": "The Contentment",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20589/c69fc57988d93eaa70f586f37a3a4d478d5b0db6.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Risto Pirnpuu",
    "director": "Ernesto  Redondo Vergara",
    "peaosa": [
      {
        "actor": "Helena Merzin-Tamm",
        "playing": "Ada"
      },
      {
        "actor": "Grete Konksi",
        "playing": "Elis"
      }
    ]
  },
  {
    "id": 20449,
    "title": "Zorg 2",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20604/281affbeab9afd1791fae24980345a44ffbdc67b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Animafilm",
    "genre": "KomöödiafilmŽanr: Ulmefilm",
    "producer": "Auden Lincoln-Vogel",
    "director": "Auden Lincoln-Vogel",
    "peaosa": [
      {
        "actor": "Sally Lincoln-Vogel",
        "playing": "(Hääl)"
      },
      {
        "actor": "Kirsten Sogaard",
        "playing": "(Hääl)"
      }
    ]
  },
  {
    "id": 20467,
    "title": "Tammjärve Kurikad",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20622/2fdd90a6ee9849986175282d1bd1637a24a4ada0.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Draama",
    "producer": "Kristiana Kalnina",
    "director": "Oto Klavins",
    "peaosa": [
      {
        "actor": "Karl Jakob Bartels",
        "playing": "Oliver Kook"
      }
    ]
  },
  {
    "id": 20468,
    "title": "Päeva Printsess",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20623/a93f813214b79869d5c0fd620fa293a1dd5ced4c.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Telesaade",
    "genre": "Draama",
    "producer": "Kristiana Kalnina",
    "director": "Mariann Jüriorg",
    "peaosa": [
      {
        "actor": "Una Marta Soms",
        "playing": "Mandy"
      },
      {
        "actor": "Ragne Veensalu",
        "playing": "Bibi"
      },
      {
        "actor": "Madis Kuusik",
        "playing": "Mart"
      }
    ]
  },
  {
    "id": 20473,
    "title": "Mu kallid laibad",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20628/0f3dd1c0a89afa78d0a070f2ed111afd821e1a82.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Draama",
    "producer": "Sander Lebreht, Antero Noor",
    "director": "German Golub",
    "peaosa": [
      {
        "actor": "Ruuben-Joosua Palu",
        "playing": "Erki"
      },
      {
        "actor": "Erki Laur",
        "playing": "Ott"
      }
    ]
  },
  {
    "id": 20478,
    "title": "Duett",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20633/925570b8f921194ac801e5c79bfbc24346af87bc.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Draama",
    "producer": "Kati Vuks",
    "director": "Teresa Juksaar",
    "peaosa": [
      {
        "actor": "Lisanna Lajal",
        "playing": "Veera"
      },
      {
        "actor": "Johanna Poll",
        "playing": "Karmen"
      }
    ]
  },
  {
    "id": 20479,
    "title": "Shopping",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20634/96f872c13285a1e8147ff8428c8f2afbda553142.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Õudusfilm",
    "producer": "Kati Vuks",
    "director": "Katariina Aule",
    "peaosa": [
      {
        "actor": "Mari Abel",
        "playing": "Valeria"
      }
    ]
  },
  {
    "id": 20482,
    "title": "See räägib pulmast",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20637/69d522e7de6222280fb93880569607bac843f652.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Draama",
    "producer": "Hanna Maria Toome",
    "director": "Vivian Säde",
    "peaosa": [
      {
        "actor": "Grete Jürgenson",
        "playing": "Kirjanik"
      },
      {
        "actor": "Kristjan Lüüs",
        "playing": "Peigmees"
      },
      {
        "actor": "Ingrid Margus",
        "playing": "Pruut"
      }
    ]
  },
  {
    "id": 20492,
    "title": "Teene",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20647/ac8cc2a84eb295432954c9fec62980df6bda82a0.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Põnevusfilm",
    "producer": "Sigrid Salutee",
    "director": "Bojana Babic",
    "peaosa": [
      {
        "actor": "Raphael Zari",
        "playing": "Saeed"
      },
      {
        "actor": "Tiina Tauraite",
        "playing": "Ellen"
      },
      {
        "actor": "Veikko Laaneoks",
        "playing": "Lauri"
      }
    ]
  },
  {
    "id": 20493,
    "title": "Ainult üks",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20648/dc19befb065a3766d40478fc2c81c7560298f70f.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Melik Demirel",
    "director": "Jessica Sattabongkot",
    "peaosa": [
      {
        "actor": "Katrin Koskela",
        "playing": "Anni"
      },
      {
        "actor": "Elis Järvsoo",
        "playing": "Juulia"
      },
      {
        "actor": "Liisu Krass",
        "playing": "Kim"
      },
      {
        "actor": "Eric Romero",
        "playing": "Eric"
      }
    ]
  },
  {
    "id": 20495,
    "title": "Ajakapsel",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20650/a0bacdd4ccb0fd90ee4bfc33f25362dc1ea519ac.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Mirjam Ruut",
    "director": "Eric Romero",
    "peaosa": [
      {
        "actor": "Loviise Kapper",
        "playing": "Emeri"
      },
      {
        "actor": "Meelis Rämmeld",
        "playing": "Andres"
      },
      {
        "actor": "Helena Maria Reisner",
        "playing": "Noor Emeri"
      }
    ]
  },
  {
    "id": 20496,
    "title": "Kuiv maa",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20651/96643e90d6045edb60cfd9ea3e86485e05e42ea4.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kristjan Pütsep",
    "director": "Maria Reinup",
    "peaosa": [
      {
        "actor": "Anne Türnpu",
        "playing": "Mirtel"
      },
      {
        "actor": "Santeri Helinheimo Mäntylä",
        "playing": "Ari"
      }
    ]
  },
  {
    "id": 20511,
    "title": "Lockdown",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20667/0e03f0f5bf2c16b00a028de99642c10e78762d18.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Niina Rostovtseva",
    "director": "Niina Rostovtseva",
    "peaosa": [
      {
        "actor": "Olga Grišina",
        "playing": "Katya"
      },
      {
        "actor": "Vladimir Aleksejev",
        "playing": "Michail"
      }
    ]
  },
  {
    "id": 20512,
    "title": "Kõik puhas",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20668/9122b114a7051dfb866f52fcc3bf832069d8c0c5.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Evelina Romanenkova, Kristiana Kalnina",
    "director": "Eliza Benina",
    "peaosa": [
      {
        "actor": "Juris  Strenga",
        "playing": "Majahoidja Ivars"
      },
      {
        "actor": "Rudolfs Gedinš",
        "playing": "Treener Toms"
      },
      {
        "actor": "Elizabete Moisjuka",
        "playing": "Lelde"
      },
      {
        "actor": "Zane Jančevska",
        "playing": "Koolijuhataja"
      },
      {
        "actor": "Raitis  Dadzis",
        "playing": "Valvur"
      }
    ]
  },
  {
    "id": 20516,
    "title": "Vaata, mis sa tegid",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20672/20ae9aa87d3ed24b45ff35d067c4326a6aab357f.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Georg Puhm",
    "director": "Carlos Eduardo Lesmes Lopéz",
    "peaosa": [
      {
        "actor": "Pääru Oja",
        "playing": "Ingmar"
      },
      {
        "actor": "Jaanika Arum",
        "playing": "Anne"
      }
    ]
  },
  {
    "id": 20582,
    "title": "M3RCORY",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20738/4e2251f2f6cdb6cca6bae5bfd71df9ae545ac4d5.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Põnevusfilm",
    "producer": "Katerina Tzolas",
    "director": "Katariina Rahumägi",
    "peaosa": [
      {
        "actor": "Oskar Seeman",
        "playing": "Aaron"
      },
      {
        "actor": "Margareth Sonntak",
        "playing": "Deivi"
      }
    ]
  },
  {
    "id": 20586,
    "title": "Tallata kingad",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20742/b2be7c11d63b6462acbee0d7e300b2abd5be252d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Risto Pirnpuu",
    "director": "Ernesto  Redondo Vergara",
    "peaosa": [
      {
        "actor": "Toomas Tross",
        "playing": "Eno"
      },
      {
        "actor": "Stefan Hein",
        "playing": "Beto"
      },
      {
        "actor": "Helena Merzin-Tamm",
        "playing": "Bata"
      }
    ]
  },
  {
    "id": 20587,
    "title": "Saadetised",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20743/9762f410bc7a1ee019a11e843a3209c9fa726b0a.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kertu Viira",
    "director": "Lauri Niemelä",
    "peaosa": [
      {
        "actor": "Cyprien Chiatoh",
        "playing": "Chia"
      },
      {
        "actor": "Katrin Nielsen",
        "playing": "Piret Tamm"
      }
    ]
  },
  {
    "id": 20589,
    "title": "Süngelt tuled",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20745/dc0e195f1c35f3becfca41d08f638a1c520e5f6d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Els Kaev",
    "director": "Sander Gering",
    "peaosa": [
      {
        "actor": "Laura Kukk",
        "playing": "Nele"
      },
      {
        "actor": "Johannes Richard Sepping",
        "playing": "Alo"
      }
    ]
  },
  {
    "id": 20594,
    "title": "Lõplik õnnelikkus",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20750/f93fd9d905a213058749611b6a5a05ff391d73f8.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Mauricio Tunaroza Romero",
    "director": "Eric Romero",
    "peaosa": [
      {
        "actor": "Rachel Flynn",
        "playing": "Miranda"
      },
      {
        "actor": "Roisin Brehony",
        "playing": "Fran"
      },
      {
        "actor": "Mart Sander",
        "playing": "Taavi"
      }
    ]
  },
  {
    "id": 20600,
    "title": "Kapten Anti-Dieet Mees",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20756/6a80b8bce8464204bf125ff83c7624bd91cfdc78.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Raul Esko, Romet Esko",
    "director": "Raul Esko, Romet Esko",
    "peaosa": [
      {
        "actor": "Raul Esko",
        "playing": "Kapten"
      },
      {
        "actor": "Mark Sagar",
        "playing": "Juustor"
      },
      {
        "actor": "Jaco Lembit Sepp",
        "playing": "Vegetron"
      },
      {
        "actor": "Katariina Lassel",
        "playing": "Malviina"
      }
    ]
  },
  {
    "id": 20609,
    "title": "Lõvitekk",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20765/83ae5f953df65d0f5bedb01595536fcdac66bd1d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Evelina Romanenkova",
    "director": "Sofia Afonasina",
    "peaosa": [
      {
        "actor": "Katariina Unt",
        "playing": "Berta"
      },
      {
        "actor": "Leene Vugts",
        "playing": "Klara"
      },
      {
        "actor": "Tanel Saar",
        "playing": "Uurija"
      }
    ]
  },
  {
    "id": 20645,
    "title": "MIA: Kassiahastus",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20801/5b3c6175584a169de1705dd90cf06867129b7937.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Animafilm",
    "genre": "Draama",
    "producer": "Johanna Randmann",
    "director": "Johanna Randmann",
    "peaosa": [
      {
        "actor": "Johanna Randmann",
        "playing": "Mia"
      }
    ]
  },
  {
    "id": 20648,
    "title": "Emane",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20804/10e584578fe5e73d4e8dcd939e9e18a92d2a734b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Ville Niemi, Miika Ekström",
    "director": "Ville Niemi",
    "peaosa": [
      {
        "actor": "Benjamin Klemettinen",
        "playing": "Johannes"
      },
      {
        "actor": "Joel Hirvonen",
        "playing": "Aleksi"
      },
      {
        "actor": "Jussi Lankoski",
        "playing": "Markus"
      },
      {
        "actor": "Fikrete Miftari",
        "playing": "Liisa"
      },
      {
        "actor": "Kirsi Poutanen",
        "playing": "Uudisteankur"
      },
      {
        "actor": "Antero Raanoja",
        "playing": "Jahimees"
      }
    ]
  },
  {
    "id": 20649,
    "title": "Puugist on veel kasu",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20805/b21a2afa6d81fb99feffe329ff4b80f83f7006d7.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "",
    "producer": "Kristjan Talu",
    "director": "Kristjan Talu, Anet Maripuu",
    "peaosa": [
      {
        "actor": "Otto-Valter Väinaste",
        "playing": "Vend I"
      },
      {
        "actor": "Karel Käos",
        "playing": "Vend II"
      }
    ]
  },
  {
    "id": 20650,
    "title": "Alppila’s Pharmacy - Who owns those muscles?",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20807/7d9d65ecddbac407610dc601c9eea2116116bf3f.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Muusikavideo",
    "genre": "",
    "producer": "Vivian Ruumet",
    "director": "Ville Niemi",
    "peaosa": [
      {
        "actor": "Ville Niemi",
        "playing": "Nerd"
      },
      {
        "actor": "Sandra Roosme",
        "playing": "Hot Girl"
      },
      {
        "actor": "Marko Viik",
        "playing": "Guy 1"
      },
      {
        "actor": "Janar Goddo",
        "playing": "Guy 2"
      },
      {
        "actor": "Gert Goršanov",
        "playing": "Guy3"
      }
    ]
  },
  {
    "id": 20652,
    "title": "Pidox - Dinner is Served",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20809/09779bb40c5abbed04388dd7eb91b7700e5e3c5f.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Muusikavideo",
    "genre": "Komöödiafilm",
    "producer": "Kristiana Kalnina",
    "director": "Oto Klavins, Rinalts Ignass",
    "peaosa": [
      {
        "actor": "Stelle Enn",
        "playing": "Kuri vanaema"
      },
      {
        "actor": "Reeni Painik",
        "playing": "Hea vanaema"
      },
      {
        "actor": "Romet Esko",
        "playing": "Lapselaps"
      }
    ]
  },
  {
    "id": 20662,
    "title": "IX korrus",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20819/0295b47c64ca0c75c6a19e9375036a6ae07e8b94.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "",
    "producer": "Maiken Palm",
    "director": "Vivian Ruumet",
    "peaosa": [
      {
        "actor": "Lena Barbara Luhse",
        "playing": "Lili"
      },
      {
        "actor": "Tom Kalvik",
        "playing": "Paul"
      },
      {
        "actor": "Steven-Kristjan Tšoba",
        "playing": "Andres"
      },
      {
        "actor": "Kristjan Poom",
        "playing": "Raimond"
      }
    ]
  },
  {
    "id": 20688,
    "title": "Seest välja",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20845/b93daa5102b0358755eaf929ce97acea4565e2e6.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "PõnevusfilmŽanr: Õudusfilm",
    "producer": "Christina Kraft",
    "director": "Johanna Alvin",
    "peaosa": [
      {
        "actor": "Jan Roos",
        "playing": "Felix"
      },
      {
        "actor": "Mattias Nurga",
        "playing": "Henry"
      }
    ]
  },
  {
    "id": 20689,
    "title": "Talent",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20846/fe40dceeed15c6bd1c70638bffaf6a7ec8e90570.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Sander Lebreht",
    "director": "Silver Õun",
    "peaosa": [
      {
        "actor": "Markus Truup",
        "playing": "Andreas"
      },
      {
        "actor": "Katariina Tamm",
        "playing": "Lo"
      }
    ]
  },
  {
    "id": 20696,
    "title": "Serotoniin",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20853/9814259c4d3f2bb287ea08d766be9d81fb6ed7d6.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Muusikavideo",
    "genre": "",
    "producer": "Kadri Veisner",
    "director": "Kadri Veisner",
    "peaosa": [
      {
        "actor": "Henry (Genka) Kõrvits",
        "playing": "Modell"
      },
      {
        "actor": "Karina Auli",
        "playing": "Modell"
      },
      {
        "actor": "Carine Jessica Kostla",
        "playing": "Modell"
      },
      {
        "actor": "Käthlin Pähn",
        "playing": "Modell"
      },
      {
        "actor": "Maria-Elisabeth Lootus",
        "playing": "Modell"
      },
      {
        "actor": "Iris Abdullajev",
        "playing": "Modell"
      },
      {
        "actor": "Denis Tihhomirov",
        "playing": "Modell"
      }
    ]
  },
  {
    "id": 20697,
    "title": "Vanad mehed ja meri",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20854/4eb5f287f652e85dc5c667da650ec9028136cbc4.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Melik Demirel",
    "director": "Daria Litvichenko",
    "peaosa": [
      {
        "actor": "Lembit Peterson",
        "playing": "Johannes"
      }
    ]
  },
  {
    "id": 20700,
    "title": "Kuningas",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20857/16c56b608f9fb4d3b8bdad838f1e572f6c055b59.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Sofia Mihhaljova",
    "director": "Teresa Juksaar",
    "peaosa": [
      {
        "actor": "Aarne Soro",
        "playing": "Olev"
      },
      {
        "actor": "Saskia Rebeka Vaarend",
        "playing": "Tüdruk"
      }
    ]
  },
  {
    "id": 20705,
    "title": "Koletis",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20862/0728be71024664299d9b0c128c2579917048ddca.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Põnevusfilm",
    "producer": "Kati Vuks",
    "director": "Oliver Remma",
    "peaosa": [
      {
        "actor": "Teele Valdlo",
        "playing": "Cathy"
      },
      {
        "actor": "Mart Müürisepp",
        "playing": "Koletis"
      }
    ]
  },
  {
    "id": 20709,
    "title": "Vinguv jalaluu",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20866/35346138ad77feada1459125e424eb67e3663fc4.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Fantaasiafilm",
    "producer": "Merili  Laur",
    "director": "Katariina Aule",
    "peaosa": [
      {
        "actor": "Silva Pijon",
        "playing": "Harriet"
      },
      {
        "actor": "Grete Konksi",
        "playing": "Manguja"
      }
    ]
  },
  {
    "id": 20711,
    "title": "Atleet",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20868/8b01cf65d0beedb5326a24571e3a3d8845cec686.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Draama",
    "producer": "Triin Rennit",
    "director": "Greta Liht",
    "peaosa": [
      {
        "actor": "Helari Saaremäe",
        "playing": "Poeg"
      }
    ]
  },
  {
    "id": 20713,
    "title": "Õmblusmasinad",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20870/510280a4cff2b80789b6ca5890702f345eceb7b4.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Antero Noor",
    "director": "Alesja Suzdaltseva",
    "peaosa": [
      {
        "actor": "Tarmo Song",
        "playing": "Tirr"
      },
      {
        "actor": "Liis Lass",
        "playing": "Annemari"
      },
      {
        "actor": "Maria Peterson",
        "playing": "Marta"
      }
    ]
  },
  {
    "id": 20727,
    "title": "Come Out Sinner",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20884/1ab5a141ef6dac86bd7f8d5691eaae945fc14501.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Põnevusfilm",
    "producer": "Volodymyr  Golovko",
    "director": "Ksenia  Buzhbetskaya",
    "peaosa": [
      {
        "actor": "Ronald Pelin",
        "playing": "Egor"
      },
      {
        "actor": "Indrek Arula",
        "playing": "Lembit"
      },
      {
        "actor": "Liisa Linhein",
        "playing": "Vaike"
      },
      {
        "actor": "Jegor Sevastjanov",
        "playing": "Esoteerik"
      }
    ]
  },
  {
    "id": 20728,
    "title": "Öö Baaris",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20885/1d60b48392a45cee099c94a155389800d75c5141.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Olli Niemi, Baran Ismail Ulas",
    "director": "Eldar Basmanov",
    "peaosa": [
      {
        "actor": "Oto Klavins",
        "playing": "Larry"
      },
      {
        "actor": "Mark Sagar",
        "playing": "Roma"
      },
      {
        "actor": "Hendrik  Lõhmus",
        "playing": "Karl"
      }
    ]
  },
  {
    "id": 20730,
    "title": "Minu sünnipäevapidu",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20887/defa20808d09b8c698de597dda69e8bf82ca1399.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Muusika/tantsu",
    "producer": "Aline Belfort, Rafael Melo",
    "director": "Aline Belfort, Rafael Melo",
    "peaosa": [
      {
        "actor": "Karoline Suhhov",
        "playing": "Tüdruk"
      },
      {
        "actor": "Samuel Koppel",
        "playing": "Tüdruk"
      }
    ]
  },
  {
    "id": 20731,
    "title": "Palun, olge palun vait",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20888/2ff68bd6b4481b3c4547db56df227f9dbc34acdd.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Muusika/tantsu",
    "producer": "",
    "director": "Prem Jyothis, Tul Paloma Rodriguez",
    "peaosa": [
      {
        "actor": "Erena Reilent",
        "playing": "Tantsija"
      },
      {
        "actor": "Mihkel Ernist",
        "playing": "Tantsija"
      }
    ]
  },
  {
    "id": 20732,
    "title": "Leidsin",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20889/4cd1aab51fa8be7ec8956d82de1be276f44bea41.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "PõnevusfilmŽanr: Draama",
    "producer": "Laura García Baeza",
    "director": "Ragne Mandri",
    "peaosa": [
      {
        "actor": "Mirtel Muga",
        "playing": "Agnes"
      },
      {
        "actor": "Filipp Varik",
        "playing": "Mihkel"
      },
      {
        "actor": "Evgeny Moissenko",
        "playing": "Dmitri"
      }
    ]
  },
  {
    "id": 20733,
    "title": "Mälu püsivus",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20890/838e20cca67d8e183a9aff223ffc219cf2842026.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Triin Hook",
    "director": "Carlos Eduardo Lesmes Lopéz",
    "peaosa": [
      {
        "actor": "Steffi Pähn",
        "playing": "Ettekandja"
      },
      {
        "actor": "Jarmo Reha",
        "playing": "Poiss"
      },
      {
        "actor": "Kaija Maarit Kalvet",
        "playing": "Direktor"
      },
      {
        "actor": "Villu Kangur",
        "playing": "Vana mees"
      }
    ]
  },
  {
    "id": 20734,
    "title": "Uibu Talu",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20891/2368c059b8a96dc3a9e1ddacad674d3ab9ff22a7.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Andrea Uibo, Bia Tafner",
    "director": "Ivar Erik Yeoman",
    "peaosa": [
      {
        "actor": "Peeter Volkonski",
        "playing": "Vanaisa Kristof"
      },
      {
        "actor": "Andres Mähar",
        "playing": "Isa Johan"
      },
      {
        "actor": "Karl-Kristjan Puusepp",
        "playing": "Poeg Mart"
      }
    ]
  },
  {
    "id": 20736,
    "title": "Göllia",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20895/9098b9f5113b7c9b9db50620aaceb243ded8d591.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Georg Puhm",
    "director": "Gergely Lőrinczi",
    "peaosa": [
      {
        "actor": "Eduard Tee",
        "playing": "Göllia"
      }
    ]
  },
  {
    "id": 20737,
    "title": "Tule jälg",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20896/800d10aa9a4081dcb510ca8fb85ceac0d211095b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Põnevusfilm",
    "producer": "Kaili Lehtemaa",
    "director": "Diego Alejandro  Barajas",
    "peaosa": [
      {
        "actor": "Marko Sarv",
        "playing": "Marko"
      },
      {
        "actor": "Peeter Rästas",
        "playing": "Peeter"
      },
      {
        "actor": "Austin Raimond Kell",
        "playing": "Sander"
      }
    ]
  },
  {
    "id": 20738,
    "title": "LUKUS",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20897/da0c0cf64387a2078c7a7cdbe8bae6859f1c9c84.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Mirjam Ruut",
    "director": "Umut Vedat",
    "peaosa": [
      {
        "actor": "Jaanika Arum",
        "playing": "Rea"
      }
    ]
  },
  {
    "id": 20739,
    "title": "Aurora Laul",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20898/7cc41a22a03c0c3cf5f0302fa80cef8ffbf60b9f.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Nevena Semova, Andjela Lazic",
    "director": "Stella Carneiro",
    "peaosa": [
      {
        "actor": "Ester Kuntu",
        "playing": "Margit"
      }
    ]
  },
  {
    "id": 20740,
    "title": "Days Without",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20899/35764ff590221e9aff48c383ef40855ecf320802.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Bia Tafner",
    "director": "Ivar Erik Yeoman",
    "peaosa": [
      {
        "actor": "Nikolai Bentsler",
        "playing": "Nikolai"
      },
      {
        "actor": "Aurora Emily Trubetsky",
        "playing": "Sophia (Sonya)"
      }
    ]
  },
  {
    "id": 20741,
    "title": "Hällilaul",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20900/718ad3de5ca01340e3b8c6229febcc43391e8127.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Põnevusfilm",
    "producer": "Külli Kaljulind, Ville Niemi",
    "director": "Ville Niemi",
    "peaosa": [
      {
        "actor": "Mirtel Pohla",
        "playing": "Laura Koppel"
      },
      {
        "actor": "Rain Tolk",
        "playing": "Sander Koppel"
      },
      {
        "actor": "Arabella Pall",
        "playing": "Klaara Koppel"
      }
    ]
  },
  {
    "id": 20742,
    "title": "Mina ja tema",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20901/97ab34d3d248b42dfcade15a0aec72ccc08020e0.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Dokumentaalfilm",
    "genre": "",
    "producer": "Ahmed Fouad Ragab",
    "director": "Eldar Basmanov, Ahmed Fouad Ragab",
    "peaosa": [
      {
        "actor": "Jelena Tarassenko",
        "playing": "Vanaema"
      },
      {
        "actor": "Kaarina Naur",
        "playing": "Külaline 1"
      },
      {
        "actor": "Krista Heinpalu",
        "playing": "Külaline 2"
      }
    ]
  },
  {
    "id": 20743,
    "title": "Rooste vahele eksinud",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20902/9c321cb51367b2956389edc1bf43e683f629b784.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Kaspars Grabovskis",
    "director": "Rudolfs Anže",
    "peaosa": [
      {
        "actor": "Sandis Runge",
        "playing": "Nauris"
      },
      {
        "actor": "Uldis  Anže",
        "playing": "Andrejs"
      }
    ]
  },
  {
    "id": 20769,
    "title": "Kättemaksuingel",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20928/3afd45a3a9fd5265253c280b7715d4f910d52a54.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Põnevusfilm",
    "producer": "David Daudu",
    "director": "Stefania  Makarenko",
    "peaosa": [
      {
        "actor": "Erik Vent",
        "playing": "Andrew"
      },
      {
        "actor": "Madis Kareda",
        "playing": "Taurus"
      }
    ]
  },
  {
    "id": 20771,
    "title": "Nostalgia",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20930/72303bcb7bf4589c5c9cefc5578ef8b1b0ad9008.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "",
    "producer": "Camilla Saar",
    "director": "Brandon Povilaitis",
    "peaosa": [
      {
        "actor": "Karel Airapetjan",
        "playing": "Mees"
      },
      {
        "actor": "Tairi Tuulik",
        "playing": "Naine"
      },
      {
        "actor": "Helena Saks",
        "playing": "Tüdruk"
      },
      {
        "actor": "Martin Pedari",
        "playing": "Poiss"
      }
    ]
  },
  {
    "id": 20784,
    "title": "Moemull",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20943/aa97755cf3dbf26035aa61050b75e0513e135086.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Telesaade",
    "genre": "",
    "producer": "Kadri Veisner",
    "director": "Kadri Veisner",
    "peaosa": [
      {
        "actor": "Carine Jessica Kostla",
        "playing": "Saatejuht"
      }
    ]
  },
  {
    "id": 20787,
    "title": "Maskeraad",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20946/fb2c6001e057fe0bcaff858ffe3e3662b6453c0b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Draama",
    "producer": "Lennart Mathias Männik",
    "director": "Alexandra  Pärn",
    "peaosa": [
      {
        "actor": "Iris  Pähn",
        "playing": "Simone"
      }
    ]
  },
  {
    "id": 20788,
    "title": "Viimane piisk",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20947/58cc14062ec9392e365fd155fa690bc42e602acd.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Komöödiafilm",
    "producer": "Anet Õunpuu",
    "director": "Iris Peil",
    "peaosa": [
      {
        "actor": "Greta Liht",
        "playing": "Venus"
      },
      {
        "actor": "Franz  Malmsten jr",
        "playing": "Näituse korraldaja"
      },
      {
        "actor": "Elisabeth Madisson",
        "playing": "Grimeerija"
      }
    ]
  },
  {
    "id": 20789,
    "title": "Väärtus",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20948/87156692c192d587df7532980c64bf190edaec26.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Draama",
    "producer": "Margareth Villers",
    "director": "Franz  Malmsten jr",
    "peaosa": [
      {
        "actor": "Carmen Laurend",
        "playing": "Naine"
      },
      {
        "actor": "Timo Kiirend",
        "playing": "Mees"
      },
      {
        "actor": "Otto Tiidermann",
        "playing": "Dr. Sven Katik"
      }
    ]
  },
  {
    "id": 20790,
    "title": "Maalietüüd (2021)",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20949/a8b479bac041560b6e7037136264fa888c274278.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Komöödiafilm",
    "producer": "Anet Õunpuu, Carmen Laurend, Henry Laasalu, Lennart Mathias Männik, Margareth Villers, Triin Rennit",
    "director": "Franz  Malmsten jr, Greta Liht, Elis Rumma, Iris Peil, Katariina Škurinski, Alexandra  Pärn",
    "peaosa": [
      {
        "actor": "Leon Allik",
        "playing": "Aleksander"
      },
      {
        "actor": "Erko Sild",
        "playing": "Andrei"
      },
      {
        "actor": "Joosep Anton",
        "playing": "Nikolai"
      },
      {
        "actor": "Sander Koit",
        "playing": "Viktor"
      }
    ]
  },
  {
    "id": 20801,
    "title": "Põlev portselan",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20960/0eb055c24bc1a93447dbb62d2a4f369896661876.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Draama",
    "producer": "Margareth Villers",
    "director": "Greta Liht",
    "peaosa": [
      {
        "actor": "Luisa  Lõhmus",
        "playing": "Eleonor"
      }
    ]
  },
  {
    "id": 20806,
    "title": "MISSIOON",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/20965/a4235dafeb3f65c5494f2e8d8f254aa5424d7e5f.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Antero Noor",
    "director": "Teresa Juksaar",
    "peaosa": [
      {
        "actor": "Kert Pallo",
        "playing": "Toomas"
      },
      {
        "actor": "Anselm Püvi",
        "playing": "Peeter"
      },
      {
        "actor": "Maili Vaarpu",
        "playing": "Anu"
      },
      {
        "actor": "Joe  Joosep",
        "playing": "Autoomanik"
      }
    ]
  },
  {
    "id": 20857,
    "title": "Simman",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21016/9313fed78adc866a802bf589eb92f518d1106854.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Leo Vissak, Patrick Antonjuk",
    "director": "Leo Vissak",
    "peaosa": [
      {
        "actor": "Madis Martin Kasterpalu",
        "playing": "Meelis"
      },
      {
        "actor": "Kaimo Suits",
        "playing": "Isa"
      },
      {
        "actor": "Markus Habakukk",
        "playing": "Alo"
      }
    ]
  },
  {
    "id": 20860,
    "title": "Esimees",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21019/a7097bfea05fed26d037dc96ca458c3b59b022d0.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Katariina Rahumägi",
    "director": "Eik Erik Sikk",
    "peaosa": [
      {
        "actor": "Erik Richard Salumäe",
        "playing": "Esimees"
      },
      {
        "actor": "Hardi Möller",
        "playing": "Edgar"
      }
    ]
  },
  {
    "id": 20868,
    "title": "Üksildus",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21027/cf3c45ebdf627e9ce24edfe05c622c47d102631c.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Muusika/tantsu",
    "producer": "Aline Belfort",
    "director": "Samuel Koppel, Rafael Melo, Aline Belfort, Mazin Helal",
    "peaosa": [
      {
        "actor": "Samuel Koppel",
        "playing": "Noormees"
      }
    ]
  },
  {
    "id": 20881,
    "title": "Tagurpidikäik",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21040/51fbec3f0f4519e1641e30ae6593c0b434ec66f8.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Draama",
    "producer": "Carmen Laurend",
    "director": "Franz  Malmsten jr",
    "peaosa": [
      {
        "actor": "Kristjan Kasearu",
        "playing": "Juhan"
      },
      {
        "actor": "Meelis Rondo",
        "playing": "Jaan"
      },
      {
        "actor": "Rauni Saagim",
        "playing": "Veiko"
      }
    ]
  },
  {
    "id": 20882,
    "title": "TLÜ Kangelased",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21041/89766e55c01cbd8e806ec509963d63a674ad5743.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "",
    "producer": "Eva Kauponen",
    "director": "Janek Maantoa",
    "peaosa": [
      {
        "actor": "Erik Vent",
        "playing": "Ärimees"
      }
    ]
  },
  {
    "id": 20883,
    "title": "Murrang",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21042/8b2d551fc4735802dba23677a009776a47c52fc4.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Fantaasiafilm",
    "producer": "Triin Rennit",
    "director": "Iris Peil",
    "peaosa": [
      {
        "actor": "Anselm Oja",
        "playing": "Mees"
      }
    ]
  },
  {
    "id": 20884,
    "title": "(Ära) vaata",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21043/b475f51670941399126694a50ee382d382147c15.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Õudusfilm",
    "producer": "Sander Lebreht",
    "director": "Raoul  Kirsima",
    "peaosa": [
      {
        "actor": "Laine Mägi",
        "playing": "Lea"
      }
    ]
  },
  {
    "id": 20886,
    "title": "Hüvastijätt",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21045/0641918c818653beebd27e861806faf258a68773.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kristiana Kalnina",
    "director": "Mariann Jüriorg",
    "peaosa": [
      {
        "actor": "Maarja Johanna Mägi",
        "playing": "Mari"
      },
      {
        "actor": "Ülle Toming",
        "playing": "Silvia"
      }
    ]
  },
  {
    "id": 20890,
    "title": "Retrospect",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21049/0a14af265197876de6d6231b99be3160523a824c.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Põnevusfilm",
    "producer": "Sten Toom, Katariina Rahumägi",
    "director": "Katariina Rahumägi",
    "peaosa": [
      {
        "actor": "Egert Kadastu",
        "playing": "Aksel"
      },
      {
        "actor": "Elina Pähklimägi-Purde",
        "playing": "Marie"
      },
      {
        "actor": "Tanel Saar",
        "playing": "Kaarel"
      },
      {
        "actor": "Britta Vahur",
        "playing": "Psühiaater"
      }
    ]
  },
  {
    "id": 20894,
    "title": "Peegel peeglis",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21053/37b0af3fcc049aa13b45e0d5cc8ece9200de40f9.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Antero Noor",
    "director": "Silver Õun",
    "peaosa": [
      {
        "actor": "Joonas Mikk",
        "playing": "Poiss"
      },
      {
        "actor": "Gert Raudsep",
        "playing": "Jura"
      }
    ]
  },
  {
    "id": 20895,
    "title": "Tiiu ja draakon",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21054/d23737a186183ae11bdaa2560eda356d8f2ec475.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Merili  Laur",
    "director": "Teresa Juksaar",
    "peaosa": [
      {
        "actor": "Tiina Tõnis",
        "playing": "Tädi Tiiu"
      },
      {
        "actor": "Merle Talvik",
        "playing": "Marta"
      }
    ]
  },
  {
    "id": 20907,
    "title": "Jätkame rullimist",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21067/97d4860d0e312a1f5ee248eee643bb96ee836db4.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Draama",
    "producer": "Kristiana Kalnina",
    "director": "Rinalts Ignass, Oto Klavins",
    "peaosa": [
      {
        "actor": "Atis Alfrēds Brašmanis",
        "playing": "Alfreds"
      },
      {
        "actor": "Māris Kantoris",
        "playing": "Maris"
      },
      {
        "actor": "Ieva Kašs",
        "playing": "Karuna"
      },
      {
        "actor": "Jānis Jarāns",
        "playing": "Šerif Janis"
      }
    ]
  },
  {
    "id": 20908,
    "title": "Pädaste",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21068/518a92cfe410d874823e0292f4eb3c6494fabab2.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "PõnevusfilmŽanr: Draama",
    "producer": "Sten Toom, Ann Marii Moorus",
    "director": "Katariina Rahumägi",
    "peaosa": [
      {
        "actor": "Elli Hoyer",
        "playing": "Kitty"
      },
      {
        "actor": "Erki Laur",
        "playing": "Alexander von Buxhoeveden"
      }
    ]
  },
  {
    "id": 20912,
    "title": "Doominoefekt",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21073/72037bb93e2764aa9233bd66afdf62433fece514.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "Draama",
    "producer": "Anastasia Voznjuk, Olga Malkina",
    "director": "Olga Malkina, Anastasia Voznjuk",
    "peaosa": [
      {
        "actor": "Jüri Smirnov",
        "playing": "Korteri omanik"
      }
    ]
  },
  {
    "id": 20913,
    "title": "Kindlustusjuhtum parklas",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21074/3c6c427ecd7932074e16effe4069d3def03ee266.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "",
    "producer": "Reiko Kolatsk",
    "director": "Henrik Frederik Ait",
    "peaosa": [
      {
        "actor": "Katrin Tamm",
        "playing": "Ema"
      },
      {
        "actor": "Gregor Markus Tamm",
        "playing": "Poeg"
      }
    ]
  },
  {
    "id": 20914,
    "title": "Kahjujuhtum tuli sama ootamatult kui armastus",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21075/d34450065a8cdeee6ad78b5b2e59a2acb12d2f92.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "",
    "producer": "Claudia Robin Andros",
    "director": "Claudia Robin Andros",
    "peaosa": [
      {
        "actor": "Sten Erik Allikas",
        "playing": "Mees"
      },
      {
        "actor": "Julia Aret",
        "playing": "Naine"
      }
    ]
  },
  {
    "id": 20915,
    "title": "Läbi puugi silmade",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21076/c2c69e1eb8d36c0b0ea76f8676e6642c10e32244.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "",
    "producer": "Claudia Robin Andros",
    "director": "Claudia Robin Andros",
    "peaosa": [
      {
        "actor": "Jegori Sevastjanov",
        "playing": "Mees"
      },
      {
        "actor": "Birgit Arus",
        "playing": "Naine"
      }
    ]
  },
  {
    "id": 20916,
    "title": "Vecta Home Design",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21077/c004e6f4808b373e186c56e044a3040e296764ed.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "",
    "producer": "Philip Filimonau",
    "director": "Anna Kaisa  Jämsä",
    "peaosa": [
      {
        "actor": "Philip Filimonau",
        "playing": "Mees"
      },
      {
        "actor": "Sofiya Babiy",
        "playing": "Naine"
      }
    ]
  },
  {
    "id": 20917,
    "title": "Arst - Vectra Design",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21078/209f70a00e39da68407ddf44d8ae868ce94fb6a7.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "Komöödiafilm",
    "producer": "Katariina Rahumägi",
    "director": "Katariina Rahumägi",
    "peaosa": [
      {
        "actor": "Kristen Aigro",
        "playing": "Arst"
      }
    ]
  },
  {
    "id": 20919,
    "title": "Üle lävepaku",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21080/b067e65bc95ccdf49b70bcc38815c580ebbebd0d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Sofia Mihhaljova",
    "director": "Katariina Aule",
    "peaosa": [
      {
        "actor": "Elo Järv",
        "playing": "Kadi"
      },
      {
        "actor": "Hardo Adamson",
        "playing": "Simmo"
      }
    ]
  },
  {
    "id": 20920,
    "title": "Keegi peab surema",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21081/5694332165ee66ea2b6956b816a93ae92211369e.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Õudusfilm",
    "producer": "Johanna Alvin",
    "director": "Christina Kraft",
    "peaosa": [
      {
        "actor": "Merilyn Ploompuu",
        "playing": "Vivian"
      },
      {
        "actor": "Alice Anderssoo",
        "playing": "Emma"
      }
    ]
  },
  {
    "id": 20921,
    "title": "Pressure",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21082/061e7dc94064606a837bde97d915774ae2e76684.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Muusikavideo",
    "genre": "Draama",
    "producer": "Johanna Alvin",
    "director": "Christina Kraft",
    "peaosa": [
      {
        "actor": "Merilyn Ploompuu",
        "playing": "Naine"
      },
      {
        "actor": "Marc Adam Barsegjan",
        "playing": "Mees"
      }
    ]
  },
  {
    "id": 20926,
    "title": "Hääl maalilõuendil",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21087/e700d042f9aede3a04f8ea9f9d72db34f74598bc.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Fantaasiafilm",
    "producer": "Mariann Jüriorg",
    "director": "Sandija Miglava",
    "peaosa": [
      {
        "actor": "Ester Kuntu",
        "playing": "Amelia"
      },
      {
        "actor": "Izabel Altermann",
        "playing": "Liisi"
      },
      {
        "actor": "Andrus Vaarik",
        "playing": "Arst"
      }
    ]
  },
  {
    "id": 20928,
    "title": "Valge vale",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21089/7ec85278e63574890068aaa10b5a32cae786b092.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Eepiline/ajalooline filmŽanr: Draama",
    "producer": "Kati Vuks",
    "director": "Katariina Aule",
    "peaosa": [
      {
        "actor": "Maarja Johanna Mägi",
        "playing": "Marie"
      },
      {
        "actor": "Sander Roosimägi",
        "playing": "August"
      },
      {
        "actor": "Andres Mähar",
        "playing": "Raivo"
      }
    ]
  },
  {
    "id": 20929,
    "title": "Jäätisemees",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21090/f4c466d20d5e35a18aef6abbf426dae282c1f4c7.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Johanna Alvin",
    "director": "Sten Toom",
    "peaosa": [
      {
        "actor": "Aivar Luht",
        "playing": "Jäätisemees"
      },
      {
        "actor": "Elli Hoyer",
        "playing": "Noor Laura"
      },
      {
        "actor": "Maarja Korstnik",
        "playing": "Ema"
      },
      {
        "actor": "Kristo Kambek",
        "playing": "Isa"
      },
      {
        "actor": "Jane Napp",
        "playing": "Laura"
      },
      {
        "actor": "Karel Airapetjan",
        "playing": "Steven"
      },
      {
        "actor": "Henri Lind",
        "playing": "Karl"
      },
      {
        "actor": "Kadri Lukk",
        "playing": "Matilda"
      }
    ]
  },
  {
    "id": 20934,
    "title": "Võlts",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21095/e3fa261d2e593d159ec9c1d28e213bab38d3eafd.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Draama",
    "producer": "Anet Õunpuu",
    "director": "Elis Rumma",
    "peaosa": [
      {
        "actor": "Mauri Liiv",
        "playing": "Ruben"
      },
      {
        "actor": "Aia Kokk",
        "playing": "Ema"
      }
    ]
  },
  {
    "id": 20939,
    "title": "Tõus",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21100/7a91766e34eb8c771ae24300557d097f3124b7b6.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Noortefilm",
    "producer": "Jonathan Peterson",
    "director": "Alesja Suzdaltseva",
    "peaosa": [
      {
        "actor": "Leene Vugts",
        "playing": "Lilit"
      }
    ]
  },
  {
    "id": 20943,
    "title": "Eik - TEAD (Muusikavideo)",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21104/2c07c76b090a186168b994631817c1a789a6654b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Muusikavideo",
    "genre": "",
    "producer": "Sten Toom",
    "director": "Eik Erik Sikk",
    "peaosa": [
      {
        "actor": "Hardi Möller",
        "playing": "Mees"
      }
    ]
  },
  {
    "id": 20945,
    "title": "Suu probleemid",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21106/9902868be2833765cbdc2fb711391e654df1a2d0.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Baran Ismail Ulas, Valeria Perez",
    "director": "Olli Niemi",
    "peaosa": [
      {
        "actor": "Johan Elm",
        "playing": "Hans"
      },
      {
        "actor": "Margus Kobing",
        "playing": "Pekka"
      },
      {
        "actor": "Madis Kareda",
        "playing": "Vennad"
      },
      {
        "actor": "Laura Kukk",
        "playing": "Eliise"
      }
    ]
  },
  {
    "id": 20950,
    "title": "Võõrad",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21111/3aabcbb396a099c52ec607b4da5c268482da1298.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Nevena Semova",
    "director": "Lauri Elstelä",
    "peaosa": [
      {
        "actor": "Anne Veesaar",
        "playing": "Veera"
      },
      {
        "actor": "Linda Vaher",
        "playing": "Marianne"
      },
      {
        "actor": "Simeoni Sundja",
        "playing": "Jaan"
      }
    ]
  },
  {
    "id": 20956,
    "title": "Kahe poole vahel",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21117/a10f197738c3822c9f01d1dedec920dabb9bee8a.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Sõjafilm",
    "producer": "Sofia Mihhaljova",
    "director": "Oliver Remma, Teresa Juksaar",
    "peaosa": [
      {
        "actor": "Rainer Elhi",
        "playing": "Meedik saar"
      }
    ]
  },
  {
    "id": 20962,
    "title": "Ime purki püüdmine",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21123/3ae723af387deeedcc817070e8466c2f27798406.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Dokumentaalfilm",
    "genre": "",
    "producer": "Liis Slugen, Betra Käsper",
    "director": "Erik Kiviselg",
    "peaosa": [
      {
        "actor": "Andrus Eelmäe",
        "playing": "Vanamees"
      }
    ]
  },
  {
    "id": 20963,
    "title": "Lapsemäng",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21124/912ef95ebc49a500af21911d0a31fad95d3db8b8.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Sander Lebreht",
    "director": "Silver Õun",
    "peaosa": [
      {
        "actor": "Ott Kartau",
        "playing": "Robert"
      },
      {
        "actor": "Kalju-Karl Kivi",
        "playing": "Mart"
      },
      {
        "actor": "Maiken Pius",
        "playing": "Liina"
      },
      {
        "actor": "Saara Pius",
        "playing": "Eve"
      },
      {
        "actor": "Karli Peever",
        "playing": "Martin"
      },
      {
        "actor": "Joonas Mikk",
        "playing": "Joonas"
      }
    ]
  },
  {
    "id": 20964,
    "title": "Hommikul",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21125/5815cd5e74052da1da39ae43ffd12ca83cea7e0d.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Sten Toom",
    "director": "Eik Erik Sikk",
    "peaosa": [
      {
        "actor": "Ott Aardam",
        "playing": "Juhan"
      }
    ]
  },
  {
    "id": 20965,
    "title": "Punane muinasjutt",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21126/f89c905e3859853f02fc0569be08aafd57bc5b9a.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Ann Miller",
    "director": "Frederiks Sebastians",
    "peaosa": [
      {
        "actor": "Laura Elcere",
        "playing": "Laura"
      },
      {
        "actor": "Rūdolfs Cīrulis",
        "playing": "Arhitekt"
      },
      {
        "actor": "Linards Počs",
        "playing": "Konstantin"
      },
      {
        "actor": "Kaspars Arājs",
        "playing": "Arcadius"
      }
    ]
  },
  {
    "id": 20966,
    "title": "Prelüüd tühjusele",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21127/c8ba6cd8d90d2aa514d522e9b1877a842718c5c1.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Maiken Palm",
    "director": "Vivian Ruumet",
    "peaosa": [
      {
        "actor": "Mait Joorits",
        "playing": "Rain"
      },
      {
        "actor": "Laura Kukk",
        "playing": "Deelia"
      },
      {
        "actor": "Johan Elm",
        "playing": "Adrian"
      }
    ]
  },
  {
    "id": 20968,
    "title": "Topelt Turbo",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21129/e9e8bea2efe724d45ae1b688d43e9bafea5384d8.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Seiklusfilm",
    "producer": "Henry Laasalu, Lennart Mathias Männik",
    "director": "Romet Esko, Raul Esko",
    "peaosa": [
      {
        "actor": "Maria Kriisa",
        "playing": "Nana"
      },
      {
        "actor": "Mari-Liis Kriisa",
        "playing": "Lulu"
      },
      {
        "actor": "Mirtel Pohla",
        "playing": "Nana ja Lulu hääl"
      },
      {
        "actor": "Erki Laur",
        "playing": "Race King"
      }
    ]
  },
  {
    "id": 20969,
    "title": "Tehnik",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21130/83bf33e6a6c548cc55d92b86f81fee9c5fb1570b.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Telesaade",
    "genre": "Komöödiafilm",
    "producer": "Mihkel Matkevicius",
    "director": "Karl Koppelmaa",
    "peaosa": [
      {
        "actor": "Kristo Viiding",
        "playing": "Tõnu"
      }
    ]
  },
  {
    "id": 20970,
    "title": "Buss",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21131/8d9595f47bc88a810defd28e345d9055fe6d89e5.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Telesaade",
    "genre": "Komöödiafilm",
    "producer": "Mihkel Matkevicius",
    "director": "Rasmus Rammo, Kristi Tirmaste",
    "peaosa": [
      {
        "actor": "Jaune Kimmel",
        "playing": "Leena"
      },
      {
        "actor": "Katrin Karisma",
        "playing": "Helju"
      },
      {
        "actor": "Jürgen Gansen",
        "playing": "Villem Viiroja"
      },
      {
        "actor": "Nils Mattias Steinberg",
        "playing": "Oss"
      },
      {
        "actor": "Märten Männiste",
        "playing": "Paul"
      }
    ]
  },
  {
    "id": 20972,
    "title": "Strawberry Shake",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21133/2e9087fd5bd0eca689716c63cbfe176a06e4cea1.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Põnevusfilm",
    "producer": "Andjela Lazic",
    "director": "Lou-Andrea Fiere",
    "peaosa": [
      {
        "actor": "Ursel Tilk",
        "playing": "Röövel"
      },
      {
        "actor": "Külli Teetamm",
        "playing": "Naine"
      },
      {
        "actor": "Villem Eplik",
        "playing": "Kassapidaja"
      }
    ]
  },
  {
    "id": 20975,
    "title": "Rentsli krahvid",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21136/d7729773ca77779cedbe6d7daeaa3b432d1074ae.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Muusika/tantsu",
    "producer": "Merili  Laur",
    "director": "Raoul  Kirsima",
    "peaosa": [
      {
        "actor": "Markus Truup",
        "playing": "Tang"
      },
      {
        "actor": "Kaili Närep",
        "playing": "Hilse"
      },
      {
        "actor": "Jaune Kimmel",
        "playing": "Kadi"
      },
      {
        "actor": "Raul  Talmar",
        "playing": "Toivo"
      }
    ]
  },
  {
    "id": 20985,
    "title": "Ära tee välja",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21146/4c81afeb171909c64b04994aaeb28fd52785d8b9.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Christina Kraft",
    "director": "Kristen Aigro",
    "peaosa": [
      {
        "actor": "Märten Matsu",
        "playing": "Evert"
      },
      {
        "actor": "Rein Annuk",
        "playing": "Poliitik"
      }
    ]
  },
  {
    "id": 20987,
    "title": "Lenda, lenda, lenda",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21148/f064f1bd4e1b90993e57f10454cde2f3f9aad175.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Muusikavideo",
    "genre": "",
    "producer": "Emily Bruus",
    "director": "Kristen Aigro",
    "peaosa": [
      {
        "actor": "Ken Rüütel",
        "playing": "Mees"
      }
    ]
  },
  {
    "id": 20994,
    "title": "Reklaam Vecta Designile",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21155/742bdf14a39613f71250e9d27eff2ec9a8e01a75.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "",
    "producer": "Kristofer Ild",
    "director": "Merilin Lutsar",
    "peaosa": [
      {
        "actor": "Karel Airapetjan",
        "playing": "Noormees"
      }
    ]
  },
  {
    "id": 20995,
    "title": "Suvine meeleolu",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21156/d0915a4de09ace66d2d1f5326da4e15a7e6ebfcf.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "",
    "producer": "Sofia Kusainova, Ekaterina Moiseeva",
    "director": "Stefania  Makarenko, Sedef Dündar",
    "peaosa": [
      {
        "actor": "Roman Maksimuk",
        "playing": "Mees"
      },
      {
        "actor": "Sedef Dündar",
        "playing": "Naine"
      },
      {
        "actor": "Nuran Niftalijev",
        "playing": "Poiss"
      }
    ]
  },
  {
    "id": 20998,
    "title": "Vaikne maa",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21159/33534c5e68713838e3ed4ce2cd65a7224eaf2f81.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Ulmefilm",
    "producer": "Kailiin  Dubrov",
    "director": "Martin Riispere",
    "peaosa": [
      {
        "actor": "Mihkel Kuusk",
        "playing": "Poeg"
      },
      {
        "actor": "Marje Kärner",
        "playing": "Ema"
      }
    ]
  },
  {
    "id": 21002,
    "title": "Nälg",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21163/ed8a7ba7e9b81f0d27333667690e9101b96a854b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Antero Noor",
    "director": "Katariina Aule",
    "peaosa": [
      {
        "actor": "Miika Pihlak",
        "playing": "Jass"
      }
    ]
  },
  {
    "id": 21011,
    "title": "Õhtuline",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21172/ffb7093f37138c7b3f2541004adc21127eb3a128.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Põnevusfilm",
    "producer": "Margareth Villers",
    "director": "Iris Peil",
    "peaosa": [
      {
        "actor": "Hanna Brigita Jaanovits",
        "playing": "Mirjam"
      },
      {
        "actor": "Karl Birnbaum",
        "playing": "Lauri Leek"
      }
    ]
  },
  {
    "id": 21012,
    "title": "AVM Koopainimesed",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21173/6b7a20b803d2d95f7d4ebaf48cc7d99479a8c022.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "Komöödiafilm",
    "producer": "Konstantin Sosunov",
    "director": "Max Mikkilä",
    "peaosa": [
      {
        "actor": "Vladimir  Mišenkin",
        "playing": "Monkey 1"
      },
      {
        "actor": "Konstantin Sosunov",
        "playing": "Monkey 2"
      }
    ]
  },
  {
    "id": 21013,
    "title": "Ristmeedia kultus",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21174/87c4a73767129e72e4408265cfa659ac56180bf4.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "Komöödiafilm",
    "producer": "Konstantin Sosunov",
    "director": "Max Mikkilä",
    "peaosa": [
      {
        "actor": "Sarvin Sefatyar",
        "playing": "Noor kultusejuht"
      },
      {
        "actor": "Konstantin Sosunov",
        "playing": "Kultusejünger 1"
      },
      {
        "actor": "Venla Rummukainen",
        "playing": "Kultusejünger 2"
      }
    ]
  },
  {
    "id": 21014,
    "title": "Ürgne IKUMUMU",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21175/96e82f39ac552707f73deb0588345c80bd1824e2.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Reklaam/Promofilm",
    "genre": "Komöödiafilm",
    "producer": "Konstantin Sosunov",
    "director": "Max Mikkilä",
    "peaosa": [
      {
        "actor": "Grete Teearu",
        "playing": "IKUMUMU sisalik"
      }
    ]
  },
  {
    "id": 21017,
    "title": "Kehad ja majad",
    "year": "2020",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21178/2988f7d9b149f1313e498e2aa05f7009ecb8042e.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Animafilm",
    "genre": "Fantaasiafilm",
    "producer": "",
    "director": "Ebe-Liis Kopp, Anna Kuriljonok",
    "peaosa": [
      {
        "actor": "Anna Kuriljonok",
        "playing": "Modell"
      },
      {
        "actor": "Jane Tagu",
        "playing": "Modell"
      }
    ]
  },
  {
    "id": 21018,
    "title": "SHIRA-Out in Space",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21179/e472d688e5f6392a5198c46f5781ad2f56c89698.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Muusikavideo",
    "genre": "",
    "producer": "Moona-Liisa Mänd",
    "director": "Annaliise Kalamees",
    "peaosa": [
      {
        "actor": "Marika Rodionova",
        "playing": "Laulja"
      }
    ]
  },
  {
    "id": 21022,
    "title": "Kuni elu meid lahutab",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21183/50cf3869214cd72982380a3b8cd15432f9ea9c9f.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Darta Iršeina",
    "director": "Alise Linde",
    "peaosa": [
      {
        "actor": "Dzimstna Berziņa",
        "playing": "Pruut"
      },
      {
        "actor": "Marcis Veveris",
        "playing": "Mees"
      }
    ]
  },
  {
    "id": 21023,
    "title": "Viis Minutit",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21184/d12429b393a4e5340b27b7ddb63cd046e8216144.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Anet Õunpuu",
    "director": "Alexandra  Pärn",
    "peaosa": [
      {
        "actor": "Lauren Grinberg",
        "playing": "Aet"
      },
      {
        "actor": "Hele-Riin Palumaa",
        "playing": "Gerda"
      },
      {
        "actor": "Markus Andreas Auling",
        "playing": "Kristjan"
      }
    ]
  },
  {
    "id": 21039,
    "title": "Sume mälestus",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21200/8bcd0adadbe1232325a50e131a3427efc17dbc2f.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Kati Vuks",
    "director": "Teresa Juksaar",
    "peaosa": [
      {
        "actor": "Kristiin Räägel",
        "playing": "Suur Pääsu"
      },
      {
        "actor": "Simo Andre Kadastu",
        "playing": "Suur Atko"
      },
      {
        "actor": "Karmel Naudre",
        "playing": "Suur Virge"
      },
      {
        "actor": "Marta Andreas",
        "playing": "Väike Pääsu"
      },
      {
        "actor": "Mikk Arvisto",
        "playing": "Väike Atko"
      },
      {
        "actor": "Loore Kuusmann",
        "playing": "Väike Virge"
      }
    ]
  },
  {
    "id": 21055,
    "title": "Öölind",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21217/7c94b909b6480629650db6890a01d0cb956d6905.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Sofia Mihhaljova, Inger Põder",
    "director": "Dora Lall",
    "peaosa": [
      {
        "actor": "Linda Kolde",
        "playing": "Simona"
      },
      {
        "actor": "Imre Õunapuu",
        "playing": "Tomas"
      },
      {
        "actor": "Rainer Elhi",
        "playing": "Jakob"
      }
    ]
  },
  {
    "id": 21056,
    "title": "Korter",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21218/6eec5ad72df3efe214fe421ee2ddb7664eb43353.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Draama",
    "producer": "Lennart Mathias Männik",
    "director": "Katariina Škurinski",
    "peaosa": [
      {
        "actor": "Tiit Alte",
        "playing": "Vanamees"
      }
    ]
  },
  {
    "id": 21065,
    "title": "Nostos Algos",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21227/659130a1ffd4306fe355ddf7f601548a12225ee8.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Harjutusfilm (lavastuslik)",
    "genre": "Draama",
    "producer": "Carmen Laurend",
    "director": "Greta Liht",
    "peaosa": [
      {
        "actor": "Alice Siil",
        "playing": "Luna"
      }
    ]
  },
  {
    "id": 21071,
    "title": "Keemialabor",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21233/7600277d74eb5ebaca248911fef6c847afdfb723.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Muusikavideo",
    "genre": "",
    "producer": "Kaisa Tamme",
    "director": "Renelle Karnaskind",
    "peaosa": [
      {
        "actor": "Rovin Raie",
        "playing": "Rovin Hood"
      },
      {
        "actor": "Tanel Vaikjärv",
        "playing": "Bljätmän"
      },
      {
        "actor": "Taavi Raudkivi",
        "playing": "Onu Heino"
      }
    ]
  },
  {
    "id": 21096,
    "title": "Soovid kaevu põhjast",
    "year": "2023",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21258/7c8a3faee44fcdb372b29f5282dba704f7c448a6.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Anet Õunpuu",
    "director": "Alesja Suzdaltseva",
    "peaosa": [
      {
        "actor": "Meelis Rämmeld",
        "playing": "Vetevana Kalle"
      },
      {
        "actor": "Kris Kaspar Alamaa",
        "playing": "Harri"
      },
      {
        "actor": "Tiina Tauraite",
        "playing": "Apteeker Johanna"
      }
    ]
  },
  {
    "id": 21103,
    "title": "Mõrad",
    "year": "2023",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21265/1807bacb6a8c41a688e394ffd2dde1926f7d983a.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Õudusfilm",
    "producer": "Robin Marten Leppik",
    "director": "Anna  Veisman",
    "peaosa": [
      {
        "actor": "Anna Birgitta Põder",
        "playing": "Loreen"
      },
      {
        "actor": "Katertina Malasevits",
        "playing": "Koopia"
      }
    ]
  },
  {
    "id": 21109,
    "title": "Nälg",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21271/61d1c751b840fd064462dde0ad078e40e60bf356.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Muusika/tantsu",
    "producer": "Nevena Semova, Andjela Lazic",
    "director": "Lou-Andrea Fiere",
    "peaosa": [
      {
        "actor": "Allar Valge",
        "playing": "Tantsija"
      }
    ]
  },
  {
    "id": 21122,
    "title": "Tuleriit, kus ta põles",
    "year": "2019",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21284/280f73c6aaeec9e2416a37196757c05fc0ea8e16.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Sandija Miglava, Lasma Žagota",
    "director": "Sandija Miglava",
    "peaosa": [
      {
        "actor": "Elvita Ragovska",
        "playing": "Marta"
      },
      {
        "actor": "Emils Ralfs Zagorskis",
        "playing": "Toms"
      },
      {
        "actor": "Gerda Embure",
        "playing": "Brigita"
      },
      {
        "actor": "Elizabete Marija Brente",
        "playing": "Made"
      },
      {
        "actor": "Davids Petersons",
        "playing": "Alekss"
      }
    ]
  },
  {
    "id": 21124,
    "title": "Meie kaks",
    "year": "2023",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21286/170c9ead5f21368e958e90e2515dcb5fa665ef02.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Põnevusfilm",
    "producer": "Hans Kristjan Linnutaja",
    "director": "Karoliine  Rämmi",
    "peaosa": [
      {
        "actor": "Kaarel Targo",
        "playing": "Mark"
      },
      {
        "actor": "Mariann Tammaru",
        "playing": "Emilia"
      },
      {
        "actor": "Sarah-Elisabeth Haidak",
        "playing": "Jane"
      }
    ]
  },
  {
    "id": 21130,
    "title": "Kahekaupa",
    "year": "2023",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21292/3b93a86279857a8e8220da3809b978038f74f165.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Ina Gagola",
    "director": "Chris Todorovic",
    "peaosa": [
      {
        "actor": "Lara Zelenova",
        "playing": "Eden"
      },
      {
        "actor": "Jaan Tristan Kolberg",
        "playing": "Leo"
      }
    ]
  },
  {
    "id": 21133,
    "title": "Palve",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21295/459baafbb7cc9061bee268b964573a3bbabc15e6.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Lennart Mathias Männik",
    "director": "Elis Rumma",
    "peaosa": [
      {
        "actor": "Elar Vahter",
        "playing": "Jakob"
      },
      {
        "actor": "Marika Otsa",
        "playing": "Naine"
      },
      {
        "actor": "Tõnu Oja",
        "playing": "Isa"
      }
    ]
  },
  {
    "id": 21141,
    "title": "Kolhoosi miss",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21303/7731152ee731bf4be56d6cd09bf898088c830a84.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Margareth Villers",
    "director": "Alexandra  Pärn",
    "peaosa": [
      {
        "actor": "Enid Leetjõe",
        "playing": "Liidia"
      },
      {
        "actor": "Säde Sibul",
        "playing": "Miina"
      }
    ]
  },
  {
    "id": 21142,
    "title": "Crispy Fries",
    "year": "2023",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21304/fda42d570c3dab37f5a4525885cbcb619e2d67ed.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Pablo Thiermann",
    "director": "Lucia Deuerling",
    "peaosa": [
      {
        "actor": "Mihkel Kuusk",
        "playing": "David"
      },
      {
        "actor": "Külli Kaljulind",
        "playing": "Gerda"
      }
    ]
  },
  {
    "id": 21147,
    "title": "ASPHYXIA",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21309/70b326e5021876c67dc1664b525248175db546d7.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Jaakko Tervonen",
    "director": "Sergei Batrak",
    "peaosa": [
      {
        "actor": "Stanislav Kolodub",
        "playing": "Ivan"
      }
    ]
  },
  {
    "id": 21148,
    "title": "Müüdud hing",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21310/b297e3f21c246982ef1b27bde1adb4d142303496.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "KomöödiafilmŽanr: Draama",
    "producer": "Desiree Talv",
    "director": "Betra Käsper",
    "peaosa": [
      {
        "actor": "Terje Pennie",
        "playing": "Milvi"
      },
      {
        "actor": "Rauno Põld",
        "playing": "Paul"
      },
      {
        "actor": "Lauli Koppelmaa",
        "playing": "Lenna"
      }
    ]
  },
  {
    "id": 21151,
    "title": "Mitte näkku ja mitte väga valusalt",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21313/fd1c0577ea6bf80160f23da856baf8068eb8bddb.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "DraamaŽanr: Fantaasiafilm",
    "producer": "Carmen Laurend",
    "director": "Iris Peil",
    "peaosa": [
      {
        "actor": "Jarmo Reha",
        "playing": "Slava"
      },
      {
        "actor": "Fatme Helge Leevald",
        "playing": "Veronica"
      }
    ]
  },
  {
    "id": 21153,
    "title": "Vastamata kõne",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21315/2808e9d8c3be6df02c3334edbd340433447f792b.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Ann Marii Moorus",
    "director": "Jennifer Marisse Cohen",
    "peaosa": [
      {
        "actor": "Theodor Tabor",
        "playing": "Kusti"
      },
      {
        "actor": "Liisbeth Kala",
        "playing": "Niina"
      }
    ]
  },
  {
    "id": 21155,
    "title": "Ilus Armin",
    "year": "2023",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21317/69fa191a997ba4a912fa0543538410c7b9517c53.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Muinasjuttfilm",
    "producer": "Anet Õunpuu",
    "director": "Katariina Škurinski",
    "peaosa": [
      {
        "actor": "Tristan Czar Aasmäe",
        "playing": "Ilus Armin"
      },
      {
        "actor": "Maili Metssalu",
        "playing": "Maret"
      },
      {
        "actor": "Margo Mitt",
        "playing": "Isa"
      }
    ]
  },
  {
    "id": 21156,
    "title": "NooR JumaL - glenwashere",
    "year": "2023",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21318/e67a316ce93964e6c1ebcc71570606500e91bdfc.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Muusikavideo",
    "genre": "",
    "producer": "Kirke Antsmäe, Gete Tiirats",
    "director": "Paul Henrich Daude, Kätleen Noormägi",
    "peaosa": [
      {
        "actor": "Glen-Ander Popovitch",
        "playing": "Artist"
      }
    ]
  },
  {
    "id": 21160,
    "title": "Silmitsi",
    "year": "2022",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21322/502042f723d2c35cd1022eeeb16197e5de0b053f.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Triin Rennit",
    "director": "Greta Liht",
    "peaosa": [
      {
        "actor": "Jaanika Arum",
        "playing": "Mia"
      },
      {
        "actor": "Risto Vaidla",
        "playing": "Taavi"
      }
    ]
  },
  {
    "id": 21167,
    "title": "Oli kuningas",
    "year": "2021",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21329/286685f274919ec6f1956d0723aea9c150955aa6.png",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Draama",
    "producer": "Marien Vaga",
    "director": "Ester Stancel",
    "peaosa": [
      {
        "actor": "Jüri Štšetinin",
        "playing": "Mihkel"
      },
      {
        "actor": "Remy Sõber",
        "playing": "Gabriel"
      },
      {
        "actor": "Martin Tikk",
        "playing": "Raphael"
      },
      {
        "actor": "Margus Kobin",
        "playing": "Isa"
      }
    ]
  },
  {
    "id": 21438,
    "title": "Kodu",
    "year": "2024",
    "image": "https://is.efis.ee/UserFiles/EfisFilms/Thumbnails/21603/89d2d4fb0f6001d3305ddb678a1d2a03ebd5015d.jpg",
    "language": "Estonian",
    "type": "Tudengifilmid",
    "subtype": "Lühimängufilm",
    "genre": "Komöödiafilm",
    "producer": "Karmen Mai Karus, Joonatan Pärn",
    "director": "Rasmus Rammo",
    "peaosa": [
      {
        "actor": "Merle Jääger",
        "playing": "Maali"
      },
      {
        "actor": "Karmen Mai Karus",
        "playing": "Lydia"
      },
      {
        "actor": "Dan Jeršov",
        "playing": "Volodõmõr"
      },
      {
        "actor": "Roman Maksimuk",
        "playing": "Alex"
      },
      {
        "actor": "Veljo Reinik",
        "playing": "Otto von Richten"
      }
    ]
  }
]